const testQueries = [
  {
    "Query": "G2m to do list from Simon",
    "Entity": "List",
    "Sub-type": "",
    "Date and time": "Mar 19, 2021, 12:10 AM",
    "Subject": "Final Decision: G2M 3.0",
    "IDs": "<CALV-+1dYNbmBQnMQDGQsCvAa9N=Kh_VepWQ306Lo=hh-Gzc8ew@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify offer",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Mar 17, 2021, 12:16 PM",
    "Subject": "RE: AW: Contact Form [ ref:_00DG0Cbyq._5001M1fs6ZJ:ref ]",
    "IDs": "<CAC=hQbm4_+g9gkqXnKZP174ihm2-vR6G+3gCxQxD9H-6HJ3_Dw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Offer to EUTEC",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Mar 17, 2021, 12:16 PM",
    "Subject": "RE: AW: Contact Form [ ref:_00DG0Cbyq._5001M1fs6ZJ:ref ]",
    "IDs": "<CAC=hQbm4_+g9gkqXnKZP174ihm2-vR6G+3gCxQxD9H-6HJ3_Dw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Updated offer from Personify",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Wed, Mar 17, 1:37 PM",
    "Subject": "RE: AW: Contact Form [ ref:_00DG0Cbyq._5001M1fs6ZJ:ref ]",
    "IDs": "<CAC=hQbnA84Ny5HyMcSd=osBO9k2LYgL6L6T+AjK7NJOoNX6hXQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Updated eutec offer",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Wed, Mar 17, 1:37 PM",
    "Subject": "RE: AW: Contact Form [ ref:_00DG0Cbyq._5001M1fs6ZJ:ref ]",
    "IDs": "<CAC=hQbnA84Ny5HyMcSd=osBO9k2LYgL6L6T+AjK7NJOoNX6hXQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "eutec address",
    "Entity": "Location",
    "Sub-type": "",
    "Date and time": "Wed, Mar 17, 2:09 PM",
    "Subject": "RE: AW: Contact Form [ ref:_00DG0Cbyq._5001M1fs6ZJ:ref ]",
    "IDs": "<9D86ECC7-D10C-41A7-9F69-0524757F6981@eutec.org>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify PayPal link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, Mar 17, 6:23 PM",
    "Subject": "RE: AW: Contact Form [ ref:_00DG0Cbyq._5001M1fs6ZJ:ref ]",
    "IDs": "<1704BF39-A817-4A78-9A3C-C7D8C23737B7@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Korean customer from Philip",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Thu, Mar 18, 9:30 PM",
    "Subject": "Payment check",
    "IDs": "<007701d71c67$c6c5a5d0$5450f170$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "March PO from Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Mar 18, 7:55 PM",
    "Subject": "PO from Japan",
    "IDs": "<005601d71c5a$936e4230$ba4ac690$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Ai crib from surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Mar 17, 10:49 PM",
    "Subject": "your thoughts",
    "IDs": "<CAKVuy5FjE8WJW=Df+OEMSWXrAgJkdzmaBObKnX2WPzCt3jDJXA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "AI crib sent to Byron",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Mar 17, 10:49 PM",
    "Subject": "your thoughts",
    "IDs": "<CAKVuy5FjE8WJW=Df+OEMSWXrAgJkdzmaBObKnX2WPzCt3jDJXA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "MacBook suggestions",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "Tue, Mar 16, 5:43 AM",
    "Subject": "Request Device",
    "IDs": "<CAKng2fHB9iTdgWz4NXJm149ZgPe_V9=v6JzcJ3P=oG+61crxMQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Pricing",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Mar 17, 2021, 3:41 PM",
    "Subject": "RE: contract call [ ref:_00DG0Cbyq._5001M1f1JVH:ref ]",
    "IDs": "<5bxt_000000000000000000000000000000000000000000000QQ4S5G00VuZmhGORQ7OGAEzkW3PzzA@sfdc.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "MHM invoice from Khoa",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, March 16, 2021, 3:58 PM",
    "Subject": "SOC2 Invoice",
    "IDs": "<7D1C1D15-974E-45D5-B1C2-126401FC35B7@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "MHM payment details from Khoa",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, March 16, 2021, 3:58 PM",
    "Subject": "SOC2 Invoice",
    "IDs": "<7D1C1D15-974E-45D5-B1C2-126401FC35B7@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "mhm contract from Khoa",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, March 16, 2021, 3:58 PM",
    "Subject": "SOC2 Invoice",
    "IDs": "<7D1C1D15-974E-45D5-B1C2-126401FC35B7@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Support link from Loron",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Tue, Mar 16, 2021, 2:57 PM",
    "Subject": "RE: INF5601W panels - Mac Driver",
    "IDs": "<MWHPR08MB34052B9EE523426C3F7456169E6B9@MWHPR08MB3405.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Goshen it director",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Thu, Mar 11, 2021 6:43 AM",
    "Subject": "Re: Looking at panels",
    "IDs": "<MWHPR08MB34052B9EE523426C3F7456169E6B9@MWHPR08MB3405.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Rick Davis email from Tod",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Wed, Mar 10, 2021, 6:23 PM",
    "Subject": "Looking at panels",
    "IDs": "<MWHPR08MB34052B9EE523426C3F7456169E6B9@MWHPR08MB3405.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Rick Davis' number from Tod",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Wed, Mar 10, 2021, 6:23 PM",
    "Subject": "Looking at panels",
    "IDs": "<MWHPR08MB34052B9EE523426C3F7456169E6B9@MWHPR08MB3405.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "SOC2 client profile from Khoa",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Mon, Mar 15, 8:35 PM",
    "Subject": "SOC 2 Auditing service from MHM Corporation",
    "IDs": "<F23EBD77-1F66-491A-A742-D0F1F9A807A8@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "SOC2 contract draft from Khoa",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Mon, Mar 15, 8:35 PM",
    "Subject": "SOC 2 Auditing service from MHM Corporation",
    "IDs": "<F23EBD77-1F66-491A-A742-D0F1F9A807A8@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Updated soc2 from dustin",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Tue, Mar 16, 2:02 PM",
    "Subject": "SOC 2 Auditing service from MHM Corporation",
    "IDs": "<MWHPR0801MB37225F585BA7247E373C53E2876B9@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "SSA by Snowflake",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Mon, Feb 1, 2021 at 10:38 PM",
    "Subject": "Re: Vendor Security Assessment For Personify Presenter [Urgent Feedback Required] [ ref:_00DG0Cbyq._5001M1eydje:ref ]",
    "IDs": "<CAC=hQbn9Pkq9Tz30qD8m833qgip4rZuWDoLCe8sq2v-atx=P5A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "ssa sent to personify",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Mon, Feb 1, 2021 at 10:38 PM",
    "Subject": "Re: Vendor Security Assessment For Personify Presenter [Urgent Feedback Required] [ ref:_00DG0Cbyq._5001M1eydje:ref ]",
    "IDs": "<CAC=hQbn9Pkq9Tz30qD8m833qgip4rZuWDoLCe8sq2v-atx=P5A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "List of CC services",
    "Entity": "List",
    "Sub-type": "",
    "Date and time": "Fri, Mar 12, 1:52 PM",
    "Subject": "List all CC Services",
    "IDs": "<CALV-+1ezFSvPq484zWEzscPBJBCx3qx_SrEJR_6g7uUVd+fZ9A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Website design review from Shauli",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Mar 10, 10:07 AM",
    "Subject": "Website design review",
    "IDs": "<CAAmcMVQ8qp5ABr4nLwC7TeP8F0uDTA9KYt=k2BBQ1=6+rCnecQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Recap of social accounts from Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Mar 1, 6:57 PM",
    "Subject": "Accounts and previous marketing",
    "IDs": "<CAKVuy5G6KGLbwYZUeQEf1hWwgMPoL8=L6a2ucORzRk7FjTGbEg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Social accounts recap to Shauli",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Mar 1, 6:57 PM",
    "Subject": "Accounts and previous marketing",
    "IDs": "<CAKVuy5G6KGLbwYZUeQEf1hWwgMPoL8=L6a2ucORzRk7FjTGbEg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Marcom from Surendra",
    "Entity": "Link",
    "Sub-type": "OneDrive",
    "Date and time": "Mon, Mar 1, 6:57 PM",
    "Subject": "Accounts and previous marketing",
    "IDs": "<CAKVuy5G6KGLbwYZUeQEf1hWwgMPoL8=L6a2ucORzRk7FjTGbEg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Marcom to Shauli",
    "Entity": "Link",
    "Sub-type": "OneDrive",
    "Date and time": "Mon, Mar 1, 6:57 PM",
    "Subject": "Accounts and previous marketing",
    "IDs": "<CAKVuy5G6KGLbwYZUeQEf1hWwgMPoL8=L6a2ucORzRk7FjTGbEg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "New website link from Simon",
    "Entity": "Link",
    "Sub-type": "Figma",
    "Date and time": "Tue, Mar 2, 12:11 AM",
    "Subject": "Accounts and previous marketing",
    "IDs": "<CALV-+1e1ntwOCFt4muP=j=JP6S4QUh5mw=4TSQAG4W=WsmeUww@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Marketing matrix from Philip",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Mar 11, 2021, 8:49 PM",
    "Subject": "Accounts and previous marketing",
    "IDs": "<00d201d716ea$5c364da0$14a2e8e0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Marketing matrix to Shauli",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Mar 11, 2021, 8:49 PM",
    "Subject": "Accounts and previous marketing",
    "IDs": "<00d201d716ea$5c364da0$14a2e8e0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "ChromaCam features link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, Jan 27, 2021, 7: 44 PM",
    "Subject": "[EXT EMAIL] RE: Request for Demo [ ref:_00DG0Cbyq._5001M1f0Bgp:ref ]",
    "IDs": "<1CD84CBF-BA53-4137-8267-E589FEA624F8@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Jason tuttle number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Mar 11, 2021, 11:00 AM",
    "Subject": "RE: 00024526 - Quote 10 annual licenses. [ ref:_00DG0Cbyq._5001M1f0Bgp:ref ]",
    "IDs": "<MN2PR13MB3927492DC53ADF9E508BE2B7C8909@MN2PR13MB3927.namprd13.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Keyword Analysis written by Shauli",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Mar 10, 9:56 AM",
    "Subject": "Status",
    "IDs": "<CAAmcMVSCPW9kbscS-AqPvP9nKUk-cCRAoEyGpbP-d1ZTsv+MxA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Keyword Analysis sent to Surendra",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Mar 10, 9:56 AM",
    "Subject": "Status",
    "IDs": "<CAAmcMVSCPW9kbscS-AqPvP9nKUk-cCRAoEyGpbP-d1ZTsv+MxA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Competitors Analysis from Shauli",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Mar 10, 9:56 AM",
    "Subject": "Status",
    "IDs": "<CAAmcMVSCPW9kbscS-AqPvP9nKUk-cCRAoEyGpbP-d1ZTsv+MxA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Competitors Analysis shared with Surendra",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Mar 10, 9:56 AM",
    "Subject": "Status",
    "IDs": "<CAAmcMVSCPW9kbscS-AqPvP9nKUk-cCRAoEyGpbP-d1ZTsv+MxA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "IOS 10 folder",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Tue, Mar 9, 8:57 PM",
    "Subject": "IOS SDK 1.0 - Invitation to collaborate",
    "IDs": "<00000000000009ba0f05bd25d5a2@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Neoperl address",
    "Entity": "Location",
    "Sub-type": "",
    "Date and time": "Mar 9, 2021, 3:58 PM",
    "Subject": "RE: WG: AW: AW: AW: Company account [ ref:_00DG0Cbyq._5001M1f1ZWx:ref ]",
    "IDs": "<lci9i000000000000000000000000000000000000000000000QPQ2CR00Sy5jSML5S6-MX1tz0E0UBQ@sfdc.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "PsySeg slides from Sanjay",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Mon, Mar 8, 6:27 PM",
    "Subject": "PsySeg Overview - Invitation to edit",
    "IDs": "<000000000000af9c1e05bd0f9eca@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "ChromaCam setup",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, Mar 3, 2021, 10:42 AM",
    "Subject": "Re: [External] : Re: Question about Personify Roadmap and a bit more",
    "IDs": "<CAC=hQbm73W3w4EBaEWQQRWguQCNMP-=M7bs+VQGuPB5veMdR6A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Links for presenter",
    "Entity": "List",
    "Sub-type": "",
    "Date and time": "Mar 5, 2021, 8:05 PM",
    "Subject": "Re: [External] : Re: Question about Personify Roadmap and a bit more",
    "IDs": "<CAC=hQbm2fJhjXTS+azYCLc8nFCKbY+zXe+3iDsCV4MdW4HXbhg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify brochure",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mar 5, 2021, 8:05 PM",
    "Subject": "Re: [External] : Re: Question about Personify Roadmap and a bit more",
    "IDs": "<CAC=hQbm2fJhjXTS+azYCLc8nFCKbY+zXe+3iDsCV4MdW4HXbhg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Presenter update ppt",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Mar 8, 2021, 4:34 PM",
    "Subject": "Re: [External] : Re: Question about Personify Roadmap and a bit more",
    "IDs": "<CALV-+1ew+4XcTJt=9xJCAgSwX4f63S2mDq51Em_DjiWqN=-_Kw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Sanjay feb invoice",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Mar 8, 10:13 AM",
    "Subject": "Feb invoice",
    "IDs": "<MWHPR0801MB372243B25203FCFFC28A31E387939@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Feb invoice to Dustin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Mar 8, 10:13 AM",
    "Subject": "Feb invoice",
    "IDs": "<MWHPR0801MB372243B25203FCFFC28A31E387939@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Security document from Jeremiah",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "Fri, Mar 5, 1:28 PM",
    "Subject": "Chromacam and Personify Presenter Security Information - Invitation to edit",
    "IDs": "<000000000000279a8d05bccf1750@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Deadline for Cisco invoice",
    "Entity": "Date",
    "Sub-type": "",
    "Date and time": "Oct., 29, 2020 1:56 PM",
    "Subject": "FW: 33326026695: Approved - Invoice 20200827CSI - to Cisco (ANID: AN01001638440) - Notification from Ariba Network-Personify Inc-600670",
    "IDs": "<CC17EE39-A3D1-4161-8776-995BA5849FC9@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Surendra number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Thu, Mar 4, 4:07 PM",
    "Subject": "Personify Payments",
    "IDs": "<91C1CE8F-1DCE-498F-BCA3-8000D86880B1@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Meeting info with Keith",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Fri, Mar 5, 10:28 AM",
    "Subject": "Surendra / Keith",
    "IDs": "<SN6PR11MB28803FACECF9734831E742D2DB969@SN6PR11MB2880.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Meeting info with Surendra",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Fri, Mar 5, 10:28 AM",
    "Subject": "Surendra / Keith",
    "IDs": "<SN6PR11MB28803FACECF9734831E742D2DB969@SN6PR11MB2880.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify support link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Feb 3, 2021 11:13 PM",
    "Subject": "no camera found [ ref:_00DG0Cbyq._5001M1f1EDG:ref ]",
    "IDs": "<fd6ea86312cd42c68f2c27e43d3c3376@olb.de>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Script download from Personify",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Freitag, 12. Februar 2021 11:24",
    "Subject": "회신: AW: no camera found [ ref:_00DG0Cbyq._5001M1f1EDG:ref ]",
    "IDs": "<005001d70180$0480cab0$0d826010$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Public installer from Hai",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Thu, Feb 18, 9:59 PM",
    "Subject": "WG: AW: no camera found [ ref:_00DG0Cbyq._5001M1f1EDG:ref ]",
    "IDs": "<CAGMeF1QchOVJpK-dhitsZQWeDgeUVxotzoqLhRQ=uuBjt-kqGw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Public installer sent to Philip",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Feb 19, 2021, 5:56 PM",
    "Subject": "WG: AW: no camera found [ ref:_00DG0Cbyq._5001M1f1EDG:ref ]",
    "IDs": "<CAL43u-VYpgEWc2W6wT_nutXvPwBA7UEVN7kxfjS-3bew6Td0bA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Slack link to Jeremiah",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Feb 19, 2021, 5:56 PM",
    "Subject": "WG: AW: no camera found [ ref:_00DG0Cbyq._5001M1f1EDG:ref ]",
    "IDs": "<CAL43u-VYpgEWc2W6wT_nutXvPwBA7UEVN7kxfjS-3bew6Td0bA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Slack link from Long",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Feb 19, 2021, 5:56 PM",
    "Subject": "WG: AW: no camera found [ ref:_00DG0Cbyq._5001M1f1EDG:ref ]",
    "IDs": "<CAL43u-VYpgEWc2W6wT_nutXvPwBA7UEVN7kxfjS-3bew6Td0bA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Issues list from Philip",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Tue, Mar 2, 5:50 AM",
    "Subject": "WG: AW: no camera found [ ref:_00DG0Cbyq._5001M1f1EDG:ref ]",
    "IDs": "<011101d70f5a$44b561d0$ce202570$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Google Analytics account from Simon",
    "Entity": "Link",
    "Sub-type": "Google Analytics",
    "Date and time": "Thu, Mar 4, 3:38 PM",
    "Subject": "Accounts and Continuity",
    "IDs": "<CALV-+1d7ThqyqAF5cdgNHQAnO0Ucy0r+sHanfYSNa7w8XbLtBA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "SOW from Shauli",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Mar 4, 2:48",
    "Subject": "Personify Inc SOW for Marketing",
    "IDs": "<CAAmcMVT2NLpvag7mkeeyawdwQ0rv6fbL-c7U-P-5V5dBHKS7LQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "SOW to Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Mar 4, 2:48",
    "Subject": "Personify Inc SOW for Marketing",
    "IDs": "<CAAmcMVT2NLpvag7mkeeyawdwQ0rv6fbL-c7U-P-5V5dBHKS7LQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Tim's email",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Thu, Mar 4, 11:55 AM",
    "Subject": "Please create Personify email",
    "IDs": "<CAEuirr61O8z2PU2hfodYNALXzKfoXFjsLuRTMLxEvk3nwsKoDA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "March PO from Japan by Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Mar 3, 6:53 AM",
    "Subject": "PO from Japan",
    "IDs": "<027f01d7102c$370c08e0$a5241aa0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "SDK slides from Khoa",
    "Entity": "File",
    "Sub-type": "Google Slides",
    "Date and time": "Tue, Mar 2, 1:07 PM",
    "Subject": "App<->SDK Improvements/Enhancements - Invitation to edit",
    "IDs": "<00000000000076163805bc92725d@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Jeremiah's number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Mar 1, 2021, 6:03 PM",
    "Subject": "Re: 00025066 - Refund [ ref:_00DG0Cbyq._5001M1frMuP:ref ]",
    "IDs": "<CAC=hQbnOmqF_Vj_F-SvxNy_ws1fCLwbsA+cPCv-_V0Ep6q+ODg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "February salaries from Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Feb 26, 2021, 12:22 PM",
    "Subject": "Operation expense estimate 2021-03",
    "IDs": "<CAL43u-V+uWgU0dj9J7xGekYZDW5f8Hcnt05QTWENQPoNeZsL5Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "February salaries sent to Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Feb 26, 2021, 12:22 PM",
    "Subject": "Operation expense estimate 2021-03",
    "IDs": "<CAL43u-V+uWgU0dj9J7xGekYZDW5f8Hcnt05QTWENQPoNeZsL5Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "March estimate by Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Feb 26, 2021, 12:22 PM",
    "Subject": "Operation expense estimate 2021-03",
    "IDs": "<CAL43u-V+uWgU0dj9J7xGekYZDW5f8Hcnt05QTWENQPoNeZsL5Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "March estimate shared with Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Feb 26, 2021, 12:22 PM",
    "Subject": "Operation expense estimate 2021-03",
    "IDs": "<CAL43u-V+uWgU0dj9J7xGekYZDW5f8Hcnt05QTWENQPoNeZsL5Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Acord form from Jeremiah",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Friday, February 12, 2021 5:12 PM",
    "Subject": "[EXTERNAL] RE: Personify ChromaCam contact [ ref:_00DG0Cbyq._5001M1f2LFF:ref ]",
    "IDs": "<5rtPP000000000000000000000000000000000000000000000QONF9D00A1hf-IABSZmz_50ientPIg@sfdc.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify admin guide",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Feb 25, 2021, 5:57 PM",
    "Subject": "RE: Contact Form [ ref:_00DG0Cbyq._5001M1frl6d:ref ]",
    "IDs": "<dc9RA000000000000000000000000000000000000000000000QP3ZVT00WyM83Yl_S8mBHCXfjTeolg@sfdc.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify tutorial",
    "Entity": "Link",
    "Sub-type": "YouTube",
    "Date and time": "Feb 25, 2021, 5:57 PM",
    "Subject": "RE: Contact Form [ ref:_00DG0Cbyq._5001M1frl6d:ref ]",
    "IDs": "<dc9RA000000000000000000000000000000000000000000000QP3ZVT00WyM83Yl_S8mBHCXfjTeolg@sfdc.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Notices for electricity from Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Feb 25, 2021, 4:47 PM",
    "Subject": "1551 McCarthy Blvd., Milpitas - PGE SHUTDOWNS",
    "IDs": "<7937718B-68DA-40F3-BAA9-146DFD17C10C@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify login",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, 24 Feb 2021 at 01:34",
    "Subject": "Reassign Chromacam license",
    "IDs": "<qnoCM000000000000000000000000000000000000000000000QP220E00WXHCxM4UToS7qTaLSG5--Q@sfdc.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Link to startup info",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Feb 24, 2021, 6:51 AM",
    "Subject": "Media interview request",
    "IDs": "<CAJ87cEq6Q9k31vtqPvrQWjO08=qkzqCvL=DzRD3SOf833E-LiQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "SDK Segmentation folder from Khoa",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Tue, Feb 23, 10:42 AM",
    "Subject": "Personify Segmentation SDK (PsySeg) Release 3.6.11.5 - Invitation to collaborate",
    "IDs": "<00000000000005ba9105bc039938@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Agent number in Vietnam",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Monday, February 22, 2021 12:29 PM",
    "Subject": "RE: Re: Vietnam visa application_MTSTW",
    "IDs": "<CAL43u-WC5tC21x-2VjQJGwzOW0VjC9OJzd=sa_K-6CXkuq-Pug@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Steven's number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Fri, Feb 19, 2021 3:19 PM",
    "Subject": "Re: Vietnam visa application_MTSTW",
    "IDs": "<CAL43u-WC5tC21x-2VjQJGwzOW0VjC9OJzd=sa_K-6CXkuq-Pug@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Whiteboard meeting info",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Tue, Feb 23, 4:45 PM",
    "Subject": "Invitation: Whiteboard and others @ Wed Feb 24, 2021 4pm - 5pm (PST) (Surendra Arora)",
    "IDs": "<000000000000b90eb005bc08ac16@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify roadmap",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Tue, Feb 23, 12:24 AM",
    "Subject": "Question about Personify Roadmap and a bit more",
    "IDs": "<CALV-+1dPoUpMzZNshzvU_hXOWaVdn=S0gs9MiT=hxqDK33sx4w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "List of services from Long",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "Feb 22, 2021, 9:05 PM",
    "Subject": "Personify business continuity plans",
    "IDs": "<CAL43u-Uj-qaCiFjgyEgp=VH=zu60hdR9S7DC83L+BAryONoGtQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "List of services sent to Tim",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "Feb 22, 2021, 9:05 PM",
    "Subject": "Personify business continuity plans",
    "IDs": "<CAL43u-Uj-qaCiFjgyEgp=VH=zu60hdR9S7DC83L+BAryONoGtQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Phlilp invoice for Janauary",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Jan 24, 2021, 4:12 PM",
    "Subject": "Jan 2021 Invoice - Philip Lee",
    "IDs": "<00d501d6f29e$011a1750$034e45f0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Google invoice from Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 24, 2021, 4:12 PM",
    "Subject": "Jan 2021 Invoice - Philip Lee",
    "IDs": "<00d501d6f29e$011a1750$034e45f0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Background check from Mike",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Feb 22, 2021, 1:51 PM",
    "Subject": "Re: Personify Personnel Security Policy",
    "IDs": "<BY5PR19MB4033217300027CF524ED2FD4C8819@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Business protection agreement from Mike",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Feb 22, 2021, 1:51 PM",
    "Subject": "Re: Personify Personnel Security Policy",
    "IDs": "<BY5PR19MB4033217300027CF524ED2FD4C8819@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Employee form to Khoa",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Feb 22, 2021, 1:51 PM",
    "Subject": "Re: Personify Personnel Security Policy",
    "IDs": "<BY5PR19MB4033217300027CF524ED2FD4C8819@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Offboarding form to Khoa",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Feb 22, 2021, 1:51 PM",
    "Subject": "Re: Personify Personnel Security Policy",
    "IDs": "<BY5PR19MB4033217300027CF524ED2FD4C8819@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "SOC2 Worksheet from Khoa",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Mon, Feb 22, 10:51 AM",
    "Subject": "SOC2 Worksheet - Invitation to edit",
    "IDs": "<000000000000bdd71105bbef9e1d@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "R&D meeting info",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Mon, Feb 22, 6:19 AM",
    "Subject": "Invitation: R&D Work and Priorities updates @ Thu Feb 25, 2021 7pm - 8pm (PST) (Surendra Arora)",
    "IDs": "<000000000000a928ee05bbebd1bf@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "IOS meeting update",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Feb 23, 2021, 9:31 PM",
    "Subject": "Updated invitation: IOS SDK sync @ Tue Feb 23, 2021 7:30pm - 8pm (PST) (Surendra Arora)",
    "IDs": "<00000000000032ef1405bc0cabbd@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "IOS meeting details",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Mon, Feb 22, 6:15 AM",
    "Subject": "Invitation: IOS SDK sync @ Tue Feb 23, 2021 7:30pm - 8pm (PST) (Surendra Arora)",
    "IDs": "<000000000000415fc205bbebc018@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Corporate folder shared by Long",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Fri, Feb 19, 12:06 AM",
    "Subject": "Corporate - Invitation to view",
    "IDs": "<0000000000001d72f205bbaa4209@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Feb Japan PO by Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Feb 17, 10:29 PM",
    "Subject": "PO(20 x PP OA) from Japan",
    "IDs": "<00a001d705ae$97b09720$c711c560$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Presenter intro",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Jan 15, 4:08 AM",
    "Subject": "WG: Company licence chomacam",
    "IDs": "<010501d6eb26$67b13680$3713a380$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Link about presenter",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Fri, Jan 15, 4:08 AM",
    "Subject": "WG: Company licence chomacam",
    "IDs": "<010501d6eb26$67b13680$3713a380$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify phone number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Fri, Feb 12, 1:30 PM",
    "Subject": "00024554 - Chromacam Licenses [ ref:_00DG0Cbyq._5001M1f0Kyl:ref ]",
    "IDs": "<CAC=hQb=Sy-iDNY70PKFT64vAXBAtkVVgw7YSj44mOae84eRX0g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Updates on meeting with Citadel",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Wed, Feb 17, 2:55 PM",
    "Subject": "Webex meeting changed: Personify Chromacam for Citadel Credit Union",
    "IDs": "<1795907785.18985141613595354414.JavaMail.nobody@rsj7rmd001.webex.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Termination agreement for Personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Feb 16, 2021, 4:32 PM",
    "Subject": "FW: Personify (Foxconn)_2020-0382_Partially Executed Termination Agreement",
    "IDs": "<DM6PR11MB33402A3A815F69AB72FF3ADBB1879@DM6PR11MB3340.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Chromacam download",
    "Entity": "Link",
    "Sub-type": "Google Drive",
    "Date and time": "Donnerstag, 4. Februar 2021 06:19",
    "Subject": "회신: ChromaCam without Login [ ref:_00DG0Cbyq._5001M1f13MA:ref ]",
    "IDs": "<00ec01d6fdff$8695f270$93c1d750$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Infocus business protection agreement from Mike",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Feb 11, 5:20 PM",
    "Subject": "Re: Code of Business Conduct",
    "IDs": "<BY5PR19MB4033AB6BCED3F54513324994C88C9@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Infocus COI from Mike",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Feb 11, 5:20 PM",
    "Subject": "Re: Code of Business Conduct",
    "IDs": "<BY5PR19MB4033AB6BCED3F54513324994C88C9@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Infocus ethics from Mike",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Feb 11, 5:20 PM",
    "Subject": "Re: Code of Business Conduct",
    "IDs": "<BY5PR19MB4033AB6BCED3F54513324994C88C9@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Infocus confidentiality policy from Mike",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Feb 11, 5:20 PM",
    "Subject": "Re: Code of Business Conduct",
    "IDs": "<BY5PR19MB4033AB6BCED3F54513324994C88C9@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify employee form from Mike",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Feb 11, 2021, 8:22 PM",
    "Subject": "Re: Code of Business Conduct",
    "IDs": "<BY5PR19MB40339070721B432D76E7BD55C88B9@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify COI from Mike",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Feb 11, 2021, 8:22 PM",
    "Subject": "Re: Code of Business Conduct",
    "IDs": "<BY5PR19MB40339070721B432D76E7BD55C88B9@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify business ethics from Mike",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Feb 11, 2021, 8:22 PM",
    "Subject": "Re: Code of Business Conduct",
    "IDs": "<BY5PR19MB40339070721B432D76E7BD55C88B9@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify confidentiality policy from Mike",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Feb 11, 2021, 8:22 PM",
    "Subject": "Re: Code of Business Conduct",
    "IDs": "<BY5PR19MB40339070721B432D76E7BD55C88B9@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Wiseup po from philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, Feb 9, 11:03 PM",
    "Subject": "PO from Hitachi Japan",
    "IDs": "<00ef01d6ff6a$0c85cd40$259167c0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "W9 form from Personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, Feb 9, 1:40 PM",
    "Subject": "RE: FW: 00024790 - CC Pro licenses. [ ref:_00DG0Cbyq._5001M1f1edO:ref ]",
    "IDs": "<A15BE9CA-246F-44C2-BD48-250AE9F8179E@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "ach vendor form from boh",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Feb 9, 2021, 2:38 PM",
    "Subject": "RE: FW: 00024790 - CC Pro licenses. [ ref:_00DG0Cbyq._5001M1f1edO:ref ]",
    "IDs": "<6ba7e9e6234946a19b32c96fa432b565@EXMBX2-CPF.bankoh.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "New vendor form sent by Kristine",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Feb 9, 2021, 2:38 PM",
    "Subject": "RE: FW: 00024790 - CC Pro licenses. [ ref:_00DG0Cbyq._5001M1f1edO:ref ]",
    "IDs": "<6ba7e9e6234946a19b32c96fa432b565@EXMBX2-CPF.bankoh.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Compiled ach form from Dustin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Feb 9, 2021, 4:16 PM",
    "Subject": "RE: FW: 00024790 - CC Pro licenses. [ ref:_00DG0Cbyq._5001M1f1edO:ref ]",
    "IDs": "<FA41E33F-B9A1-4DDC-B276-064A6116267D@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Compiled new vendor set up form from Dustin",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Feb 9, 2021, 4:16 PM",
    "Subject": "RE: FW: 00024790 - CC Pro licenses. [ ref:_00DG0Cbyq._5001M1f1edO:ref ]",
    "IDs": "<FA41E33F-B9A1-4DDC-B276-064A6116267D@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Chromacam quote",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Feb 9, 2021, 4:16 PM",
    "Subject": "RE: FW: 00024790 - CC Pro licenses. [ ref:_00DG0Cbyq._5001M1f1edO:ref ]",
    "IDs": "<FA41E33F-B9A1-4DDC-B276-064A6116267D@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Chromacam log collection script",
    "Entity": "File",
    "Sub-type": "Zip",
    "Date and time": "Monday, 08. 02 2021 23:37",
    "Subject": "Chromacam Beta Test Issue",
    "IDs": "<CAC=hQbmUw06cn7MrjgZuPFa5-8waabk_m5-7Jh_1XwaYJieFjg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "CC logs upload",
    "Entity": "Link",
    "Sub-type": "Google Drive",
    "Date and time": "Monday, 08. 02 2021 23:37",
    "Subject": "Chromacam Beta Test Issue",
    "IDs": "<CAC=hQbmUw06cn7MrjgZuPFa5-8waabk_m5-7Jh_1XwaYJieFjg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Chromacam Production version",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Monday, 08. 02 2021 23:37",
    "Subject": "Chromacam Beta Test Issue",
    "IDs": "<CAC=hQbmUw06cn7MrjgZuPFa5-8waabk_m5-7Jh_1XwaYJieFjg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Slack signoff from Long",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Feb 4, 2021, 10:29 AM",
    "Subject": "Sign-off for release Presenter for Win 3.0.6.5",
    "IDs": "<CAL43u-VpSwn-FVXKJUyNx6Nu2h3_s=YpvA8-y64CbykzZz4sog@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Slack signoff to Simon",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Feb 4, 2021, 10:29 AM",
    "Subject": "Sign-off for release Presenter for Win 3.0.6.5",
    "IDs": "<CAL43u-VpSwn-FVXKJUyNx6Nu2h3_s=YpvA8-y64CbykzZz4sog@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Feedback on 3013 from Holly",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Fri, Feb 5, 7:31 PM",
    "Subject": "Re: Sign-off for release Presenter for Win 3.0.6.5",
    "IDs": "<CAP7yWZj4=h+Scjw9PBUbxnLsLrakA9E2GmmqkGusjZCa3uApRA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Feedback on 3013 to Simon",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Fri, Feb 5, 7:31 PM",
    "Subject": "Re: Sign-off for release Presenter for Win 3.0.6.5",
    "IDs": "<CAP7yWZj4=h+Scjw9PBUbxnLsLrakA9E2GmmqkGusjZCa3uApRA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Khoa's address",
    "Entity": "Location",
    "Sub-type": "Address",
    "Date and time": "Mon, Feb 8, 12:29 AM",
    "Subject": "Re: We heard you and we agree",
    "IDs": "<9B671BF9-36B9-45B5-94AE-712C29410376@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Transition kit email from Simon",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Thu, Feb 4, 12:51 AM",
    "Subject": "Re: Get ready to return the Developer Transition Kit.",
    "IDs": "<CALV-+1fLHJHp8LLE940+TXrhFVpvm7pVaJ4B5_0tFdAkjvhzCQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Transition kit email to Richard",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Thu, Feb 4, 12:51 AM",
    "Subject": "Re: Get ready to return the Developer Transition Kit.",
    "IDs": "<CALV-+1fLHJHp8LLE940+TXrhFVpvm7pVaJ4B5_0tFdAkjvhzCQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Termination letter with edits to Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Tue, Dec 8, 2020, 2:28 PM",
    "Subject": "Termination Letter",
    "IDs": "<DM6PR11MB3340D7498CA2059F44E549C9B1CD0@DM6PR11MB3340.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Termination letter with edits from Svetlana",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Tue, Dec 8, 2020, 2:28 PM",
    "Subject": "Termination Letter",
    "IDs": "<DM6PR11MB3340D7498CA2059F44E549C9B1CD0@DM6PR11MB3340.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Clean termination letter by Svetlana",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Tue, Dec 8, 2020, 2:28 PM",
    "Subject": "Termination Letter",
    "IDs": "<DM6PR11MB3340D7498CA2059F44E549C9B1CD0@DM6PR11MB3340.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Clean termination letter to Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Tue, Dec 8, 2020, 3:45 PM",
    "Subject": "Termination Letter",
    "IDs": "<DM6PR11MB3340D7498CA2059F44E549C9B1CD0@DM6PR11MB3340.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Surendra's number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Tue, Dec 8, 2020, 3:49 PM",
    "Subject": "Termination Letter",
    "IDs": "<B9D3ACA2-1B3C-46A4-8AD3-E6CC68025034@foxconn.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Termination letter with Personify",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Feb 4, 7:03 PM",
    "Subject": "Termination Letter",
    "IDs": "<DM6PR11MB3340279EFB7D2E67AA95818CB1B29@DM6PR11MB3340.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Clean termination letter for personify",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Feb 4, 7:03 PM",
    "Subject": "Termination Letter",
    "IDs": "<DM6PR11MB3340279EFB7D2E67AA95818CB1B29@DM6PR11MB3340.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "License with Illinois",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Feb 5, 11:27 AM",
    "Subject": "Termination Letter",
    "IDs": "<BYAPR11MB333552EE228B99D40DF25A45B1B29@BYAPR11MB3335.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "License with Personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Feb 5, 11:27 AM",
    "Subject": "Termination Letter",
    "IDs": "<BYAPR11MB333552EE228B99D40DF25A45B1B29@BYAPR11MB3335.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Illinois license amendment",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Feb 5, 11:27 AM",
    "Subject": "Termination Letter",
    "IDs": "<BYAPR11MB333552EE228B99D40DF25A45B1B29@BYAPR11MB3335.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify license amendment",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Feb 5, 11:27 AM",
    "Subject": "Termination Letter",
    "IDs": "<BYAPR11MB333552EE228B99D40DF25A45B1B29@BYAPR11MB3335.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Meeting about taxes",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Fri, Feb 5, 3:50 PM",
    "Subject": "Re: Personify (OldCo) taxes",
    "IDs": "<F79E9716-DFED-4FD8-84C6-2487E99D55AF@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Live demo with Langley",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "2/1/2021 8:54 AM",
    "Subject": "RE: [EXT EMAIL] RE: Request for Demo [ ref:_00DG0Cbyq._5001M1f0Bgp:ref ]",
    "IDs": "<BzFb3000000000000000000000000000000000000000000000QO2J9C00vQABKu6aTHOBIb0Ylu9_1g@sfdc.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Unicode camera from Long",
    "Entity": "Link",
    "Sub-type": "Github",
    "Date and time": "Feb 4, 2021, 8:34 PM",
    "Subject": "Re: Ticket 00022913",
    "IDs": "<CAL43u-V_yU9oXhF9kaxSBms+ra52Mg3xOvqagAMQWe-dquMWYA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Context results from Holly",
    "Entity": "Link",
    "Sub-type": "Facebook",
    "Date and time": "Thu, Feb 4, 8:35 AM",
    "Subject": "Re: PP and CC contest 2020",
    "IDs": "<C3052F68-B809-46A5-BDAE-02E8E9E91AE5@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Context results to Philip",
    "Entity": "Link",
    "Sub-type": "Facebook",
    "Date and time": "Thu, Feb 4, 8:35 AM",
    "Subject": "Re: PP and CC contest 2020",
    "IDs": "<C3052F68-B809-46A5-BDAE-02E8E9E91AE5@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Signoff link from Long",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Feb 4, 2021, 11:11 AM",
    "Subject": "Sign-off for release ChromaCam for Mac 1.0.3.63",
    "IDs": "<CAL43u-Ve__VtoTHKoUbQccEQpCT1L92V+_FtfgqDELArxG8W2Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "December january invoice from Sanjay",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Feb 4, 9:59 AM",
    "Subject": "Dec and Jan invoice",
    "IDs": "<E2978538-7ADA-4BA2-8A8B-48F37DCDAABC@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Dec invoice to Dustin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Feb 4, 9:59 AM",
    "Subject": "Dec and Jan invoice",
    "IDs": "<E2978538-7ADA-4BA2-8A8B-48F37DCDAABC@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Jan invoice to Dustin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Feb 4, 9:59 AM",
    "Subject": "Dec and Jan invoice",
    "IDs": "<E2978538-7ADA-4BA2-8A8B-48F37DCDAABC@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Schock address",
    "Entity": "Location",
    "Sub-type": "Address",
    "Date and time": "Feb 3, 2021, 1:41 AM",
    "Subject": "Antwort: RE: Contact Form [ ref:_00DG0Cbyq._5001M1f13JG:ref ]",
    "IDs": "<OF478B0022.C3E2D817-ONC1258671.002905A3-C1258671.002A47F7@schock-metall.de>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify sales email",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Feb 3, 2021, 1:41 AM",
    "Subject": "Antwort: RE: Contact Form [ ref:_00DG0Cbyq._5001M1f13JG:ref ]",
    "IDs": "<OF478B0022.C3E2D817-ONC1258671.002905A3-C1258671.002A47F7@schock-metall.de>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Surendra's address",
    "Entity": "Location",
    "Sub-type": "Address",
    "Date and time": "Sat, Jan 30, 10:28 AM",
    "Subject": "Re: Samsung - NDA and SEA",
    "IDs": "<D030D1D2-E025-4AD3-8AFF-A6371A122F9E@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Number surendra",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Sat, Jan 30, 10:28 AM",
    "Subject": "Re: Samsung - NDA and SEA",
    "IDs": "<D030D1D2-E025-4AD3-8AFF-A6371A122F9E@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "January salaries from Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Feb 1, 2021, 11:05 AM",
    "Subject": "Operation expense estimate 2021-02",
    "IDs": "<CAL43u-V+Frbi_2oq0yVg3MmoB5yHOKR8YprYkjvL84-EMKM-KA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Estimated February costs from Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Feb 1, 2021, 11:05 AM",
    "Subject": "Operation expense estimate 2021-02",
    "IDs": "<CAL43u-V+Frbi_2oq0yVg3MmoB5yHOKR8YprYkjvL84-EMKM-KA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Suggestions for iphone",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Jan 27, 1:46 AM",
    "Subject": "Request device",
    "IDs": "<CAKng2fHgw_9VzbFyem9iBi8Ne0K_KJyZnsxcUwhiKJw9BjmG-w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Updated suggestions for iphone",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Thu, Jan 28, 11:34 PM",
    "Subject": "Request device",
    "IDs": "<CAKng2fGDLCKr5rMXt6rSivN+F4+CnoHYW7MHsgNndQZaP8EaWA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Tet spreasheet shared by Long",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Thu, Jan 28, 11:11 PM",
    "Subject": "WFH -- Working remote tracking - Tet holiday 2021 - Invitation to edit",
    "IDs": "<000000000000842e0d05ba03083e@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Tet workplan",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Thu, Jan 28, 11:11 PM",
    "Subject": "WFH -- Working remote tracking - Tet holiday 2021 - Invitation to edit",
    "IDs": "<000000000000842e0d05ba03083e@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify registration link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Jan 21, 2021, 10:43 PM",
    "Subject": "Re: 00024373 - RE: Not for profit 501(c)3 RCF (Rotary Childrens Fund) - request for support [ ref:_00DG0Cbyq._5001M1ezTdI:ref ]",
    "IDs": "<CAP7yWZhMJyzEX5hW3e8_obH-qyLvsjxfYa1vh=HTJXwhx8AAqQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Invoice for Beyer",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Jan 27, 12:34 PM",
    "Subject": "RE: 00024491 - Chromacam licenses - purchase by invoice [ ref:_00DG0Cbyq._5001M1f013P:ref ]",
    "IDs": "<5CCFC441-9715-4B17-BFBD-118CE3BE48EE@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Updated Beyer invoice",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 27, 2021, 12:50 PM",
    "Subject": "RE: 00024491 - Chromacam licenses - purchase by invoice [ ref:_00DG0Cbyq._5001M1f013P:ref ]",
    "IDs": "<0C692252-61A7-4FFD-8F5E-6D49966F6B20@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Definitive plan from Long",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Tue, Jan 26, 10:10 PM",
    "Subject": "Re: Visual Studios Upgrade",
    "IDs": "<CAL43u-UMaq6Su=Jma_JnMU31s4MCwc13PCWMyX=umcWZGmnGxQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Definitive plan to Hai",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Tue, Jan 26, 10:10 PM",
    "Subject": "Re: Visual Studios Upgrade",
    "IDs": "<CAL43u-UMaq6Su=Jma_JnMU31s4MCwc13PCWMyX=umcWZGmnGxQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Plan proposals shared by Hai",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "Tue, 26 Jan 2021 at 09:15",
    "Subject": "Re: Visual Studios Upgrade",
    "IDs": "<CAL43u-UMaq6Su=Jma_JnMU31s4MCwc13PCWMyX=umcWZGmnGxQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Estimation by Hai",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "Thu, Jan 21, 2021 at 11:00 AM",
    "Subject": "Re: Visual Studios Upgrade",
    "IDs": "<CAL43u-UMaq6Su=Jma_JnMU31s4MCwc13PCWMyX=umcWZGmnGxQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Estimation shared with Simon",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "Thu, Jan 21, 2021 at 11:00 AM",
    "Subject": "Re: Visual Studios Upgrade",
    "IDs": "<CAL43u-UMaq6Su=Jma_JnMU31s4MCwc13PCWMyX=umcWZGmnGxQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Upgrades spreasheet from Hai",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "Mon, 18 Jan 2021 at 13:30",
    "Subject": "Re: Visual Studios Upgrade",
    "IDs": "<CAL43u-UMaq6Su=Jma_JnMU31s4MCwc13PCWMyX=umcWZGmnGxQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Spreadsheet about upgrades sent to Simon",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "Mon, 18 Jan 2021 at 13:30",
    "Subject": "Re: Visual Studios Upgrade",
    "IDs": "<CAL43u-UMaq6Su=Jma_JnMU31s4MCwc13PCWMyX=umcWZGmnGxQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "New Personify address",
    "Entity": "Location",
    "Sub-type": "Address",
    "Date and time": "Tue, Jan 26, 11:01 AM",
    "Subject": "Invoice/Receipt Address",
    "IDs": "<19EBFC45-0861-4E79-B25E-6C152550821A@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Tugboat guide",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 26, 2021, 7:14 PM",
    "Subject": "Personify - Onboarding with Tugboat Logic",
    "IDs": "<CABpd3rAPzHw70QUw-vC01EBi01X_yxqQXGwWccKJiWgh+RcPMw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Customer email from Loron",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Tue, Jan 26, 3:51 PM",
    "Subject": "Presales ticket 00024522",
    "IDs": "<018901d6f42d$57d57180$07805480$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Stockholder draft written by Christine",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Jan 19, 2021, 1:39 PM",
    "Subject": "Re: FW: 2021 - Personify, Inc. - DE annual report",
    "IDs": "<CAHz_o-4A5CYLhMYKmcKzx=f5O2GWHMqY7f2OOj8vjOEQo_20yw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Board draft written by Christine",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Jan 19, 2021, 1:39 PM",
    "Subject": "Re: FW: 2021 - Personify, Inc. - DE annual report",
    "IDs": "<CAHz_o-4A5CYLhMYKmcKzx=f5O2GWHMqY7f2OOj8vjOEQo_20yw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Definitive stockholders sent by Dustin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 25, 2021, 1:32 PM",
    "Subject": "RE: FW: 2021 - Personify, Inc. - DE annual report",
    "IDs": "<6CECC6A9-7E67-4FB7-9AEE-8C3CBAF9BC5F@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Definitive stockholders shared with Christine",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 25, 2021, 1:32 PM",
    "Subject": "RE: FW: 2021 - Personify, Inc. - DE annual report",
    "IDs": "<6CECC6A9-7E67-4FB7-9AEE-8C3CBAF9BC5F@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Definitive board meetingconsent from Dustin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 25, 2021, 1:32 PM",
    "Subject": "RE: FW: 2021 - Personify, Inc. - DE annual report",
    "IDs": "<6CECC6A9-7E67-4FB7-9AEE-8C3CBAF9BC5F@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Definitive board consent to Christine",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 25, 2021, 1:32 PM",
    "Subject": "RE: FW: 2021 - Personify, Inc. - DE annual report",
    "IDs": "<6CECC6A9-7E67-4FB7-9AEE-8C3CBAF9BC5F@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "PayPal statement for OldCo",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Jan 25, 11:39 AM",
    "Subject": "Paypal account",
    "IDs": "<E1E37D49-21EC-4460-9591-71034C2F7FA5@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Headen kpi review to dustin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jan 21, 4:40 PM",
    "Subject": "2020 Q4 KPI - Haeden Bridge, Korea",
    "IDs": "<006a01d6f046$73f21430$5bd63c90$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Headen Bridge revised invoice from Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jan 21, 4:40 PM",
    "Subject": "2020 Q4 KPI - Haeden Bridge, Korea",
    "IDs": "<006a01d6f046$73f21430$5bd63c90$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Chromacam price request from Softwareone",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 22, 2021, 3:12 AM",
    "Subject": "Purchase Price Request (SWO) DEC-PPQ-122184 Klingel medical metal GmbH",
    "IDs": "<7bfc3723-bc17-41ba-ab57-3a45644ae2f9@CHPVS00556.domain.global>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Quote from Personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 22, 2021, 4:14 PM",
    "Subject": "RE: Purchase Price Request (SWO) DEC-PPQ-122184 Klingel medical metal GmbH",
    "IDs": "<A52F967F-6565-49DF-BFAA-11D671C81B4F@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "New year meeting",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Fri, Jan 22, 11:49 AM",
    "Subject": "Invitation: Happy New Year to VN team video @ Fri Jan 22, 2021 1pm - 1:30pm (PST) (Surendra Arora)",
    "IDs": "<00000000000050d8aa05b980cf52@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Wise up kpi review to surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jan 21, 9:49 PM",
    "Subject": "2020 Q4 KPI - Wise Up, Japan",
    "IDs": "<010501d6f071$a831b950$f8952bf0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Tugboat contract from Khoa",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 21, 2021, 11:39 AM",
    "Subject": "soc2",
    "IDs": "<CADTtM3-D6QmMZk-Lr+p+v1O4CVzwsLL7=aKQ_+JTQAzdJtHqsw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Samsung link from Philip",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Tue, Jan 19, 5:18 AM",
    "Subject": "Samsung's Knox",
    "IDs": "<017301d6ee54$d0c0d410$72427c30$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Japan log from Philip",
    "Entity": "File",
    "Sub-type": "Zip",
    "Date and time": "Dec 2, 2020, 12:50 AM",
    "Subject": "PP Recording issue",
    "IDs": "<06fa01d6c877$692368c0$3b6a3a40$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Top priority list from Long",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Jan 15, 2021, 1:44 AM",
    "Subject": "Re: PP Recording issue",
    "IDs": "<CAL43u-XCQ2Y=Ojan6JjC9ArK-Otoqi4DQtWXSes=JLbPrUq88Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Top priority list shared with Simon",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Jan 15, 2021, 1:44 AM",
    "Subject": "Re: PP Recording issue",
    "IDs": "<CAL43u-XCQ2Y=Ojan6JjC9ArK-Otoqi4DQtWXSes=JLbPrUq88Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Link for quality from Phuc Le",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Jan 20, 2021, 3:26 AM",
    "Subject": "Re: PP Recording issue",
    "IDs": "<6F65FC47-1B97-49D3-A1B0-9912F82DDE4E@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Revenue summary to Surendra",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Tue, Jan 19, 8:35 PM",
    "Subject": "Finance data for KPI with the partners",
    "IDs": "<02a101d6eed4$f5ee9760$e1cbc620$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Transaction report shared with Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Tue, Jan 19, 8:35 PM",
    "Subject": "Finance data for KPI with the partners",
    "IDs": "<02a101d6eed4$f5ee9760$e1cbc620$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify receipt",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, Jan 19, 3:35 PM",
    "Subject": "Fwd: Not authorized credit card transaction [ ref:_00DG0Cbyq._5001M1ezCEm:ref ]",
    "IDs": "<CABnbrUbXMfv38Z4eJby=quMvSXar5YDwuHiKQ++oPVASToNqsg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Hiseva meeting info",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Jan 19, 2021, 2:39 PM",
    "Subject": "Invitation: Seva < > Personify intro @ Tue Jan 19, 2021 1pm - 1:30pm (PST) (Surendra Arora)",
    "IDs": "<000000000000b58dfd05b946d5ad@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Voicemail sent by Loron",
    "Entity": "File",
    "Sub-type": "Mp3",
    "Date and time": "Friday, January 15, 2021 11:27 AM",
    "Subject": "Voicemail from (973) 302-5993",
    "IDs": "<024801d6eb78$f11caec0$d3560c40$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Jira Huyen",
    "Entity": "Link",
    "Sub-type": "Jira",
    "Date and time": "Jan 14, 2021, 10:02 PM",
    "Subject": "[JIRA] Huyen Nguyen mentioned you on WEB-2609",
    "IDs": "<01EW23B4C41EABZC82RA58Z28Q@personify.atlassian.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Allen's phone",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "1/7/2021 7:27 AM",
    "Subject": "RE: Contact Form [ ref:_00DG0Cbyq._5001M1e1CxQ:ref ]",
    "IDs": "<vEsUh000000000000000000000000000000000000000000000QML5EZ00z6Yn_5R2R7ylIYc6S23CuA@sfdc.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Users spreadsheet from Personify",
    "Entity": "File",
    "Sub-type": "Csv",
    "Date and time": "Jan 8, 2021, 11:58 AM",
    "Subject": "Re: 00024104 - ChromaCam Pricing [ ref:_00DG0Cbyq._5001M1e1CxQ:ref ]",
    "IDs": "<CAN6k-eV3OmSa_oCa9=+pD+7b+oXGJ93PVXSOkPAiha9b3X9JZQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Ie link from Hai",
    "Entity": "Link",
    "Sub-type": "Support",
    "Date and time": "Jan 12, 2021, 10:47 PM",
    "Subject": "Reports of customers getting \"Unsecured browser error",
    "IDs": "<CAGMeF1T+CH_20AfjEFrdLWpnze+kyX2Q1cEwc1o4S_L1NvFkwg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Updated meeting about browser error",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Tue, Jan 12, 6:47 PM",
    "Subject": "Updated invitation: Reports of customers getting \"Unsecured browser error\" @ Tue Jan 12, 2021 8pm - 8:30pm (PST) (Surendra Arora)",
    "IDs": "<000000000000a5edc405b8bd7b3d@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Meeting about browser error",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Tue, Jan 12, 6:45 PM",
    "Subject": "Invitation: Reports of customers getting \"Unsecured browser error\" @ Tue Jan 12, 2021 8am - 8:30am (PST) (Surendra Arora)",
    "IDs": "<00000000000095b47605b8bd7412@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Updated rd meeting",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Tue, Jan 12, 3:47 PM",
    "Subject": "Invitation: Update with VN R&D team @ Tue Jan 12, 2021 3pm - 3:45pm (PST) (Surendra Arora)",
    "IDs": "<0000000000001c385405b8baf781@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Msi installer",
    "Entity": "Link",
    "Sub-type": "Google Drive",
    "Date and time": "Jan 11, 2021, 6:24 PM",
    "Subject": "Re: ChromaCam Login Setup",
    "IDs": "<CAC=hQbkoXNc3_qpeKTeDRd4hQTPPhhZh1NyxjAPvmH9NTvgfNA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "QA testing from Jeremiah",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Mon, Jan 11, 10:37 PM",
    "Subject": "QA testing of VMWare VDI",
    "IDs": "<CAC=hQbk5NMDyS7hPCQMot1BNY3bkJJt-ZMFgtpYtxfTRT3pd1w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify invoice",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jun 10, 2020, 2:10 PM",
    "Subject": "FW: AW: ChromaCam Lifetime Purchase Receipt - DMI GmbH & Co.KG (00019282) [ ref:_00DG0Cbyq._5001M1YqJGD:ref ]",
    "IDs": "<8D829CB5-A270-4FAF-8CD3-642BA053D0EB@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Second personify invoice",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jun 16, 2020, 3:39 PM",
    "Subject": "RE: AW: ChromaCam Lifetime Purchase Receipt - DMI GmbH & Co.KG (00019282) [ ref:_00DG0Cbyq._5001M1YqJGD:ref ]",
    "IDs": "<BD1460B5-6FCC-4F94-86EA-3DE173C49174@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Order from Japan sent by Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Jan 6, 6:12 AM",
    "Subject": "PO(Japan), License request",
    "IDs": "<004e01d6e425$26d87090$748951b0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Insight PO",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Jan 6, 10:49 AM",
    "Subject": "RE: Purchase Order 43360771 // Insight Direct (UK) Limited",
    "IDs": "<LNXP265MB13720ADDDE4DDBBE85AA0C2D86D00@LNXP265MB1372.GBRP265.PROD.OUTLOOK.COM>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Sendgrid pricing",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Thu, Jan 7, 12:12 AM",
    "Subject": "Approval Sendgrid replacement for Sendy",
    "IDs": "<CALV-+1f3dK3hy8zBwEBs-fMYhjSUPbN7wJ8s12BWpfjY-xUpKg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Lead roles shared by Long",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Jan 6, 4:28 PM",
    "Subject": "Personify Application Technical Lead roles (HaiLam) - Invitation to comment",
    "IDs": "<00000000000062c22405b842d6bf@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Application table shared with Surendra",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Jan 6, 4:28 PM",
    "Subject": "Personify Application Technical Lead roles (HaiLam) - Invitation to comment",
    "IDs": "<00000000000062c22405b842d6bf@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "W9 from trustmark",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 2, 2020, 10:51 AM",
    "Subject": "RE: 00022227 RE: Order [ ref:_00DG0Cbyq._5001M1cID4z:ref ]",
    "IDs": "<DM6PR13MB39085E0432F3A459FEE6F150A0F30@DM6PR13MB3908.namprd13.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "ACH by Trustmark",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 2, 2020, 10:51 AM",
    "Subject": "RE: 00022227 RE: Order [ ref:_00DG0Cbyq._5001M1cID4z:ref ]",
    "IDs": "<DM6PR13MB39085E0432F3A459FEE6F150A0F30@DM6PR13MB3908.namprd13.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Completed ach from personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 2, 2020, 12:32 PM",
    "Subject": "RE: 00022227 RE: Order [ ref:_00DG0Cbyq._5001M1cID4z:ref ]",
    "IDs": "<58993FA9-57D6-4AF1-B45F-228FDCD10732@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Voided personify check",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 2, 2020, 12:32 PM",
    "Subject": "RE: 00022227 RE: Order [ ref:_00DG0Cbyq._5001M1cID4z:ref ]",
    "IDs": "<58993FA9-57D6-4AF1-B45F-228FDCD10732@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Signed w9 from personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 2, 2020, 12:32 PM",
    "Subject": "RE: 00022227 RE: Order [ ref:_00DG0Cbyq._5001M1cID4z:ref ]",
    "IDs": "<58993FA9-57D6-4AF1-B45F-228FDCD10732@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "New cc versions",
    "Entity": "Link",
    "Sub-type": "Conxme Drive",
    "Date and time": "Jan 5, 2021, 9:10 AM",
    "Subject": "Re: ChormaCam issues",
    "IDs": "<CAC=hQbkPBxo-AAnnj2d1VCNHuXOE9qQ0pMYCvk7LD84txm9=vg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Financial report from Dustin",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Jan 5, 2021, 12:48 PM",
    "Subject": "Financial Reporting Package-Personify 2020 12",
    "IDs": "<MWHPR0801MB37222659464CA84ABD778F3987D10@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Report sent to Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Jan 5, 2021, 12:48 PM",
    "Subject": "Financial Reporting Package-Personify 2020 12",
    "IDs": "<MWHPR0801MB37222659464CA84ABD778F3987D10@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Presenter beta",
    "Entity": "Link",
    "Sub-type": "Conxme Drive",
    "Date and time": "Dec 15, 2020, 5:28 PM",
    "Subject": "Re: Finastra issues list",
    "IDs": "<CAC=hQbkAyvzi9im-wWQLNbWbANozuDxAocg+bDWpt27X+NCpbg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Whale beta from Philip",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Thu, Dec 31, 2020, 5:50 PM",
    "Subject": "Naver Corporation(Korea)",
    "IDs": "<002c01d6dfcf$abcf6b50$036e41f0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Plan from Philip",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Mon, Jan 4, 6:07 AM",
    "Subject": "Forecast & plan 2021",
    "IDs": "<011501d6e292$38f98eb0$aaecac10$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Plan shared with Surendra",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Mon, Jan 4, 6:07 AM",
    "Subject": "Forecast & plan 2021",
    "IDs": "<011501d6e292$38f98eb0$aaecac10$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Patent checklist from Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Dec 24, 2020, 1:15 PM",
    "Subject": "Please review Personify IP checklist for Ian",
    "IDs": "<F3B199B4-FAE5-47C1-974B-FAD909606253@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Patent checklist edited by Sanjay",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Dec 31, 2020, 1:06 PM",
    "Subject": "Re: Please review Personify IP checklist for Ian",
    "IDs": "<D05F5C5A-5488-40A5-9762-4E2C8F06B953@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Psyseg release from Khoa",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Dec 31, 2020, 3:02 AM",
    "Subject": "Re: Release of PsySeg, Personify SDK",
    "IDs": "<28808EF6-CF4D-4525-9280-513FC36B7B30@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "vcube offer to Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Wed, Dec 30, 2020, 12:03 AM",
    "Subject": "V-cuve(Japan) Offer",
    "IDs": "<006e01d6de71$84319140$8c94b3c0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Offer for Madly to Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Dec 21, 2020, 4:45 PM",
    "Subject": "Madly Offer",
    "IDs": "<002301d6d7ea$ef170270$cd450750$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Revised madly offer to Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Dec 29, 2020, 11:28 PM",
    "Subject": "회신: Madly Offer",
    "IDs": "<004301d6de6c$a91331d0$fb399570$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Vdi link from Jeremiah",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Dec 29, 2020, 10:41 AM",
    "Subject": "Migros Bank Meeting",
    "IDs": "<CAC=hQbnK8BM=mKdDYs5vXzcoMhN1u+MNnRrKtaLbGxFpzV1PRQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Vietnam bonus",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Tue, Dec 29, 2020, 11:07 AM",
    "Subject": "Operation expense estimate 2021-01",
    "IDs": "<CAL43u-UMscAr=wtRhKpD7AeZOMf4D7S0p=0+QG7e-buA6oA--Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "January estimates from Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Tue, Dec 29, 2020, 11:07 AM",
    "Subject": "Operation expense estimate 2021-01",
    "IDs": "<CAL43u-UMscAr=wtRhKpD7AeZOMf4D7S0p=0+QG7e-buA6oA--Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "December payslip sent by Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Tue, Dec 29, 2020, 11:07 AM",
    "Subject": "Operation expense estimate 2021-01",
    "IDs": "<CAL43u-UMscAr=wtRhKpD7AeZOMf4D7S0p=0+QG7e-buA6oA--Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "December paycheck to Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Tue, Dec 29, 2020, 11:07 AM",
    "Subject": "Operation expense estimate 2021-01",
    "IDs": "<CAL43u-UMscAr=wtRhKpD7AeZOMf4D7S0p=0+QG7e-buA6oA--Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Legal invoice",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 29, 2020, 1:49 PM",
    "Subject": "FW: 2020 Legal Fees",
    "IDs": "<722B15CC-447E-45B9-BA9C-B34C15002358@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Newswatch pricing",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 28, 2020, 3:30 AM",
    "Subject": "Re: Follow Up: Personify TV Feature - When to Connect",
    "IDs": "<7C8D434D-CA5C-4617-BC18-8F558C0269AC@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Article about Newswatch",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 28, 2020, 3:30 AM",
    "Subject": "Re: Follow Up: Personify TV Feature - When to Connect",
    "IDs": "<7C8D434D-CA5C-4617-BC18-8F558C0269AC@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Offer letter from Personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Dec 18, 2020, 3:40 PM",
    "Subject": "Personify Internship Offer - Abhinav Pola",
    "IDs": "<MWHPR19MB09268CCC695A4C950665B146C8C30@MWHPR19MB0926.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify employement application",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Fri, Dec 18, 2020, 3:40 PM",
    "Subject": "Personify Internship Offer - Abhinav Pola",
    "IDs": "<MWHPR19MB09268CCC695A4C950665B146C8C30@MWHPR19MB0926.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Pola cv",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 10, 2020, 10:35 AM",
    "Subject": "Software Engineer Internship",
    "IDs": "<CABcqsJSGxWiwiMw82JZWCD8Eyhpy9xL7=XTC3unuc-TigT07gg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "SOC2 wiki",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Thu, Dec 17, 2020, 11:55 PM",
    "Subject": "Slides of today meeting.",
    "IDs": "<CAL43u-XD3zzwcZiUELhHxvv_wgV+hRQwdJR5pXjH7bRTzas+ig@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "2021 ppt",
    "Entity": "FIle",
    "Sub-type": "PPT",
    "Date and time": "Dec 17, 2020, 11:55 PM",
    "Subject": "Slides of today meeting.",
    "IDs": "<CAL43u-XD3zzwcZiUELhHxvv_wgV+hRQwdJR5pXjH7bRTzas+ig@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "SOC2 research by Khoa from Long",
    "Entity": "FIle",
    "Sub-type": "PPT",
    "Date and time": "Dec 17, 2020, 11:55 PM",
    "Subject": "Slides of today meeting.",
    "IDs": "<CAL43u-XD3zzwcZiUELhHxvv_wgV+hRQwdJR5pXjH7bRTzas+ig@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Roadmap for 2021",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Dec 18, 2020, 12:19 AM",
    "Subject": "Re: Slides of today meeting.",
    "IDs": "<CAL43u-UMZ_vcF1HRC17ymjpBC-to9aJCVs_-iTX34RZgS4kVyg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Evaluation copy from Personify",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Dec 17, 2020, 2:43 PM",
    "Subject": "Re: Partner for us",
    "IDs": "<25E1A766-BC03-4E6F-9D28-8BD521100561@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Evaluation copy to Farokh",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Dec 17, 2020, 2:43 PM",
    "Subject": "Re: Partner for us",
    "IDs": "<25E1A766-BC03-4E6F-9D28-8BD521100561@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "External sdk folder",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Wed, Dec 16, 2020, 2:34 PM",
    "Subject": "SDK External - Invitation to collaborate",
    "IDs": "<000000000000f5528105b69acc99@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Resignation letter draft from Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Tue, Dec 8, 2020, 12:34 PM",
    "Subject": "Resignation letter",
    "IDs": "<C8DCFDEF-B092-4A77-A8F7-3F20E2B328C7@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Resignation letter shared by Sanjay",
    "Entity": "Link",
    "Sub-type": "UOFI Adobe",
    "Date and time": "Dec 16, 2020, 11:32 AM",
    "Subject": "Re: Resignation letter",
    "IDs": "<B96E875C-1A91-4B58-928B-ACCC0D03CBFA@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Madly CEO from Philip",
    "Entity": "Link",
    "Sub-type": "LinkedIn",
    "Date and time": "Dec 16, 2020, 1:19 AM",
    "Subject": "Madly, US Company",
    "IDs": "<00b701d6d37b$d60183f0$82048bd0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Madly director from Philip",
    "Entity": "Link",
    "Sub-type": "LinkedIn",
    "Date and time": "Dec 16, 2020, 1:19 AM",
    "Subject": "Madly, US Company",
    "IDs": "<00b701d6d37b$d60183f0$82048bd0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Google prototype from Surendra",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Dec 16, 2020, 3:47 PM",
    "Subject": "Re: Madly, US Company",
    "IDs": "<122E85A8-B336-4B4B-A470-6EB5022593AF@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Simon's number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Mon, Dec 14, 2020, 4:23 PM",
    "Subject": "Re: 00023659 - RE: Fwd: Contact Form [ ref:_00DG0Cbyq._5001M1dyDmf:ref ]",
    "IDs": "<CALV-+1fk0KzErG4uG0hj5s6vG1CeU37ReQivF-qa999dztnuGQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Salesforce link from Loron",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Dec 14, 2020, 1:17 PM",
    "Subject": "Presales ChromaCam 10 to 20 users",
    "IDs": "<012101d6d24d$d2b35090$7819f1b0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify offer letter",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Dec 11, 2020, 6:57 PM",
    "Subject": "Personify Internship Offer - Aashna Mehta",
    "IDs": "<MWHPR19MB0926974EB7D7F004125C9626C8C90@MWHPR19MB0926.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Signed offer letter by Ashna",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Dec 14, 2020, 11:23 AM",
    "Subject": "Re: Personify Internship Offer - Aashna Mehta",
    "IDs": "<CAHK2KLvykCbjEMZHw3s-=JkTc+DCA8e-mTu=2BUWVfgOvG4gLg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Offer letter by Personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Dec 11, 2020, 6:57 PM",
    "Subject": "Personify Internship Offer - Rohan Patel",
    "IDs": "<MWHPR19MB092621B04C87015228A92DA6C8C90@MWHPR19MB0926.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Rohan offer letter",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Sun, Dec 13, 2020, 8:58 PM",
    "Subject": "Re: Personify Internship Offer - Rohan Patel",
    "IDs": "<F6DAC037-F1F4-4BAF-A6D2-0F33149F1B3A@gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Cvs from Khoa",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, Dec 8, 2020, 10:32 AM",
    "Subject": "Re: UIUC students",
    "IDs": "<D4350950-3D64-4777-A9C5-3EE92DD8A935@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Voicemail from Loron",
    "Entity": "File",
    "Sub-type": "Mp3",
    "Date and time": "Fri, Dec 11, 2020, 4:53 PM",
    "Subject": "FW: Voicemail from (866) 521-6995",
    "IDs": "<004401d6d010$7db38720$791a9560$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Voicemail from Surendra",
    "Entity": "File",
    "Sub-type": "Mp3",
    "Date and time": "Dec 11, 2020, 4:59 PM",
    "Subject": "Fwd: Voicemail from (866) 521-6995",
    "IDs": "<854E8FD5-420D-466D-B83D-8A54669864CA@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Epoccam link shared by Philip",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Fri, Dec 11, 2020, 4:58 AM",
    "Subject": "Epoccam",
    "IDs": "<009801d6cfac$a2e2deb0$e8a89c10$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Chromacam beta download",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Dec 4, 2020, 5:54 PM",
    "Subject": "Re: New version of ChromaCam",
    "IDs": "<CAC=hQbn+sOVdDf6YxvP+65U3OE8m+qk96QUsfwi1+CRAo1V+ig@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Log from MeyerBrown",
    "Entity": "File",
    "Sub-type": "Log",
    "Date and time": "Dec 7, 2020, 11:10 AM",
    "Subject": "RE: New version of ChromaCam",
    "IDs": "<02f6a86c836b4147b838d5074e8001c2@mayerbrown.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "MSI manual from Jeremiah",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Dec 7, 2020, 11:33 AM",
    "Subject": "Re: New version of ChromaCam",
    "IDs": "<CAC=hQbmAiOO_7JZR+yMW-TWUuBeBV-LsaOPO9Wcgq=12RtaU_g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Enterprise installer sent by Jeremiah",
    "Entity": "Link",
    "Sub-type": "Google Drive (conxme)",
    "Date and time": "Dec 8, 2020, 6:24 PM",
    "Subject": "Re: New version of ChromaCam",
    "IDs": "<CAC=hQbnbye9LpfhguvKL=n+f=W8KCDmn-WZ18O=NgrVEMsgNoQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Slack link for Mac",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Dec 3, 2020, 9:28 PM",
    "Subject": "Sign-off for release Presenter for Mac 3.0.9.2 (full Account upgrade and status feature)",
    "IDs": "<CAL43u-VDK92pkC4-=awYUjobEbzyUyoWJ19Vi5HwXAroBJ5Exw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "CC signoff on slack",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Sat, Nov 28, 2020, 7:44 AM",
    "Subject": "RSign-off for release ChromaCam for Mac 1.0.2.61 (missing Slides feature, Apt-in, bug report, limit login 3 times, timestamp & drop fps...)",
    "IDs": "<CAL43u-VKbWh-qOVakvHbFiwg-7Wm+ODfTjqGH-cZN=-qjf4qww@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Recap by Holly",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Dec 9, 2020, 1:50 PM",
    "Subject": "Re: PP for Pexip",
    "IDs": "<A6CDD545-8CB5-4386-BD1C-06618A7E0010@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Datasheet to Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Dec 9, 2020, 1:50 PM",
    "Subject": "Re: PP for Pexip",
    "IDs": "<A6CDD545-8CB5-4386-BD1C-06618A7E0010@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Resignation draft for Sanjay",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Dec 7, 2020, 3:06 PM",
    "Subject": "Re: Remove Sanjay from Personify",
    "IDs": "<CAHz_o-4=x0FG9HUo1Dr3-PUxeGgA=Tds+3AFW75EHknTi2Sw9Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Officers certificate written by Christine",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Dec 8, 2020, 11:19 AM",
    "Subject": "Re: Remove Sanjay from Personify",
    "IDs": "<CAHz_o-4xPQGttWyR-C_nbaZTVtoTswHvYQE8OmyGgbCFjFoMHg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Resume from Patel",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 10, 2020, 10:45 AM",
    "Subject": "Interested in Software Engineering Internship at Personify",
    "IDs": "<F1FBC3A1-D3C9-4FF4-81BF-6CE7B00C827D@illinois.edu>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Link from Khoa",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Dec 7, 2020 at 12:30 PM Khoa Tran",
    "Subject": "Follow up on Internship position",
    "IDs": "<D40BA543-DE3D-4B64-B16A-C0A2B1EDF9FD@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Stock retention calculation",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Sun, 9 Jun 2019 at 12:06",
    "Subject": "Bonus/retention suggestion (via known stock model) for everyone in VNOffice",
    "IDs": "<CAL43u-XieTiiia63mTffpPdG5pAjyCuML76WefFHO7dPBay3SA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Long's stock",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Sun, 9 Jun 2019 at 12:06",
    "Subject": "Bonus/retention suggestion (via known stock model) for everyone in VNOffice",
    "IDs": "<CAL43u-XieTiiia63mTffpPdG5pAjyCuML76WefFHO7dPBay3SA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Total stock vn",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Sun, 9 Jun 2019 at 12:06",
    "Subject": "Bonus/retention suggestion (via known stock model) for everyone in VNOffice",
    "IDs": "<CAL43u-XieTiiia63mTffpPdG5pAjyCuML76WefFHO7dPBay3SA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Stock rate sent by Long",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Sun, 9 Jun 2019 at 12:06",
    "Subject": "Bonus/retention suggestion (via known stock model) for everyone in VNOffice",
    "IDs": "<CAL43u-XieTiiia63mTffpPdG5pAjyCuML76WefFHO7dPBay3SA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Total vn budget",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Sun, 9 Jun 2019 at 12:06",
    "Subject": "Bonus/retention suggestion (via known stock model) for everyone in VNOffice",
    "IDs": "<CAL43u-XieTiiia63mTffpPdG5pAjyCuML76WefFHO7dPBay3SA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "VN bonus",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Mon, Dec 7, 2020, 5:28 PM",
    "Subject": "Bonus for VN team v1.2.xlsx",
    "IDs": "<0000000000003cba4905b5e82f12@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Aryaman's cv",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 10, 2020, 1:35 P",
    "Subject": "Software Engineer Intern position",
    "IDs": "<CAO8CUwatKc6GNOGXTh-H30QmdHNOZmZ8zc3m6jMsKLQ337chyg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "License agreement with Pexip",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Wednesday, December 2, 2020 9:54 PM",
    "Subject": "Personify - License Agreement - Pexip_V5.0(1 Dec 2020) (002)",
    "IDs": "<004701d6c8a3$51c4e150$f54ea3f0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Signed agreement from Personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 2, 2020, 6:52 PM",
    "Subject": "회신: Personify - License Agreement - Pexip_V5.0(1 Dec 2020) (002)",
    "IDs": "<009a01d6c90e$9111b430$b3351c90$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Signed contract by Tom Erik",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 7, 2020, 3:15 AM",
    "Subject": "RE: Personify - License Agreement - Pexip_V5.0(1 Dec 2020) (002)",
    "IDs": "<AS8PR01MB7560884048CADD2D532AC2A2C6CE0@AS8PR01MB7560.eurprd01.prod.exchangelabs.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Marketing draft from Ian",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Fri, Dec 4, 2020, 3:24 PM",
    "Subject": "Draft Marketing Agreement",
    "IDs": "<F4F2AF5D-CFE2-4A2B-B377-59102FC59D73@quinnpacific.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Due dilingence by Ian",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Fri, Dec 4, 2020, 3:24 PM",
    "Subject": "Draft Marketing Agreement",
    "IDs": "<F4F2AF5D-CFE2-4A2B-B377-59102FC59D73@quinnpacific.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "All chromacam versions by Long",
    "Entity": "Link",
    "Sub-type": "Google Drive",
    "Date and time": "Dec 2, 2020, 9:17 AM",
    "Subject": "Re: PC Specs for Migros Bank",
    "IDs": "<CAL43u-X_L3gC9in57y4GRBdP4=CBoHzjuj46kjDZ5GVKXrKgwA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "No login watermark msi",
    "Entity": "Link",
    "Sub-type": "Google Drive",
    "Date and time": "Dec 2, 2020, 9:17 AM",
    "Subject": "Re: PC Specs for Migros Bank",
    "IDs": "<CAL43u-X_L3gC9in57y4GRBdP4=CBoHzjuj46kjDZ5GVKXrKgwA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "November salaries shared by Long",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Dec 2, 2020, 10:07 AM",
    "Subject": "Operation expense estimate 2020-12",
    "IDs": "<CAL43u-V4wagQu9PB4PWxXvCXUX10N1XrBJ7agsUsrQwgipiJcA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Vietnam costs for december",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Dec 2, 2020, 10:07 AM",
    "Subject": "Operation expense estimate 2020-12",
    "IDs": "<CAL43u-V4wagQu9PB4PWxXvCXUX10N1XrBJ7agsUsrQwgipiJcA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Screenshots from Long",
    "Entity": "File",
    "Sub-type": "Image",
    "Date and time": "Dec 3, 2020, 9:52 PM",
    "Subject": "Re: Operation expense estimate 2020-12",
    "IDs": "<CAL43u-VvOdPvyuK1M7pzuGMcn2E4upL96+T9LswGKezEBccesw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Roadmap shared by Khoa",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Wed, Dec 2, 2020, 5:23 PM",
    "Subject": "SDK / R&D Roadmap - Invitation to edit",
    "IDs": "<0000000000003ddc0005b583888f@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Slack receipt from Simon",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Dec 2, 2020, 12:28 PM",
    "Subject": "[Slack Receipt] Re: Credit Card not going through on Slack",
    "IDs": "<CALV-+1fP88ZNLQ3rez-Tw-FfiNq5H+bs2ME8we2aKWOOjLSH8g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "DNS slides shared by Suresh",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Tue, Dec 1, 2020, 5:01 PM",
    "Subject": "RE: Responses to Technical Questions",
    "IDs": "<DM6PR11MB26357FD69DD1D0520BCA0ECD9FF40@DM6PR11MB2635.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Nov financial report by Dustin",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Dec 1, 2020, 2:14 PM",
    "Subject": "Financial Reporting Package-Personify 2020 11.xlsx",
    "IDs": "<MWHPR0801MB3722EC05EE9F1A2E01597A0087F40@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "November report to Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Dec 1, 2020, 2:14 PM",
    "Subject": "Financial Reporting Package-Personify 2020 11.xlsx",
    "IDs": "<MWHPR0801MB3722EC05EE9F1A2E01597A0087F40@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Jabber demo from Khoa",
    "Entity": "File",
    "Sub-type": "Mp4",
    "Date and time": "Oct 19, 2020, 1:35 PM",
    "Subject": "Re: BOA Jabber issue",
    "IDs": "<D173EF1D-8CE1-49C5-AC54-A2B61B4A2387@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Evaluation link from Simon",
    "Entity": "Link",
    "Sub-type": "Google Drive (conxme)",
    "Date and time": "Nov 18, 2020, 12:51 PM",
    "Subject": "Re: BOA Jabber issue",
    "IDs": "<CALV-+1e6PPL_M8cQX31kGgJSy6yP4PuL91F+6h+ScudYsRFfsA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Evaluation link to David",
    "Entity": "Link",
    "Sub-type": "Google Drive (conxme)",
    "Date and time": "Nov 18, 2020, 12:51 PM",
    "Subject": "Re: BOA Jabber issue",
    "IDs": "<CALV-+1e6PPL_M8cQX31kGgJSy6yP4PuL91F+6h+ScudYsRFfsA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify eula",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Nov 30, 2020, 3:41 PM",
    "Subject": "00023296 RE: Contact Form [ ref:_00DG0Cbyq._5001M1d3nD5:ref ]",
    "IDs": "<aslH5000000000000000000000000000000000000000000000QKMPLK00Ibtrp9xrRf2FaoCKkf4FGg@sfdc.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "2621 signoff on slack",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Mon, Nov 23, 2020, 10:40 AM",
    "Subject": "Re: Windows 2.6.2.0 Release Notes",
    "IDs": "<CAL43u-ViLVgS2C+NqBtMCD53W+57q52Ri07TakbE3jkBkYCK+A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Resume sent by Ragini",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 29, 2020, 8:27 PM",
    "Subject": "Personify Software Engineering Internship- Resume, Coverletter",
    "IDs": "<CH2PR11MB429410E1A42B8A970A8EF5AAF4F50@CH2PR11MB4294.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Cover letter written by Ragini",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 29, 2020, 8:27 PM",
    "Subject": "Personify Software Engineering Internship- Resume, Coverletter",
    "IDs": "<CH2PR11MB429410E1A42B8A970A8EF5AAF4F50@CH2PR11MB4294.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Vendor information form sent by Dustin",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Nov 18, 2020, 12:58 PM",
    "Subject": "RE: New legal contact for Personify",
    "IDs": "<091AE6AF-D937-4589-B954-68F0761ED170@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "W9 shared by Christine",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 19, 2020, 9:57 AM",
    "Subject": "Re: New legal contact for Personify",
    "IDs": "<CAHz_o-4ryZad1SYnAedL_htefV6CF8LPv6t0-jks=KN3W_E5QQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "VIF compiled by Christine",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Nov 19, 2020, 9:57 AM",
    "Subject": "Re: New legal contact for Personify",
    "IDs": "<CAHz_o-4ryZad1SYnAedL_htefV6CF8LPv6t0-jks=KN3W_E5QQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Farmer engagement letter",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 19, 2020, 9:57 AM",
    "Subject": "Re: New legal contact for Personify",
    "IDs": "<CAHz_o-4ryZad1SYnAedL_htefV6CF8LPv6t0-jks=KN3W_E5QQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Conxme resume from surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 17, 2020, 5:06 PM",
    "Subject": "ConxM candidate",
    "IDs": "<ABBEC111-89A9-4B2D-AAF1-A4128032E7CD@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Clion link from Viet",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, Nov 18, 2020, 2:45 AM",
    "Subject": "[R&D] Development IDE",
    "IDs": "<CAMovQvdPSbaRH0=7bbgtU9qoxVAOKDUuZ2M-=fRHuquy5iRGuQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "BVS NDA from Philip",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Nov 12, 2020, 12:54 AM",
    "Subject": "전달: Reviewed NDA",
    "IDs": "<00ad01d6b8c0$b6e85780$24b90680$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "bvs nda signed",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 13, 2020, 4:38 PM",
    "Subject": "Re: Reviewed NDA",
    "IDs": "<36F29111-68B9-4946-8C44-E1FC26751369@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "New machine by Viet",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, Nov 11, 2020, 8:06 PM",
    "Subject": "[SDK] Hardware request for ARM64 support",
    "IDs": "<CAMovQvfK6KzSjWZRabYfYcnjOnZ6q5fXJjrNeW1GWuAFhB5w4w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Models sent by Holly",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Thu, Nov 12, 2020, 8:37 PM",
    "Subject": "Re: Presenter MKT material",
    "IDs": "<874FDCA9-AC1E-44D2-9403-F0F089852EE4@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Templates shared with Philip",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Thu, Nov 12, 2020, 8:37 PM",
    "Subject": "Re: Presenter MKT material",
    "IDs": "<874FDCA9-AC1E-44D2-9403-F0F089852EE4@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Applications by Khoa",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Tue, Nov 10, 2020, 9:04 PM",
    "Subject": "Intern Applications - jobs@personifyinc.com - Invitation to collaborate",
    "IDs": "<000000000000b7f25205b3cc0e4f@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Good resume sent by Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, Nov 10, 2020, 10:47 AM",
    "Subject": "Really good resume",
    "IDs": "<0CC609E8-0232-408B-B157-4BD4CD80FD69@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Linkedin customer by Simon",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Nov 9, 2020, 11:43 AM",
    "Subject": "Hopin.to",
    "IDs": "<CALV-+1ftS8Z2N=L5n68e5Ef+7EOM40JhRNz-rG9YQjZf2y2ZHw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Jira notification from Long",
    "Entity": "Link",
    "Sub-type": "Jira",
    "Date and time": "Fri, Nov 6, 2020, 1:01 AM",
    "Subject": "[JIRA] Long Truong mentioned you on APPS-1424",
    "IDs": "<01EPE5R1WA9V9YEWD6430ERF5G@personify.atlassian.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Maintainance at Oak Creek",
    "Entity": "Date",
    "Sub-type": "",
    "Date and time": "Oct 6, 2020, 6:25 PM",
    "Subject": "1551 McCarthy Blvd., Milpitas - Notice",
    "IDs": "<BYAPR05MB44711EDE368BC986568DE1E4A90D0@BYAPR05MB4471.namprd05.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Windows desktop from Mike",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Sat, Aug 8, 2020 at 12:27 AM",
    "Subject": "Re: [EXTERNAL] personify: psycameratransforms.dll failing",
    "IDs": "<CAL43u-WLSV=P1SyG=5_NC5GPmMNTJCuoan1nKT3UTHCEY-vyGg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Evaluation agreement from Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 5, 2020, 5:19 AM",
    "Subject": "ClassPoint Singapore startup NDA & Eval. agreement",
    "IDs": "<00ad01d6b365$91436430$b3ca2c90$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Nondisclosure agreement Inknoe",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 5, 2020, 5:19 AM",
    "Subject": "ClassPoint Singapore startup NDA & Eval. agreement",
    "IDs": "<00ad01d6b365$91436430$b3ca2c90$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Inknoe evaluation to Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 5, 2020, 10:37 AM",
    "Subject": "Re: ClassPoint Singapore startup NDA & Eval. agreement",
    "IDs": "<F11BB8A7-E503-4DD4-B521-87482A6B9C84@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Inknoe nondisclosure to Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 5, 2020, 10:37 AM",
    "Subject": "Re: ClassPoint Singapore startup NDA & Eval. agreement",
    "IDs": "<F11BB8A7-E503-4DD4-B521-87482A6B9C84@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Release notes from Long",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Mon, Nov 2, 2020, 5:38 AM",
    "Subject": "Sign-off for release ChromaCam for Mac 1.0.2.56 (missing Slides feature, Apt-in, bug report, limit login 3 times...)",
    "IDs": "<CAL43u-WbC_SxkL8DJr9dCyv9Mx4po4oA7vHtDFdPy02oCVZ8WA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Test reports from Long",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Mon, Nov 2, 2020, 5:38 AM",
    "Subject": "Sign-off for release ChromaCam for Mac 1.0.2.56 (missing Slides feature, Apt-in, bug report, limit login 3 times...)",
    "IDs": "<CAL43u-WbC_SxkL8DJr9dCyv9Mx4po4oA7vHtDFdPy02oCVZ8WA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Oct results sent by Dustin",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Nov 2, 2020, 3:19 PM",
    "Subject": "Personify Oct Financials",
    "IDs": "<MWHPR0801MB3722FD2B387B4510B4CCC8CF87100@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "October results shared with Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Nov 2, 2020, 3:19 PM",
    "Subject": "Personify Oct Financials",
    "IDs": "<MWHPR0801MB3722FD2B387B4510B4CCC8CF87100@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Vendor info form from Dustin",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Fri, Oct 9, 2020, 2:30 PM",
    "Subject": "RE: Sanjay's monthly fee",
    "IDs": "<5AE0D94F-4A1C-4E83-A656-6B5A245AB38E@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Compiled vendor form by Sanjay",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Nov 2, 2020, 12:25 PM",
    "Subject": "Re: Sanjay's monthly fee",
    "IDs": "<4A6DCF04-3D0D-420D-9D63-FA8B186BE717@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Phase 2 plan from Long",
    "Entity": "Link",
    "Sub-type": "Atlassian",
    "Date and time": "Wed, Oct 28, 2020, 11:52 PM",
    "Subject": "Re: Bank of America Hai's Demo Cisco Jabber",
    "IDs": "<CAL43u-U1xhjMFtdmsk-Jqz=KPDSMdZZeFuFr_u8Wt6akG3AGTQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Phase 2 link to Simon",
    "Entity": "Link",
    "Sub-type": "Atlassian",
    "Date and time": "Wed, Oct 28, 2020, 11:52 PM",
    "Subject": "Re: Bank of America Hai's Demo Cisco Jabber",
    "IDs": "<CAL43u-U1xhjMFtdmsk-Jqz=KPDSMdZZeFuFr_u8Wt6akG3AGTQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Machines links from Viet",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Fri, Oct 30, 2020, 4:07 AM",
    "Subject": "[SDK] Hardware request",
    "IDs": "<CAMovQveyex_ZOigdrJArj9EV-bzFGw_WLSY8_3vyKYAx_5cu7g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Github account",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Fri, Oct 30, 2020, 12:28 PM",
    "Subject": "Need a generic email account",
    "IDs": "<5015493B-96F9-4465-BB40-099503A7F750@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Jd draft sent by Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Mon, Oct 26, 2020, 5:32 PM",
    "Subject": "UIUC intern",
    "IDs": "<A5AA3C9A-8F7D-4E6F-953E-50F678A0236F@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Updated job description",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Oct 29, 2020, 2:44 PM",
    "Subject": "Re: UIUC intern",
    "IDs": "<458B48D3-DEB3-4AB3-96E0-6D2A49993C4C@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Definitive jd sent by Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Oct 29, 2020, 3:10 PM",
    "Subject": "Re: UIUC intern",
    "IDs": "<DDB3C628-E80E-40E1-BA6B-AFB68335DC57@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Deepar github from Simon",
    "Entity": "Link",
    "Sub-type": "Github",
    "Date and time": "Oct 30, 2020, 3:32 AM",
    "Subject": "Fwd: I'd like to learn more about integrating deepar into our video conf...",
    "IDs": "<BYAPR08MB5543181186A1FB2F29EEF684A5150@BYAPR08MB5543.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Collaboration folder from Khoa",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Thu, Oct 29, 2020, 6:50 PM",
    "Subject": "LongD/Cong collaboration - Invitation to edit",
    "IDs": "<00000000000077441805b2d7f27b@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Pricing slide by Philip",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Tue, Oct 27, 2020, 6:26 PM",
    "Subject": "DeepAR and pricing",
    "IDs": "<002601d6acb8$a17fde40$e47f9ac0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Virtual AV estimate",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Sun, Oct 25, 2020, 11:37 PM",
    "Subject": "Estimate #14 from Virtual AV",
    "IDs": "<E8FD6AB1-377B-4E26-9E62-15D54CB66D9A@virtualav.io>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "rd jd from viet",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "Fri, Oct 23, 2020, 10:23 PM",
    "Subject": "[JD-R&D] Javascript, iOS, Android Engineering for R&D Teams",
    "IDs": "<CAMovQveVV47foL+ZPpkM3RGgnvfx6Pd=UO2Z+K7ip=7zb0Yigg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "New jd shared by Long",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "Oct 24, 2020, 6:58 AM",
    "Subject": "Re: [JD-R&D] Javascript, iOS, Android Engineering for R&D Teams",
    "IDs": "<CAL43u-UDgM__Rrf=XesSe_a7eGkcPCUqduWQfs4YOCHAJTVCCg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Senior engineer folder",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Thu, Oct 22, 2020, 7:12 PM",
    "Subject": "Senior Research and Product Development Engineer (C++, Algorithm, R&D) - Invitation to edit",
    "IDs": "<00000000000067dd9f05b24b6e08@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Comment by Simon on Jira",
    "Entity": "Link",
    "Sub-type": "Jira",
    "Date and time": "Thu, Oct 22, 2020, 3:51 PM",
    "Subject": "[JIRA] Simon Ng mentioned you on APPS-1382",
    "IDs": "<01EN918WJM62RMBDH0QZD0FM5D@personify.atlassian.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Finastra problems",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Oct 12, 2020, 6:14 AM",
    "Subject": "RE: FW: [EXT] RE: Cannot get past login screen [ ref:_00DG0Cbyq._5001M1aehi4:ref ]",
    "IDs": "<HE1PR08MB2923CE9DA4FE28609801DC0FE0070@HE1PR08MB2923.eurprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Issues list from Simon",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Oct 12, 2020, 5:44 PM",
    "Subject": "Fwd: FW: [EXT] RE: Cannot get past login screen [ ref:_00DG0Cbyq._5001M1aehi4:ref ]",
    "IDs": "<CALV-+1dGsU=XE9haZbTszuU+DJHVmUAAyaJXA4MNpGUbHGtwKQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Updated finastra issues",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Oct 14, 2020, 4:47 AM",
    "Subject": "RE: FW: [EXT] RE: Cannot get past login screen [ ref:_00DG0Cbyq._5001M1aehi4:ref ]",
    "IDs": "<HE1PR08MB292354AD13A806B2585DDBB2E0050@HE1PR08MB2923.eurprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Cisco assessment",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Oct 16, 2020, 10:50 AM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<D89C8A3B-D7AF-4A02-935A-BB063E4CFF55@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Assesment from Khoa",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Oct 16, 2020, 10:50 AM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<D89C8A3B-D7AF-4A02-935A-BB063E4CFF55@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Trip survey from Long",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Oct 15, 2020, 6:34 PM",
    "Subject": "Re: Team building trip 2020 options to get approval.",
    "IDs": "<CAL43u-WTaPup3z39fUth-wNJqB2NcRX45ksyU8cxfg1csusunQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Jira comment from Khoa",
    "Entity": "Link",
    "Sub-type": "Jira",
    "Date and time": "Wed, Oct 14, 2020, 6:18 PM",
    "Subject": "[JIRA] Khoa Tran mentioned you on APPS-1196",
    "IDs": "<01EMMPG2J2JRRSNFHY1JAEE294@personify.atlassian.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Car invoice from Lisa",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tuesday, October 13, 2020 6:07 PM",
    "Subject": "FW: Invoice # 9539-1",
    "IDs": "<3132F165-B2ED-46F7-80AB-1A4EA1F56DDC@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Guide from Loi",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "Tue, Oct 13, 2020, 2:50 AM",
    "Subject": "QLM Quick Guide - Invitation to edit",
    "IDs": "<0000000000008013d005b188acb8@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Pilot from Andrew",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Wed, Jul 8, 2020 at 4:27 PM",
    "Subject": "Re: today's call",
    "IDs": "<CAEU0P5aX3HeT=mEQghVge-v-wR_1SyXDLo7dahp09MHd47Oy6w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "James number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Fri, Oct 9, 2020, 10:24 AM",
    "Subject": "RE: ChromaCam",
    "IDs": "<ad29db05880d424b92c12c4c6153f7a0@mayerbrown.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Rack from Surendra",
    "Entity": "Link",
    "Sub-type": "Amazon",
    "Date and time": "Wed, Oct 7, 2020, 3:14 PM",
    "Subject": "1551 McCarthy 113 project",
    "IDs": "<D7BCCCCC-33A0-4ACD-A3DE-EE09F027A2E4@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Rack found by Ramon",
    "Entity": "Link",
    "Sub-type": "Amazon",
    "Date and time": "Oct 8, 2020, 9:54 AM",
    "Subject": "RE: 1551 McCarthy 113 project",
    "IDs": "<BYAPR08MB5061697C83430F607547A8ABC20B0@BYAPR08MB5061.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Test results from Khoa",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Wed, Sep 16, 2020, 1:14 PM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<46FFFC85-FEB4-41E3-A6BA-00CD423ED22E@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Comparison results to Keith",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Wed, Sep 16, 2020, 1:14 PM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<46FFFC85-FEB4-41E3-A6BA-00CD423ED22E@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Rsupport link from Philip",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Sun, Oct 4, 2020, 11:09 PM",
    "Subject": "회신: Notice of Information, From Haeden Bridge",
    "IDs": "<004801d69acd$469ac690$d3d053b0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Jeremiah's external ip",
    "Entity": "Location",
    "Sub-type": "IP address",
    "Date and time": "Sep 30, 2020, 3:23 PM",
    "Subject": "Re: Offline Activation Product Management",
    "IDs": "<CAC=hQbmRErJkK2k9BExLWWgF-2vskw41jKDvribV20iuMSczYQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "AMD laptop link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Tuesday, August 11, 2020 at 2:47 AM",
    "Subject": "RE: StarLeaf / Personify",
    "IDs": "<CAKVuy5Gtb9_BuN1k0d0B4rT+K5pYAKO6JNGy4ykEkhh_b_hpcA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Core update sent to Sam",
    "Entity": "Link",
    "Sub-type": "Dropbox",
    "Date and time": "Wednesday, August 5, 2020 at 3:02 AM",
    "Subject": "Re: StarLeaf / Personify",
    "IDs": "<CAKVuy5Gtb9_BuN1k0d0B4rT+K5pYAKO6JNGy4ykEkhh_b_hpcA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify update from Andrew",
    "Entity": "Link",
    "Sub-type": "Dropbox",
    "Date and time": "Wednesday, August 5, 2020 at 3:02 AM",
    "Subject": "Re: StarLeaf / Personify",
    "IDs": "<CAKVuy5Gtb9_BuN1k0d0B4rT+K5pYAKO6JNGy4ykEkhh_b_hpcA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Starleaf user revenue",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Sep 18, 2020, 5:12 AM",
    "Subject": "Re: StarLeaf / Personify commercial discussion",
    "IDs": "<AM7P194MB07563C7754A0BF7B2CE244CB823F0@AM7P194MB0756.EURP194.PROD.OUTLOOK.COM>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "New test link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Thu, Oct 1, 2020, 8:45 PM",
    "Subject": "[Campaign sent] Apology with NEW Test Link",
    "IDs": "<01000174e6fcaa72-ee8e5ca2-b148-433f-9029-c239b7b18c1f-000000@email.amazonses.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Correct study link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Thu, Oct 1, 2020, 5:55 PM",
    "Subject": "Re: Invitation to card-sorting study for ChromaCam",
    "IDs": "<CALV-+1fGounj_qVLJZBbAr4sfuWXCr9Y0e1RJ0F+10dsAEYLdg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify sentry file",
    "Entity": "File",
    "Sub-type": "Csv",
    "Date and time": "Thu, Sep 17, 2020, 1:50 PM",
    "Subject": "Re: FW: Bulk purchase [ ref:_00DG0Cbyq._5001M1ay2Fy:ref",
    "IDs": "<CAN6k-eWFcyN2j3KCK+3rCV-mKWWTxVhNuPcPWWjCd2q0wy3ACQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Member list from sentry",
    "Entity": "File",
    "Sub-type": "Csv",
    "Date and time": "Sep 17, 2020, 4:14 PM",
    "Subject": "RE: FW: Bulk purchase [ ref:_00DG0Cbyq._5001M1ay2Fy:ref ]mailed-by:sentryone.com",
    "IDs": "<CAN6k-eWFcyN2j3KCK+3rCV-mKWWTxVhNuPcPWWjCd2q0wy3ACQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Hitachi slides from Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Sep 24, 2020, 5:40 AM",
    "Subject": "전달: Thank you for the meeting / Hitachi Solutions",
    "IDs": "<018701d6925f$3015ece0$9041c6a0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Presenter ussues video",
    "Entity": "Link",
    "Sub-type": "Google Drive",
    "Date and time": "Sep 29, 2020, 5:55 PM",
    "Subject": "Presenter 2 screen issue on Windows",
    "IDs": "<CAC=hQb=jm5k9hrQ9xthYjWY5fQN7eFdWQHcEiPBSi8RG9ey+HQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Oracles machines",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Aug 21, 2020, 6:42 AM",
    "Subject": "RE: Personify introductions of new team and version 3.0 / Quotation #0222640904 Personify Presenter 3.0",
    "IDs": "<7469c121-fc22-46ec-9722-3872f0ff1112@default>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Offscreen video sent to Iulian",
    "Entity": "Link",
    "Sub-type": "Google Drive",
    "Date and time": "Sep 25, 2020, 5:37 PM",
    "Subject": "Re: Personify introductions of new team and version 3.0 / Quotation #0222640904 Personify Presenter 3.0",
    "IDs": "<CAC=hQbmF+pm7w2J8nBxid22hivKL1yruCSYZAB43Lr6LnX5TBQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "GPU-Z App",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "9/1/2020 6:13 PM",
    "Subject": "Personna is freezing while using it [ ref:_00DG0Cbyq._5001M1ayP73:ref ]",
    "IDs": "<DB7PR08MB3724EDEF76C45A907F1FB7C59F3F0@DB7PR08MB3724.eurprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "LMI slides from Khoa",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Sep 28, 2020, 6:01 PM",
    "Subject": "Re: Personify SDK Integration",
    "IDs": "<DC322CC2-5210-4A8F-926F-1D3FEDFEAD64@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "sdk evolution slides",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Mon, Sep 28, 2020, 6:00 PM",
    "Subject": "Personify SDK Improvements - Invitation to edit",
    "IDs": "<0000000000006e4e8805b067a27a@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Preliminary september results",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Sep 28, 2020, 4:35 PM",
    "Subject": "Financial Reporting Package-Personify 2020 09.xlsx",
    "IDs": "<MWHPR0801MB372277142BECADFC47BFD59687350@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "PortraitNet",
    "Entity": "Link",
    "Sub-type": "Github",
    "Date and time": "Friday, September 4, 2020 3:28 PM",
    "Subject": "Re: Proposition - Personify SDK",
    "IDs": "<010501d68284$9dbdbd80$d9393880$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Link to Openvino",
    "Entity": "Link",
    "Sub-type": "Github",
    "Date and time": "Friday, September 4, 2020 3:28 PM",
    "Subject": "Re: Proposition - Personify SDK",
    "IDs": "<010501d68284$9dbdbd80$d9393880$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Slides from Viet",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Sep 24, 2020, 6:11 PM",
    "Subject": "Re: [Source Code Protection] Share source code with Cisco team",
    "IDs": "<93168EF1-993C-461A-9AFF-89DD5D66C04B@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "UPS machines from Long",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Sep 21, 2020, 11:16 AM",
    "Subject": "Fwd: UPS request",
    "IDs": "<CAL43u-Vz7dR5W_4sLZ7JMCv0-p-KGOMgqHw3L=NmEDhQh2gQHA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Charging station agreemen from Gin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Sep 23, 2020, 2:09 PM",
    "Subject": "1551 McCarthy Blvd., Milpitas",
    "IDs": "<BYAPR05MB447170E7F10E397F56CB7DD0A9380@BYAPR05MB4471.namprd05.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Calc sheet by Ginny",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Sep 23, 2020, 2:09 PM",
    "Subject": "1551 McCarthy Blvd., Milpitas",
    "IDs": "<BYAPR05MB447170E7F10E397F56CB7DD0A9380@BYAPR05MB4471.namprd05.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "AIE sent by Dustin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Sep 22, 2020, 2:58 PM",
    "Subject": "RE: Personify Payments",
    "IDs": "<46768C91-68A2-4CC6-836B-806DD3376293@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "PG&E number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Sep 22, 2020, 12:44 PM",
    "Subject": "PG&E and Internet",
    "IDs": "<CAKVuy5Fp9-iAMxjqfAY=jFoYa6REBeiT=zGrGk5j4Joa3tsVcA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "AT&T number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Sep 22, 2020, 12:44 PM",
    "Subject": "PG&E and Internet",
    "IDs": "<CAKVuy5Fp9-iAMxjqfAY=jFoYa6REBeiT=zGrGk5j4Joa3tsVcA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Ginny Poole's phone",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Sep 22, 2020, 12:44 PM",
    "Subject": "PG&E and Internet",
    "IDs": "<CAKVuy5Fp9-iAMxjqfAY=jFoYa6REBeiT=zGrGk5j4Joa3tsVcA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Account number from Dustin",
    "Entity": "Account number",
    "Sub-type": "",
    "Date and time": "Tue, Sep 22, 2020, 1:23 PM",
    "Subject": "RE: PG&E and Internet",
    "IDs": "<MWHPR0801MB37226503D78CEF8D89C59E08873B0@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Enteprise setup from Loi",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Tue, Sep 22, 2020, 4:56 AM",
    "Subject": "Personify.Presenter.Enterprise.3.0.5.1-Setup.exe",
    "IDs": "<000000000000c123fd05afe3fbf7@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Key form Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wednesday, September 16, 2020 8:16 PM",
    "Subject": "My contact info",
    "IDs": "<BYAPR05MB4471AA18C6BF44AE794CC273A93F0@BYAPR05MB4471.namprd05.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Performance comparison for psyseg",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Fri, Sep 18, 2020 at 4:17 AM",
    "Subject": "Re: Compare about performance for 3.5.18 and latest release",
    "IDs": "<CAO+SG-0CTFBrMP6PG08JmvmwjM215hj-E1aSRR0XSWf-ihnOuw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "s/w signed by Caregility",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Sunday, July 5, 2020 at 11:46 PM",
    "Subject": "S/W evaluation agreement",
    "IDs": "<BL0PR0102MB34425ECC1F8079348D34BDB4AA7E0@BL0PR0102MB3442.prod.exchangelabs.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Evaluation agreement from Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jul 15, 2020, 7:51 PM",
    "Subject": "Re: Software Evaluation Agreement_Personify Inc._Caregility",
    "IDs": "<FCC962D5-D6B2-40CD-B690-5538D7695E09@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Complete agreement from Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jul 15, 2020, 8:30 PM",
    "Subject": "회신: Software Evaluation Agreement_Personify Inc._Caregility",
    "IDs": "<00a501d65b10$a13cd090$e3b671b0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Complete agreement sent to Roger",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jul 15, 2020, 8:30 PM",
    "Subject": "회신: Software Evaluation Agreement_Personify Inc._Caregility",
    "IDs": "<00a501d65b10$a13cd090$e3b671b0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Issues list from Khoa",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Tue, Sep 15, 2020, 12:58 PM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<268B671F-41C3-4C8A-A132-645D336664F3@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Current issues with Cisco",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Sep 16, 2020, 10:56 AM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<22E68023-E9B4-4069-A7E6-9B75EEF817F3@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Current issues with Presenter",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Sep 16, 2020, 10:56 AM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<22E68023-E9B4-4069-A7E6-9B75EEF817F3@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Support evolution slide",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Sep 16, 2020, 10:56 AM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<22E68023-E9B4-4069-A7E6-9B75EEF817F3@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Mac performance comparison",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Sep 16, 2020, 1:14 PM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<46FFFC85-FEB4-41E3-A6BA-00CD423ED22E@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Khoa's number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Wed, Sep 2, 2020, 1:22 PM",
    "Subject": "Re: Enterprise release please share",
    "IDs": "<BD434A92-7288-463B-868F-FDEA5404B8DA@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Summary of tickets from Loron",
    "Entity": "List",
    "Sub-type": "",
    "Date and time": "Tue, Sep 15, 2020, 5:29 PM",
    "Subject": "09/15/2020 Summary of tickets for sales team",
    "IDs": "<019901d68baf$be4f8b30$3aeea190$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify's ECCN from Susan",
    "Entity": "Code",
    "Sub-type": "",
    "Date and time": "Mon, Sep 14, 2020 at 10:45 AM",
    "Subject": "RE: ENNC",
    "IDs": "<DM5PR08MB295662D2363D6B07660FDD838A230@DM5PR08MB2956.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Who's starleaf VP of product",
    "Entity": "Link",
    "Sub-type": "Linkedin",
    "Date and time": "Wed, Jun 17, 2020, 4:55 AM",
    "Subject": "Fwd: StarLeaf / Personify",
    "IDs": "<CAEU0P5aJQSY-Yix6ZRRqnphtf=6irfOm+srNqz55KKDFTAJVKw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Sample eval agreement",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Jun 17, 2020, 3:31 PM",
    "Subject": "Re: StarLeaf / Personify",
    "IDs": "<CAEU0P5bzyMEeJ-4V=bn_2HN=Ke33XWzjff1x8KRGBDcm1O8G_g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Evaluation agreement draft from Personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Jun 17, 2020, 3:31 PM",
    "Subject": "Re: StarLeaf / Personify",
    "IDs": "<CAEU0P5bzyMEeJ-4V=bn_2HN=Ke33XWzjff1x8KRGBDcm1O8G_g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Definitive evaluation agreement from Andrew",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jun 18, 2020 at 2:32 PM",
    "Subject": "Re: StarLeaf / Personify",
    "IDs": "<CAEU0P5ZMHtQmTozUicAYUibh=958PGVM111_c8eJENJeF+bM1Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Definitive starleaf eval agreement",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jun 18, 2020 at 2:32 PM",
    "Subject": "Re: StarLeaf / Personify",
    "IDs": "<CAEU0P5ZMHtQmTozUicAYUibh=958PGVM111_c8eJENJeF+bM1Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Update link from Andrew",
    "Entity": "Link",
    "Sub-type": "Dropbox",
    "Date and time": "Wed, Aug 5, 2020, 5:01 AM",
    "Subject": "Re: StarLeaf / Personify",
    "IDs": "<CAEU0P5ZSNaXScPD3SLm94dD3zOXstW0-jGDFBS0DaLq79ckZmQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Video outline from Jeremiah",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Sep 10, 2020, 11:48 AM",
    "Subject": "Jeremiah Barkman shared \"ConXChat Video Outline Draft 1\" with you.",
    "IDs": "<CO2PR0801MB231250B204D0CBCF39D1C87CCD270@CO2PR0801MB2312.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Stability issues from Khoa",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Wed, Sep 9, 2020, 12:49 PM",
    "Subject": "SDK stability issues - Invitation to edit",
    "IDs": "<0000000000003b939605aee5131a@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Mooncake budget by Long",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Wed, Sep 9, 2020, 4:18 AM",
    "Subject": "Fwd: Quotation for preparing Moon cake 2020",
    "IDs": "<CAL43u-VjfZbdotXZ=9coVNuDyeztjU0vrmd9eBZLCjDEfY4_Xw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "QLM Presenter keys",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Tue, Sep 8, 2020, 11:30 PM",
    "Subject": "QLM Activation Keys for Presenter (Win and Mac) - Invitation to edit",
    "IDs": "<000000000000a3bf3305aed9ea8e@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "iPhone suggestion from Viet",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Sep 7, 2020, 2:25 AM",
    "Subject": "[Resource Request] IPhoneX for SDK iOS support",
    "IDs": "<CAMovQvchvo1wvWQ_FK1Ln4-b0vQVikYxB4gyJuJxABc9f3-Ogg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Sales summary sent by Philip",
    "Entity": "Link",
    "Sub-type": "Google Analytics",
    "Date and time": "Sat, Sep 5, 2020, 10:15 PM",
    "Subject": "Web sales summary ANZ - August 2020",
    "IDs": "<003201d683fc$0c501360$24f03a20$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Net summer revenue from Philip",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Sep 3, 2020, 8:51 AM",
    "Subject": "Partner Rev Share data",
    "IDs": "<01ea01d681f9$456e61b0$d04b2510$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Link for Google Analytics Korea",
    "Entity": "Link",
    "Sub-type": "Google Analytics",
    "Date and time": "Sep 3, 2020, 8:51 AM",
    "Subject": "Partner Rev Share data",
    "IDs": "<01ea01d681f9$456e61b0$d04b2510$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Link for Google Analytics Japan",
    "Entity": "Link",
    "Sub-type": "Google Analytics",
    "Date and time": "Sep 3, 2020, 8:51 AM",
    "Subject": "Partner Rev Share data",
    "IDs": "<01ea01d681f9$456e61b0$d04b2510$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Summer revenue corrected by Dustin",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Thu, Sep 3, 2020 at 2:17 PM",
    "Subject": "RE: Partner Rev Share data",
    "IDs": "<3E0F736A-0B5E-4084-9333-4533975FD02F@hxcore.ol>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Nvidia blog shared by Surendra",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, Aug 26, 2020, 9:38 PM",
    "Subject": "Re: Your offer letter to Pexip",
    "IDs": "<2B0F4B2A-339B-4D99-A650-C23F48185CF3@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Eddie from Pexip",
    "Entity": "Link",
    "Sub-type": "Linkedin",
    "Date and time": "Fri, Aug 28, 2020 at 7:00 AM",
    "Subject": "회신: Your offer letter to Pexip",
    "IDs": "<000f01d67d32$c7b78be0$5726a3a0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Timesheet from Uyen Tran",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Tue, Sep 1, 2020 at 9:59 AM",
    "Subject": "Re: VN Personify transfer from Oldco to Newco - Payment Application from Uyen Tran",
    "IDs": "<CAL43u-XkYLpw4GQ3CXo_1wXbaZpQ0=KtGcofe_ryFCUXodXR3Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Jira ticket about unistalling",
    "Entity": "Link",
    "Sub-type": "Jira",
    "Date and time": "Sep 1, 2020, 4:07 AM",
    "Subject": "Re: User feedback",
    "IDs": "<CAL43u-UAKDWb8Lppmw3jEAonYGTuUpreY-SCd3BU9C7c2_f=+Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Terms of service by Frank",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Aug 20, 2020, 7:31 PM",
    "Subject": "Personify, Inc. --- UPDATED TERMS OF SERVICE FROM WEBSITE [ NEW VERSION ATTACHED]",
    "IDs": "<Mimecast.4448.1b41cd342bde1e1a.1740e6d614e@us-sl-62.us.mimecast.lan>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Great video sent by Holly",
    "Entity": "Link",
    "Sub-type": "Video",
    "Date and time": "Wed, Jun 2, 10:48 AM",
    "Subject": "Great video",
    "IDs": "<CAMySe0UHdzyZChCicFwM8cQPo05G2p4iqzYf540xTeC9NXGurA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "When is ena trading track",
    "Entity": "Event",
    "Sub-type": "",
    "Date and time": "Fri, Jan 29, 12:15 PM",
    "Subject": "ENA Trading Track - Interviews October",
    "IDs": "<CAGM-d-Ep044Yd6YBa+30dgA2vDqEV7zFSwLg71d1J4PKUFM_1w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Deadline for chairma's award",
    "Entity": "Date",
    "Sub-type": "",
    "Date and time": "Fri, Jan 29, 12:14 PM",
    "Subject": "2001 Chairman's Award Deadline Extension",
    "IDs": "<CAGM-d-FwA9MeWvtPEYC=i=awJQPPsvXtsM_t_6c8xMLP6LtC9A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Link about urban legends",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Fri, Jan 29, 12:14 PM",
    "Subject": "FW: Urban Legends Reference Pages Rumors of War",
    "IDs": "<CAGM-d-E7TY=Q9QMXfjTVO9d9DF_y8bLhB3C7msfVMeDbikThTw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Feedback form from Shuchen",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Fri, Jan 29, 11:15 AM",
    "Subject": "(no subject)",
    "IDs": "<CAFQg0LpuDz_DF1KjEgOs0dDQ-XLNPEk4D7k+gtRXP79=h5-FtQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "NER blog shared by Shuchen",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "Thu, Jan 28, 3:46 PM",
    "Subject": "(no subject)",
    "IDs": "<CAC1JF-9z51hmyXOe-VkpTGY1UkD=3jtE4fsU4wqiyYR1Wi1_dQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Facebook ai link sent by Shuchen",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Thu, Jan 28, 2:25 PM",
    "Subject": "(no subject)",
    "IDs": "<CAFQg0LrZAT1L_ezrcWnEVc1n9Fd3u=NhRzC43iG1mJYgkFBPag@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Issues list compiled by Khoa",
    "Entity": "Link",
    "Sub-type": "Google Sheet",
    "Date and time": "Aug 22, 2020, 2:57 PM",
    "Subject": "Re: Cisco issues and Solutions",
    "IDs": "<52EEABD7-F0FC-4A38-8C44-A8BEA1B27324@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "SDK customer issues",
    "Entity": "Link",
    "Sub-type": "Google Sheet",
    "Date and time": "Sat, Aug 22, 2020, 2:56 PM",
    "Subject": "SDK Customer Issues - Invitation to edit",
    "IDs": "<00000000000081be8405ad7cc11b@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Video wall tracker shared by Chris",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Tue, Aug 18, 2020, 3:21 PM",
    "Subject": "RE: XLS with tracking info",
    "IDs": "<MWHPR08MB2496F37D1A2E0DCF7F0D2553845C0@MWHPR08MB2496.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Updated video wall tracker from Chris",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Thu, Aug 20, 2020, 8:22 AM",
    "Subject": "RE: XLS with tracking info",
    "IDs": "<MWHPR08MB249602467F13CDA0686EF50E845A0@MWHPR08MB2496.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "SOC2 slides from Khoa",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Fri, Aug 21, 2020, 9:41 AM",
    "Subject": "SOC 2 - Invitation to edit",
    "IDs": "<000000000000390ce205ad643cc4@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Challenge shared by Surendra",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Aug 10, 2020, 10:08 PM",
    "Subject": "Re: Summary",
    "IDs": "<3DCD4996-7B6B-48E7-9164-19F475193647@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Hyperconnect link from Philip",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Aug 10, 2020, 11:10 PM",
    "Subject": "회신: Summary",
    "IDs": "<000801d66f95$4ba5b6d0$e2f12470$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Surendra's linkedin profile",
    "Entity": "Link",
    "Sub-type": "Linkedin",
    "Date and time": "Monday, August 17, 2020 at 3:52 PM",
    "Subject": "회신: Personify Introductions; backgrounds",
    "IDs": "<004f01d67750$3740c910$a5c25b30$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Sanjay's linkedin profile",
    "Entity": "Link",
    "Sub-type": "Linkedin",
    "Date and time": "Monday, August 17, 2020 at 3:52 PM",
    "Subject": "회신: Personify Introductions; backgrounds",
    "IDs": "<004f01d67750$3740c910$a5c25b30$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Linkedin of Personify's CEO",
    "Entity": "Link",
    "Sub-type": "Linkedin",
    "Date and time": "Monday, August 17, 2020 at 3:52 PM",
    "Subject": "회신: Personify Introductions; backgrounds",
    "IDs": "<004f01d67750$3740c910$a5c25b30$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Linkedin of Personify's CTO",
    "Entity": "Link",
    "Sub-type": "Linkedin",
    "Date and time": "Monday, August 17, 2020 at 3:52 PM",
    "Subject": "회신: Personify Introductions; backgrounds",
    "IDs": "<004f01d67750$3740c910$a5c25b30$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Registration link from Bank of America",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Tue, Aug 18, 2020 at 1:12 PM",
    "Subject": "RE: Chromacam for enterprise deployment.",
    "IDs": "<8bab8b0e34bd44e28cae59e6a9e15175@bofa.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Liting patent from Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Aug 26, 2020 at 7:02 PM",
    "Subject": "472_US20190251434.pdf",
    "IDs": "<8AE50045-C518-4CAD-8320-357AACFDAEDE@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Liting patent shared with Sanjay",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Aug 26, 2020 at 7:02 PM",
    "Subject": "472_US20190251434.pdf",
    "IDs": "<8AE50045-C518-4CAD-8320-357AACFDAEDE@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Windows build for cisco with file increase",
    "Entity": "Link",
    "Sub-type": "Google Drive?",
    "Date and time": "Mon, Aug 17, 2020 at 10:15 AM",
    "Subject": "Cisco Windows - Version Incrementation",
    "IDs": "<CAMovQvcP3xDSrjuHjOUeRyuetOctGW6TY8cny1x801=0RXAm7Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Dustin's number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Mon, Aug 17, 2020 at 10:58 AM",
    "Subject": "Re: Insight Overdue Invoices",
    "IDs": "<CAKVuy5HdLCrtKYiFArnBF+OwTGj8TZ0jTkRfBVezozDEHa0e+w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Windows frames report shared by Long",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Sat, Aug 15, 2020 at 3:09 AM",
    "Subject": "Re: Ground-truth data & DNN in PsySeg",
    "IDs": "<CAL43u-UFB-hxP9+XSCNF1bryNfa1mX-fsRrFdiMxZK3zdp6WoA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify company overview",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Aug 14, 2020 at 1:50 AM",
    "Subject": "회신: 회신: 회신: Personify integration with SGNS.co",
    "IDs": "<01a801d67207$3378ca60$9a6a5f20$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Company overview",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Aug 14, 2020 at 1:50 AM",
    "Subject": "회신: 회신: 회신: Personify integration with SGNS.co",
    "IDs": "<01a801d67207$3378ca60$9a6a5f20$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Open vino slides from Viet",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Thu, Aug 13, 2020, 9:36 PM",
    "Subject": "OpenVino-Co - Invitation to edit",
    "IDs": "<000000000000f96bc805accd4a61@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Pain-points report from Holly",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, Aug 11, 2020 at 9:44 PM",
    "Subject": "Presenter research for product development",
    "IDs": "<F97E3990-3116-4C06-9278-9A444F1C3AF1@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "3.0 skus and pricing sent to Oracle",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Aug 13, 2020 at 3:28 PM",
    "Subject": "Re: FW: FW: Presenter v2.0 Release Candidates",
    "IDs": "<CALV-+1dPXC0pHv0jQGdbuYUbSz-CN6Exs37QwH3CuwEgdH226A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Presesenter skus and pricing from Simon",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Aug 13, 2020 at 3:28 PM",
    "Subject": "Re: FW: FW: Presenter v2.0 Release Candidates",
    "IDs": "<CALV-+1dPXC0pHv0jQGdbuYUbSz-CN6Exs37QwH3CuwEgdH226A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Chromacam article written by Sean",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, Aug 5, 2020 at 3:10 PM",
    "Subject": "Re: Feature Article Covering Personify's Chromacam on HostingAdvice.com",
    "IDs": "<CAJcYmS8rkKfn+ZTBJOJsFtKa2Xbt1DYUjCLUpnE4m102HSPk1A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Definitive chromacam article by Sean",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Aug 10, 2020 at 11:26 AM",
    "Subject": "Re: Feature Article Covering Personify's Chromacam on HostingAdvice.com",
    "IDs": "<CAJcYmS_wQDr+ohbTnubAqCDX-GK05a_949D3BJVkoAiFGCgVZA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "SDK Marketing ppt from Viet",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Mon, Aug 3, 2020 at 5:33 AM",
    "Subject": "PPT for PsySDK",
    "IDs": "<CAMovQve+0=xOFZb6x5ti+7hGc-rbkOEbx_pysvZO23rcU70gWQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Psyseg table from Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Aug 3, 2020 at 6:52 PM",
    "Subject": "Re: PPT for PsySDK",
    "IDs": "<91E4EB2A-F704-405F-8D8C-4F50204962AC@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Psyseg performance with blur",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Thu, Aug 6, 2020 at 2:27 PM",
    "Subject": "Re: PPT for PsySDK",
    "IDs": "<CAMovQvcpJAxDmtYX54ZXEnBohvKCreD3dPpzc6CtwHheU4JRCw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Psyseg performance without blur",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Thu, Aug 6, 2020 at 2:27 PM",
    "Subject": "Re: PPT for PsySDK",
    "IDs": "<CAMovQvcpJAxDmtYX54ZXEnBohvKCreD3dPpzc6CtwHheU4JRCw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Camera options for QC team",
    "Entity": "G",
    "Sub-type": "Google Sheets",
    "Date and time": "Tue, Aug 11, 2020, 11:48 PM",
    "Subject": "QC Team camera request - Invitation to edit",
    "IDs": "<000000000000e0cc4805aca6e514@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Telecom reseller metrics from Holly",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Mon, Aug 10, 2020 at 6:47 PM",
    "Subject": "Re: Telecom Reseller Ads update",
    "IDs": "<419AE6F0-0855-43BA-9A06-6D11DB5A3743@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Website improvement plan sent by Holly",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Aug 10, 2020 at 6:43 PM",
    "Subject": "Personify Inc Website Improvement",
    "IDs": "<D20BC00C-3081-4BCB-9745-6962454333A7@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Long's address",
    "Entity": "Location",
    "Sub-type": "Address",
    "Date and time": "Wed, Jul 29, 2020, 11:57 AM",
    "Subject": "Re: agency contact in Houston",
    "IDs": "<17144CAA-96D9-4E5F-8A2C-DC1FCEFEF90C@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "P&T address by Jeremy",
    "Entity": "Location",
    "Sub-type": "Address",
    "Date and time": "Mon, Aug 10, 2020 at 11:42 AM",
    "Subject": "Re: agency contact in Houston",
    "IDs": "<12790145-FED0-4A7F-BB6F-F12C5BACEFC0@infocus.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Phone number for shipping by Jeremy",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Mon, Aug 10, 2020 at 12:23 PM",
    "Subject": "Re: agency contact in Houston",
    "IDs": "<C36F8D1A-DB63-4EC5-A4D3-54B5DA8AD552@infocus.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Shipping label draft from Genette",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Aug 10, 2020, 12:50 PM",
    "Subject": "RE: agency contact in Houston",
    "IDs": "<MWHPR08MB25259C930E2DCA3EA3D551D38B440@MWHPR08MB2525.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Carton labels sent by Khoa",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Mon, Aug 10, 2020 at 1:29 PM",
    "Subject": "Re: agency contact in Houston",
    "IDs": "<72E68EEA-F909-43DA-889D-537056DC84F7@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Wikipedia link from Khoa",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Aug 10, 2020 at 2:44 PM",
    "Subject": "Re: agency contact in Houston",
    "IDs": "<AAE153F4-74FA-419D-B141-7BB23EF4DA14@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Developers kit's specifics shared by Genette",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Mon, Aug 10, 2020 at 2:50 PM",
    "Subject": "RE: agency contact in Houston",
    "IDs": "<MWHPR08MB2525BA090ABC8CCA9EFE66C08B440@MWHPR08MB2525.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Definite shipping label from Genette",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Aug 10, 2020 at 4:56 PM",
    "Subject": "RE: agency contact in Houston",
    "IDs": "<MWHPR08MB25254D84566CAF006A9513C68B440@MWHPR08MB2525.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Test report for OpenVino by Viet",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Mon, Aug 10, 2020 at 12:15 PM",
    "Subject": "OpenVino Experimental Results",
    "IDs": "<CAMovQvevQG+nKY6r8qw_torYRwUb4Y_G-aUk7bYGyPwq50=BEQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Machines requests from Viet Vo",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Aug 5, 2020, 4:07 PM",
    "Subject": "Resource Requests",
    "IDs": "<CAMovQvd4QrUyt2mKCmO-bC-ikX-TjTSREgqe5ydyifdsktPLag@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "BJN release from Viet",
    "Entity": "Link",
    "Sub-type": "Google Drive",
    "Date and time": "Wed, Aug 5, 2020, 11:49 AM",
    "Subject": "[BJN] Release on top 3.6.5 with OpenCL Runtime Exception",
    "IDs": "<CAMovQvf7RVppEuE4+iCvs_Un-h3YWFFT-LGxq=nWFUy4E742oA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "BJN error codes sent by Viet",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, Aug 5, 2020, 11:49 AM",
    "Subject": "[BJN] Release on top 3.6.5 with OpenCL Runtime Exception",
    "IDs": "<CAMovQvf7RVppEuE4+iCvs_Un-h3YWFFT-LGxq=nWFUy4E742oA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Alcatel slides shared by Andrew",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Aug 4, 2020, 11:05 AM",
    "Subject": "Lucent-Alcatel Enterprise opportunity",
    "IDs": "<CAEU0P5YRLqFRUN6iCUY3OF8yF0hj+fjppOFHJExhS7p-c0DP7g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Summary of Google Ads results sent by Philip",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Aug 2, 2020, 9:46 PM",
    "Subject": "Summary of Google Ads",
    "IDs": "<00c301d66940$5c10b2f0$143218d0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Download and upgrade statistics shared by Huyen",
    "Entity": "Link",
    "Sub-type": "Google Analytics",
    "Date and time": "Aug 2, 2020, 11:12 PM",
    "Subject": "Re: Summary of Google Ads",
    "IDs": "<CAOuUqHve81RebLkXd7n1=0A8qbLPNEXD+1iUbGEf2CoKcgiR-g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "BJN test build by Viet",
    "Entity": "File",
    "Sub-type": "Zip",
    "Date and time": "Fri, Jul 31, 2020, 8:49 AM",
    "Subject": "BJN test build",
    "IDs": "<CAMovQvd81srO6nP3F3xnrFQzRb8qJEVUCCRySZKtNCAyNGmELQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Paywn guide shared by Mike",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jul 30, 2020, 11:42 AM",
    "Subject": "Re: PTO notice",
    "IDs": "<5A10BE6A-BD47-4D27-BBEA-5A208551FE0C@redzonehr.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Paywn guide sent to Khoa",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jul 30, 2020, 11:42 AM",
    "Subject": "Re: PTO notice",
    "IDs": "<5A10BE6A-BD47-4D27-BBEA-5A208551FE0C@redzonehr.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Amendment from Steve Weinstock",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jul 29, 2020, 1:46 AM",
    "Subject": "Fwd: Amendment to our Agreement",
    "IDs": "<CALV-+1ercaZ3DOGNB7=LuQBJ9zpH5dTCe3rYh4=w3TS2ooVEig@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Amendment signed by Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Jul 29, 2020 at 10:57 AM",
    "Subject": "Re: Amendment to our Agreement",
    "IDs": "<37D680F9-2392-4E51-B5D2-78313107741B@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Marketing slides shared by Holly",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Tue, Jul 28, 2020 at 3:05 PM",
    "Subject": "Marketing Update - Invitation to edit",
    "IDs": "<0000000000001889ea05ab85f670@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Strategy slides from Philip",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Fri, Jul 24, 2020 at 7:28 AM",
    "Subject": "Request a call conf.",
    "IDs": "<003c01d661b5$f995fea0$ecc1fbe0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Raise recap by Long",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Jul 20, 2020, 11:15 AM",
    "Subject": "Suggest salary raise for some key persons that having contract renew this Q3",
    "IDs": "<CAL43u-WrDaim2VJAzKroNtjku=c7svq-mHgDwh-S2mtjBVwpag@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Raise recap by Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Jul 20, 2020, 11:15 AM",
    "Subject": "Suggest salary raise for some key persons that having contract renew this Q3",
    "IDs": "<CAL43u-WrDaim2VJAzKroNtjku=c7svq-mHgDwh-S2mtjBVwpag@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Q3 salary review sent by Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Jul 20, 2020, 11:15 AM",
    "Subject": "Suggest salary raise for some key persons that having contract renew this Q3",
    "IDs": "<CAL43u-WrDaim2VJAzKroNtjku=c7svq-mHgDwh-S2mtjBVwpag@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "POEditor links sent by Philip",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Jul 20, 2020, 2:53 AM",
    "Subject": "Local language support issue - IMPORTANT",
    "IDs": "<001001d65e6a$d3f12970$7bd37c50$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "POEditor links sent to Long",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Jul 20, 2020, 2:53 AM",
    "Subject": "Local language support issue - IMPORTANT",
    "IDs": "<001001d65e6a$d3f12970$7bd37c50$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Unsplash links",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Jul 20, 2020, 4:23 PM",
    "Subject": "Unsplash API Partnership for Personify",
    "IDs": "<495b186f-5863-486d-8d0d-0c63e47f5b27.comment276510498@groovehq.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Unsplash api link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Jul 20, 2020, 4:23 PM",
    "Subject": "Unsplash API Partnership for Personify",
    "IDs": "<495b186f-5863-486d-8d0d-0c63e47f5b27.comment276510498@groovehq.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Unsplash guidelines",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Jul 20, 2020, 4:23 PM",
    "Subject": "Unsplash API Partnership for Personify",
    "IDs": "<495b186f-5863-486d-8d0d-0c63e47f5b27.comment276510498@groovehq.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Unsplash documentation",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Jul 20, 2020, 4:23 PM",
    "Subject": "Unsplash API Partnership for Personify",
    "IDs": "<495b186f-5863-486d-8d0d-0c63e47f5b27.comment276510498@groovehq.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "New support page by Holly",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Jul 17, 2020, 11:20 AM",
    "Subject": "FAQs consolidation and page update",
    "IDs": "<CE0CDE25-DAC3-4E67-B870-9722CB69944A@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Chromacam FAQs shared by Holly",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Jul 17, 2020, 11:20 AM",
    "Subject": "FAQs consolidation and page update",
    "IDs": "<CE0CDE25-DAC3-4E67-B870-9722CB69944A@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "FAQs edited by Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Fri, Jul 17, 2020 at 12:05 PM",
    "Subject": "Re: FAQs consolidation and page update",
    "IDs": "<980E1672-E814-47CC-BE14-7D6B4C913EE8@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Flickering video from Jim",
    "Entity": "File",
    "Sub-type": "3gp",
    "Date and time": "Wed, Jul 8, 2020 at 9:25 AM",
    "Subject": "RE: ChromaCam",
    "IDs": "<586b2f9f052144fb91456a45680208cf@mayerbrown.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Flickering logs from mayerbrown",
    "Entity": "File",
    "Sub-type": "Zip",
    "Date and time": "Fri, Jul 10, 2020 at 9:40 AM",
    "Subject": "RE: ChromaCam",
    "IDs": "<dc8ada7536174500850c1df82c0ada67@mayerbrown.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Cisco report shared by Khoa",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Wed, Jul 15, 2020 at 6:08 PM",
    "Subject": "Re: [PersonifyInc/PsySeg] Release psy-seg-3.6.6-rc1 - psy-seg-3.6.6-rc1",
    "IDs": "<848D3BAA-6A8F-4CB0-A433-33F54D49CDA2@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Khoa's report",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Wed, Jul 15, 2020 at 6:20 PM",
    "Subject": "Re: [PersonifyInc/PsySeg] Release psy-seg-3.6.6-rc1 - psy-seg-3.6.6-rc1",
    "IDs": "<07A05498-427D-4B0B-9C22-DB4F33CF6476@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Cisco's scan results sent by Khoa",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Jul 16, 2020 at 1:17 AM",
    "Subject": "Re: [PsySeg] Mjaor Issues for SDK",
    "IDs": "<320C3C86-B8A0-44D0-9D05-24D55506241D@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Scan spreadsheet by Cisco",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Jul 16, 2020 at 1:17 AM",
    "Subject": "Re: [PsySeg] Mjaor Issues for SDK",
    "IDs": "<320C3C86-B8A0-44D0-9D05-24D55506241D@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify privacy link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Jul 14, 2020, 5:45 PM",
    "Subject": "Follow up from Personify ChromaCam",
    "IDs": "<4C618634-3982-442E-9DA1-CD5418A94F11@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify's license terms",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Jul 14, 2020, 5:45 PM",
    "Subject": "Follow up from Personify ChromaCam",
    "IDs": "<4C618634-3982-442E-9DA1-CD5418A94F11@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Tax exemption certificate from UWF",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Jul 15, 2020 at 2:11 PM",
    "Subject": "Re: Follow up from Personify ChromaCam",
    "IDs": "<CAM33NQrQ=R1w__CXvgy8h_CJHtHp1HHvf68bJrAcDF2z1bz_3g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Salesforce table from Suzie",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Jun 30, 2020, 11:25 AM",
    "Subject": "RE: salesforce.com Invoice 17146575, Personify",
    "IDs": "<DM5PR08MB2956D94E22152286C7FFD2F48A6F0@DM5PR08MB2956.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Edited salesforce table from Suzie",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Tue, Jun 30, 2020, 11:30 AM",
    "Subject": "RE: salesforce.com Invoice 17146575, Personify",
    "IDs": "<DM5PR08MB295657FDCF0707FD3410D7C98A6F0@DM5PR08MB2956.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Salesforce licenses list by Suzie",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Jul 15, 2020, 10:41 AM",
    "Subject": "RE: salesforce.com Invoice 17146575, Personify",
    "IDs": "<DM5PR08MB29564F771C63BF028338E4F78A7E0@DM5PR08MB2956.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Images folder shared by Holly",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Jul 14, 2020, 11:19 PM",
    "Subject": "Re: google smart ads",
    "IDs": "<8FB9679B-FBD4-4DE7-A5EE-C914771086CD@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Codes by Philip",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Mon, Jul 6, 2020 at 5:56 AM",
    "Subject": "Product Code",
    "IDs": "<00f701d65384$11f13fe0$35d3bfa0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Codes by Simon",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Mon, Jul 6, 2020 at 11:27 PM",
    "Subject": "Re: Product Code",
    "IDs": "<CALV-+1e6N6yMCw+oHTyy+z7fZvTesWrpt4BconaWUJHPMGEY2g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Pro overview shared by Long",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Jul 6, 2020, 11:24 AM",
    "Subject": "Fwd: Need some info of legacy Omni product",
    "IDs": "<CAL43u-VEczvC7hsf5OsF1KPZcAV5iGQ6Tjek9k5+s03J_eURew@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Screenshots linked by Long",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Jul 6, 2020, 11:24 AM",
    "Subject": "Fwd: Need some info of legacy Omni product",
    "IDs": "<CAL43u-VEczvC7hsf5OsF1KPZcAV5iGQ6Tjek9k5+s03J_eURew@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Marketing posts for July 4th by Holly",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Thu, Jul 2, 2020 at 12:54 PM",
    "Subject": "Social Media ads - 7/4",
    "IDs": "<99E969C3-0F78-4D8F-B584-C506F756E7E6@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "On24 link sent by Jeremiah",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Jul 2, 2020, 1:07 PM",
    "Subject": "Re: Fw: Contact Form [ ref:_00DG0Cbyq._5001M1YG0P8:ref ]",
    "IDs": "<CAC=hQb=oCtKnOpyzR+pgoLT-HEguHTjfxmMFdYYWnrb=7Q3dCA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Video from Jeremiah",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Jul 2, 2020, 1:07 PM",
    "Subject": "Re: Fw: Contact Form [ ref:_00DG0Cbyq._5001M1YG0P8:ref ]",
    "IDs": "<CAC=hQb=oCtKnOpyzR+pgoLT-HEguHTjfxmMFdYYWnrb=7Q3dCA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Video sent to Cognizant",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wednesday, July 1, 2020 2:58 AM",
    "Subject": "Re: Fw: Contact Form [ ref:_00DG0Cbyq._5001M1YG0P8:ref ]",
    "IDs": "<CAC=hQb=oCtKnOpyzR+pgoLT-HEguHTjfxmMFdYYWnrb=7Q3dCA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Features walk-through by Jeremiah",
    "Entity": "File",
    "Sub-type": "Video",
    "Date and time": "Thursday, June 25, 2020 11:37 PM",
    "Subject": "Re: Fw: Contact Form [ ref:_00DG0Cbyq._5001M1YG0P8:ref ]",
    "IDs": "<CAC=hQb=oCtKnOpyzR+pgoLT-HEguHTjfxmMFdYYWnrb=7Q3dCA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Video about admin features",
    "Entity": "File",
    "Sub-type": "Video",
    "Date and time": "Thursday, June 25, 2020 11:37 PM",
    "Subject": "Re: Fw: Contact Form [ ref:_00DG0Cbyq._5001M1YG0P8:ref ]",
    "IDs": "<CAC=hQb=oCtKnOpyzR+pgoLT-HEguHTjfxmMFdYYWnrb=7Q3dCA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Risk management requirements from Charles",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Jun 29, 2020 at 10:46 AM",
    "Subject": "Re: Follow up from Personify Chromacam",
    "IDs": "<CAJKO6C4LqWtCJ_Aq63a5sqn86abL7iito2hkqMHRxOAcAK2tRg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Reseller agreement shared by Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Tue, Jun 30, 2020 at 11:21 AM",
    "Subject": "Re: Affiliate code monthly update",
    "IDs": "<21318752-1B35-4139-AEAC-B6BA7DDF9A84@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Reseller agreement sent to Holly",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Tue, Jun 30, 2020 at 11:21 AM",
    "Subject": "Re: Affiliate code monthly update",
    "IDs": "<21318752-1B35-4139-AEAC-B6BA7DDF9A84@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Affiliate agreement by Holly",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, Jun 30, 2020 at 2:09 PM",
    "Subject": "Re: Affiliate code monthly update",
    "IDs": "<1A2FD202-CC54-4445-ACFC-1E2A510C0320@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Affiliate agreement sent to Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, Jun 30, 2020 at 2:09 PM",
    "Subject": "Re: Affiliate code monthly update",
    "IDs": "<1A2FD202-CC54-4445-ACFC-1E2A510C0320@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Andrew's outreach log",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Jun 29, 2020 at 10:13 PM",
    "Subject": "Personify BD Dashboard and Outreach log",
    "IDs": "<CAEU0P5bSb=zu5Pjecwn_K=otpJZehBbikOXGt_Kzf1ubTTCM0w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Outreach log sent to Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Jun 29, 2020 at 10:13 PM",
    "Subject": "Personify BD Dashboard and Outreach log",
    "IDs": "<CAEU0P5bSb=zu5Pjecwn_K=otpJZehBbikOXGt_Kzf1ubTTCM0w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "BD dashboard sent by Andrew",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Mon, Jun 29, 2020 at 10:13 PM",
    "Subject": "Personify BD Dashboard and Outreach log",
    "IDs": "<CAEU0P5bSb=zu5Pjecwn_K=otpJZehBbikOXGt_Kzf1ubTTCM0w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "BD dashboard sent by Andrew",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Mon, Jun 29, 2020 at 10:13 PM",
    "Subject": "Personify BD Dashboard and Outreach log",
    "IDs": "<CAEU0P5bSb=zu5Pjecwn_K=otpJZehBbikOXGt_Kzf1ubTTCM0w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Expenses report by Andrew",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Jun 29, 2020, 4:55 PM",
    "Subject": "Personify: Q2 Expense Report",
    "IDs": "<CAEU0P5ZTF7v3Q29DD0AxeFS7ZMCm+t8Xn7=4RH=hACaaX7J0Vg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Expenses report sent to Dustin",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Jun 29, 2020, 4:55 PM",
    "Subject": "Personify: Q2 Expense Report",
    "IDs": "<CAEU0P5ZTF7v3Q29DD0AxeFS7ZMCm+t8Xn7=4RH=hACaaX7J0Vg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Webex subscriber list",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Mon, Jun 29, 2020 at 4:24 PM",
    "Subject": "Re: Invoice 2821 from DataCaptive Inc.",
    "IDs": "<CAEU0P5bxvJWD2t6EPwhGme-xbg3afGTC_NTh=d=-x5fZwFVY2g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Example of receipt sent by Long",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Thu, Jun 18, 2020 at 10:42 AM",
    "Subject": "회신: Schedule to launch KOR & JPN service",
    "IDs": "<01d401d64587$09313690$1b93a3b0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "June allocations from Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Fri, Jun 26, 2020, 4:16 PM",
    "Subject": "Team allocation",
    "IDs": "<9DE27BDA-6610-40D7-B38B-BAE3CE50D247@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "June allocations shared with Khoa",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Fri, Jun 26, 2020, 4:16 PM",
    "Subject": "Team allocation",
    "IDs": "<9DE27BDA-6610-40D7-B38B-BAE3CE50D247@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Mac specs for R&D",
    "Entity": "File",
    "Sub-type": "Google",
    "Date and time": "Wed, Jun 24, 2020, 2:18 AM",
    "Subject": "[R&D Resources] Request a new MAC machine for R&D development",
    "IDs": "<CAMovQvfmLvsehUArGOWVkKOpn6dWNcOpwuKRn_jOH1GkpJyEMA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Test results for Webex by Surendra",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "Thu, Jun 25, 2020 at 3:45 PM",
    "Subject": "Re: [PsySeg Release] psy-seg-3.6.5-rc1 (with prelim test results)",
    "IDs": "<C52C9B8D-FE49-4DD7-AACA-D78369E4D93B@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Draft of Linkedin ad by Holly",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jun 23, 2020, 2:48 PM",
    "Subject": "linkedin ads",
    "IDs": "<529151D3-A04C-4F39-ADBF-911DE5974944@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "QLM link sent by Surendra",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Tue, Jun 23, 2020 at 10:40 AM",
    "Subject": "Re: Vietnam sales opportunity",
    "IDs": "<E3C5EEF6-7C3F-45C4-868E-F12AAC9D44C8@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Pride ad by Holly",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Thu, Jun 18, 2020 at 6:52 PM",
    "Subject": "Facebook ads",
    "IDs": "<44D5F4CB-E99C-49A0-8F66-E2B1E943FA91@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "New support link by Surendra",
    "Entity": "Link",
    "Sub-type": "Support",
    "Date and time": "Wed, Jun 17, 2020 at 10:34 PM",
    "Subject": "Re: Personify account - read a Support article?",
    "IDs": "<CAKVuy5E7u_PDEN9HmX_uKRH1EZvDN0vV6DT3rWbTF+_b-YY4ug@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "New support url sent to Jim",
    "Entity": "Link",
    "Sub-type": "Support",
    "Date and time": "Wed, Jun 17, 2020 at 10:34 PM",
    "Subject": "Re: Personify account - read a Support article?",
    "IDs": "<CAKVuy5E7u_PDEN9HmX_uKRH1EZvDN0vV6DT3rWbTF+_b-YY4ug@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Member upload file sent to Melrose",
    "Entity": "File",
    "Sub-type": "Csv",
    "Date and time": "Fri, Jun 12, 2020 at 12:59 PM",
    "Subject": "Re: Contact Form [ ref:_00DG0Cbyq._5001M1YpRj8:ref ]",
    "IDs": "<CAN6k-eXwegsFurUbjMsZXqwA3xZQLodXmfdTXqEYx=mwHMOGUw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Personify member upload",
    "Entity": "File",
    "Sub-type": "Csv",
    "Date and time": "Fri, Jun 12, 2020 at 12:59 PM",
    "Subject": "Re: Contact Form [ ref:_00DG0Cbyq._5001M1YpRj8:ref ]",
    "IDs": "<CAN6k-eXwegsFurUbjMsZXqwA3xZQLodXmfdTXqEYx=mwHMOGUw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Keith's new password",
    "Entity": "Password",
    "Sub-type": "",
    "Date and time": "Tue, Jun 16, 2020, 10:42 PM",
    "Subject": "Fwd: reset account for me",
    "IDs": "<CAKVuy5E6WOcaaBNSZmYzk1UmVW+O8EStPoeHqbavjgJUwzR+iw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Webex guide by Jeremiah",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jun 11, 2020 at 12:21 AM",
    "Subject": "Re: Mayer Brown & Chromacam",
    "IDs": "<CAC=hQbnMC=1JYnbjzqX6xXDDRmbig+4Ym7=SengGNXHyM1YQSg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Chromacam guide by Jeremiah",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jun 11, 2020 at 12:21 AM",
    "Subject": "Re: Mayer Brown & Chromacam",
    "IDs": "<CAC=hQbnMC=1JYnbjzqX6xXDDRmbig+4Ym7=SengGNXHyM1YQSg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Promo codes by Holly",
    "Entity": "Code",
    "Sub-type": "",
    "Date and time": "Mon, Jun 15, 2020, 1:34 PM",
    "Subject": "Promo codes for email marketing",
    "IDs": "<0F15EF38-A63E-46A9-8113-A7AE3F8B9DF9@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Marketing channel shared by Andrew",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Mon, Jun 15, 2020 at 4:14 PM",
    "Subject": "Re: Promo codes for email marketing",
    "IDs": "<CAEU0P5YJnf-unDoAuU_bTm1xgjrqJbwXEkT2q0yVOjTY64G5Xw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "David's cell",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Mon, Jun 15, 2020 at 2:44 PM",
    "Subject": "Re: Nice connecting",
    "IDs": "<0ACE90BF-1FEA-4390-B506-C3C13FCC43BB@pictureu.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Ads by Holly",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Fri, Jun 12, 2020 at 11:32 AM",
    "Subject": "Emails for WebEx",
    "IDs": "<CALV-+1d++qf+uKH=XCye+Ajk6b-87tROvJO1_27e5G2OSjgmfw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Study about limited offers shared by Andrew",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Fri, Jun 12, 2020 at 4:46 PM",
    "Subject": "Re: Emails for WebEx",
    "IDs": "<CAEU0P5aWEsyseTvbcjGiKFEKHO85+4mGdWU4ybwLPTtt+-Uk_g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Link for compliance report shared by Simon",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Fri, Jun 12, 2020 at 2:42 PM",
    "Subject": "SOC2 Compliance",
    "IDs": "<CALV-+1e-yYj7nP4_dRGm2WVz-QB_7mPAdt5YEiQYgHZhKQApqw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Compliance report link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Fri, Jun 12, 2020 at 2:42 PM",
    "Subject": "SOC2 Compliance",
    "IDs": "<CALV-+1e-yYj7nP4_dRGm2WVz-QB_7mPAdt5YEiQYgHZhKQApqw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Whiteboard doc by Simon",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Jun 4, 2020 at 11:24 AM",
    "Subject": "Fwd: tech marketing material",
    "IDs": "<80B29A55-83D9-4B4C-BFB9-2C7F7E6B8942@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Revised white paper from Holly",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Wed, Jun 10, 2020 at 1:47 PM",
    "Subject": "Re: tech marketing material",
    "IDs": "<3FA54C97-0F20-42F1-9429-20C7DBBD3315@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "508 compliance link from Surendra",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Jun 8, 2020 at 4:38 PM",
    "Subject": "508 compliance",
    "IDs": "<AC5F6E44-1574-49D3-B3B0-FC6208AFE5A7@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Marketing expenditures from Holly",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Mon, Jun 8, 2020 at 12:52 PM",
    "Subject": "Instagram & twitter expenditure for ChromaCam",
    "IDs": "<B08C768F-DF5C-4303-AFAD-D7A73236C754@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Expenditures sent to Surendra",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Mon, Jun 8, 2020 at 12:52 PM",
    "Subject": "Instagram & twitter expenditure for ChromaCam",
    "IDs": "<B08C768F-DF5C-4303-AFAD-D7A73236C754@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Zoom camera document by Long",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "Mon, Jun 8, 2020 at 10:50 AM",
    "Subject": "ChromaCam as Virtual Camera in Zoom Client - Invitation to edit",
    "IDs": "<000000000000c4c67f05a794935a@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Webex users list by Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Fri, Jun 5, 2020 at 9:55 PM",
    "Subject": "Webex user list",
    "IDs": "<0ECB520D-FA13-4DAD-818B-06A8EC52B2C7@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Domains list by Diem",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Mon, Jun 8, 2020 at 6:21 AM",
    "Subject": "Re: Webex user list",
    "IDs": "<CAEZmYG0HM+jFeCZ8NZO7matwvsnG+t=g9stgsXd_FwKAxSEVdw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Domains table sent to Surendra",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Mon, Jun 8, 2020 at 6:21 AM",
    "Subject": "Re: Webex user list",
    "IDs": "<CAEZmYG0HM+jFeCZ8NZO7matwvsnG+t=g9stgsXd_FwKAxSEVdw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Webex users list sent by Andrew",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Thu, Jun 4, 2020 at 5:41 AM",
    "Subject": "Fwd: List procurement 99148",
    "IDs": "<CAEU0P5Z2MOct+ta+uvWKdNeBE_y_Apw_CHYGcE8RbrczipqBQA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Webex users list sent by Andrew",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Fri, Jun 5, 2020 at 1:19 AM",
    "Subject": "Re: List procurement 99148",
    "IDs": "<CAEU0P5acyf_7jE2Oz=O9oFVE_rQEH1Rrh6TJc-0_x0L4UYKdtg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Facebook posts by Holly",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Thu, Jun 4, 2020 at 4:43 PM",
    "Subject": "Social media advertising",
    "IDs": "<B402C6EE-B38A-4E40-B19A-437DD895CBEE@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Marketing plan sent by Holly",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Thu, Jun 4, 2020 at 4:07 PM",
    "Subject": "Marketing ppt",
    "IDs": "<CAP7yWZjZECXdoeO77sJH_RcW6-fNjNR0thEQrVuPfjiDsv8tWQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Marketing plan to Surendra",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Thu, Jun 4, 2020 at 4:07 PM",
    "Subject": "Marketing ppt",
    "IDs": "<CAP7yWZjZECXdoeO77sJH_RcW6-fNjNR0thEQrVuPfjiDsv8tWQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Marketing plan from Surendra",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Thu, Jun 4, 2020 at 5:11 PM",
    "Subject": "Fwd: Marketing ppt",
    "IDs": "<B059502F-EBE9-4BD4-86AE-26EBDD01F41A@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Unistall command for Chromacam",
    "Entity": "Command",
    "Sub-type": "",
    "Date and time": "Thu, Jun 4, 2020, 3:04 PM",
    "Subject": "RE: Terminal command for uninstall ChromaCam in Mac [ ref:_00DG0Cbyq._5001M1YpTDe:ref ]",
    "IDs": "<qMVat000000000000000000000000000000000000000000000QBF3S000GnpDCFlTQ3WeyImjELgRtA@sfdc.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Counterpath profile shared by Andrew",
    "Entity": "Link",
    "Sub-type": "Linkedin",
    "Date and time": "Thu, Jun 4, 2020, 2:49 PM",
    "Subject": "Fwd: Call Between CounterPath and Andrew Melnichenko of Personify (Chromacam)",
    "IDs": "<CAEU0P5bYUFy702FuUy0rPvd=_Cs0U9wtB1kiP1s6OfiVEuGcoA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Youtube collab shared by Holly",
    "Entity": "File",
    "Sub-type": "Video",
    "Date and time": "Thu, Jun 4, 2020 at 11:26 AM",
    "Subject": "Fwd: Personify Presentation",
    "IDs": "<48AC7039-CD09-4E24-B405-F448C9B6C005@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "GTM celebration costs by Long",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Jun 3, 2020 at 11:32 PM",
    "Subject": "Estimate cost for winning contract GTM celebration 2020 - Invitation to edit",
    "IDs": "<00000000000021412505a73aa31f@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "SOW by Long",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Jun 3, 2020 at 10:22 AM",
    "Subject": "Fwd: DIGI-TEXX | Quote for Labeling Server | Phase 2 | Personify",
    "IDs": "<CAL43u-W=4NJvsF7F7hPDrA92Y_ETCfk1oVzHwL7S1eLdH4pW2g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Outreach log by Andrew",
    "Entity": "Link",
    "Sub-type": "Dropbox",
    "Date and time": "Mon, Jun 1, 2020 at 7:47 PM",
    "Subject": "Personify Outreach log",
    "IDs": "<CAEU0P5YLcyaiNT0oomtwfBOnWAEQ75mdHRA-d81Joen_0-DH4Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Outreach log sent to Surendra",
    "Entity": "Link",
    "Sub-type": "Dropbox",
    "Date and time": "Mon, Jun 1, 2020 at 7:47 PM",
    "Subject": "Personify Outreach log",
    "IDs": "<CAEU0P5YLcyaiNT0oomtwfBOnWAEQ75mdHRA-d81Joen_0-DH4Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Updated contact form from Simon",
    "Entity": "Link",
    "Sub-type": "Support",
    "Date and time": "Fri, May 29, 2020 at 2:27 PM",
    "Subject": "Contact Support Form Updated",
    "IDs": "<CALV-+1c_jQiNgZ2B_s90XiJVyXcr+MsfuLKMP3Tzz1+jxsvG1A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Inventory shared by Long",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, May 27, 2020 at 7:05 PM",
    "Subject": "Inventory management - Invitation to edit",
    "IDs": "<00000000000071188705a6aa16f7@google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "May budget from Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Sat, May 23, 2020 at 10:56 AM",
    "Subject": "Extra budget buying machines and stuffs in May 2020",
    "IDs": "<CAL43u-V4ZsyGozp7-eEbCwSw4wbg01ZWwJip4S4RZ4ShRaJWDA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Extra may expenses sent to surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Sat, May 23, 2020 at 10:56 AM",
    "Subject": "Extra budget buying machines and stuffs in May 2020",
    "IDs": "<CAL43u-V4ZsyGozp7-eEbCwSw4wbg01ZWwJip4S4RZ4ShRaJWDA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Webex user sample sent by Andrew",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Wed, May 20, 2020 at 4:51 PM",
    "Subject": "Fwd: WebEx Primary Commercial Account Owners List",
    "IDs": "<CAEU0P5YnVf65LJovPzyMaZ5H_rPHKN=UrX7eZRTbagKsf=n8Bw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Quote form sent by Dustin",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, May 18, 2020 at 10:59 AM",
    "Subject": "RE: quotation form",
    "IDs": "<5ec2b0f1.1c69fb81.796b8.46b0@mx.google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Quote template sent to Simon",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, May 18, 2020 at 10:59 AM",
    "Subject": "RE: quotation form",
    "IDs": "<5ec2b0f1.1c69fb81.796b8.46b0@mx.google.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Chromacam requirements",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Thu, May 14, 2020 at 11:15 AM",
    "Subject": "Video audio and video lip sync out of phase [ ref:_00DG0Cbyq._5001M1YD3sI:ref ]",
    "IDs": "<zzbmz000000000000000000000000000000000000000000000QABX6200b9hzllZtTau8Vjyt9g9lqQ@sfdc.net>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Social media marketing plan from Holly",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, May 12, 2020 at 3:33 PM",
    "Subject": "Social media marketing plan",
    "IDs": "<7B415E5C-570A-4BD1-96F8-8BA8BD02B145@personifyinc.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "New GPU suggested by Phong",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Tue, May 12, 2020 at 9:51 PM",
    "Subject": "Re: R&D Team Request",
    "IDs": "<CAL43u-WWHxwLSdoBAJcqYRuShdQ68dU2Z35z3x44JZt1x+6yTg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Proposal for Hitachi by Philip",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Mon, May 11, 2020, 8:13 PM",
    "Subject": "",
    "IDs": "<CA+ahe=h6dN19y8qp5SW1Qnz5C5BDiL-UEi0wZiFspGir611xbw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Database logs from Phien",
    "Entity": "Link",
    "Sub-type": "Cloud",
    "Date and time": "Mon, May 11, 2020 at 4:05 AM",
    "Subject": "Re: Jabber issue with Chromacam",
    "IDs": "<CAMBAEt6Cajz0=AZeqwwRzqSHEWfv=4EFDxdLgJ+O8Ub1hXnGUw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Google trends link from Simon",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, May 11, 2020 at 12:41 AM",
    "Subject": "Google trends",
    "IDs": "<CALV-+1e_C5B39i43zH-fQZTy=GvFygo1t4aD2Y2SPwAi+DwMFg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Admin portal improvements by Andrew",
    "Entity": "Link",
    "Sub-type": "Dropbox",
    "Date and time": "Fri, May 8, 2020 at 7:04 AM",
    "Subject": "Admin Portal Proposal",
    "IDs": "<CAEU0P5bo04KG0a0Oau52rnX-h+T7mr91717jiNTAh9sW3VEfrA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Instructions about Asia from Philip",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Fri, May 8, 2020 at 5:42 PM",
    "Subject": "ppt",
    "IDs": "<CA+ahe=g5aFKN+CxPVD01SzfpumYYT=t0p7=X6+1hNbdzBeswvw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Customer support guide by Long",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, May 7, 2020 at 10:01 AM",
    "Subject": "Re: US team for additional help to scale sales & support",
    "IDs": "<CAL43u-Um7NvZu2cXHDVm2=C+tgvupTSA8eh-nB-BSBggxkDCkw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Westan proposal from Philip",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Tue, May 5, 2020 at 6:57 AM",
    "Subject": "Re: connection",
    "IDs": "<CA+ahe=i=hKF1HEL7k7nkJWY6qWvBW8b8euRe2MmHyby7edSa+Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Updated Westan proposal",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Tue, May 5, 2020 at 7:58 PM",
    "Subject": "Re: connection",
    "IDs": "<CA+ahe=iWF7Q6W0t_pH_HMtxXHeXsnw0Q7ecgP_9eR8Yw_8jC4A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Final westan proposal",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Tue, May 5, 2020 at 7:58 PM",
    "Subject": "Re: connection",
    "IDs": "<CA+ahe=iWF7Q6W0t_pH_HMtxXHeXsnw0Q7ecgP_9eR8Yw_8jC4A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Reported issues shared by Susan",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Mon, May 4, 2020 at 3:17 PM",
    "Subject": "RE: Support Cases Callback Study",
    "IDs": "<MWHPR0801MB38041C3B54E17DE9BB4575808AA60@MWHPR0801MB3804.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Facebook instructions from Loron",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Mon, May 4, 2020 at 3:39 PM",
    "Subject": "Re: Facebook video app",
    "IDs": "<CAF3aHr7_sRjJxQ6-+05RpjOezX5j+6Gg=qQUHvmqi6K4NTz4=Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Company introduction by Simon",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Fri, May 1, 2020 at 6:37 PM",
    "Subject": "Re: Company and Tech Info",
    "IDs": "<CALV-+1dT4xehSA=y8ODvYvUO50gnC_BpD7Ai2hFvB92-0bqXhg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "CSA from Julie",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Apr 30, 2020 at 4:16 PM",
    "Subject": "Synopsys Black Duck Audits: Follow Up to Call & Next Steps",
    "IDs": "<E2316ABD-79BF-4EC7-BE03-632CD76514C7@contoso.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Scoping directions from Julie",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Apr 30, 2020 at 4:16 PM",
    "Subject": "Synopsys Black Duck Audits: Follow Up to Call & Next Steps",
    "IDs": "<E2316ABD-79BF-4EC7-BE03-632CD76514C7@contoso.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Security document from Julie",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Apr 30, 2020 at 4:16 PM",
    "Subject": "Synopsys Black Duck Audits: Follow Up to Call & Next Steps",
    "IDs": "<E2316ABD-79BF-4EC7-BE03-632CD76514C7@contoso.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Sample summary by Julie",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Apr 30, 2020 at 4:16 PM",
    "Subject": "Synopsys Black Duck Audits: Follow Up to Call & Next Steps",
    "IDs": "<E2316ABD-79BF-4EC7-BE03-632CD76514C7@contoso.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Sample audit from Julie",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Thu, Apr 30, 2020 at 4:16 PM",
    "Subject": "Synopsys Black Duck Audits: Follow Up to Call & Next Steps",
    "IDs": "<E2316ABD-79BF-4EC7-BE03-632CD76514C7@contoso.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Signed CSA by Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Apr 30, 2020 at 4:55 PM",
    "Subject": "Re: Synopsys Black Duck Audits: Follow Up to Call & Next Steps",
    "IDs": "<C13EE742-5F24-44EF-8216-F3FEA33AD632@synopsys.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Slack channel by Simon",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Tue, Apr 28, 2020, 1:59 AM",
    "Subject": "Re: Technical Deep Dive Meeting on Authentication topics",
    "IDs": "<CALV-+1fn7oeXAXq+s9KhuH-3Z91ha_fT2Vk9Lw7Bo5oc5VHyVw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "Slack channel by Simon",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Tue, Apr 28, 2020, 1:59 AM",
    "Subject": "Re: Technical Deep Dive Meeting on Authentication topics",
    "IDs": "<CALV-+1fn7oeXAXq+s9KhuH-3Z91ha_fT2Vk9Lw7Bo5oc5VHyVw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Gmail",
    "Accounts": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com;",
    "Login-email": "trova.testuser1@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com;  trova.testuser13@gmail.com;"
  },
  {
    "Query": "",
    "Entity": "",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "",
    "Accounts": "",
    "Login-email": ""
  },
  {
    "Query": "New development log shared by Sanjay",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1622234816033700",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "New development log shared with Trova",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1622234816033700",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Maize order on slack",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1622219909032200",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "MUM article sent by Kevin",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1622138343028800",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Url proposals from Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1621963200013400",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Jira link by Lijian",
    "Entity": "Link",
    "Sub-type": "Jira",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1621358262000400",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Jira link shared in #general",
    "Entity": "Link",
    "Sub-type": "Jira",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1621358262000400",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Document expansion paper from Kevin",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1622579551014400",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "BERT article shared by Shuchen",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1620416014001200",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "NER article from Laurentiu",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1616522763000900",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Architecture picture sent by Kevin",
    "Entity": "Picture",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1622145717029500",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Stanford link from Tae",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1610184790006300",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Netid form shared by Elena",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HY7V73GU/p1621358235003800",
    "Channel": "Random",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Clubhouse link from Omer",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HY7V73GU/p1615003025006200",
    "Channel": "Random",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Survey link from Holly",
    "Entity": "Link",
    "Sub-type": "Google Forms",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01TMEP2W0K/p1621623919014300",
    "Channel": "Standup",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Snapon notes written by Yucheng",
    "Entity": "Link",
    "Sub-type": "Confluence",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01TMEP2W0K/p1621268785003600",
    "Channel": "Standup",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Search evaluation report",
    "Entity": "Link",
    "Sub-type": "Confluence",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01TMEP2W0K/p1620410431001900",
    "Channel": "Standup",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "All alchemy meeting",
    "Entity": "Link",
    "Sub-type": "Zoom",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1602203581006600",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Alchemy call to action",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1585828663004600",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Mert email",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFHJR9VLL/p1572995472002800",
    "Channel": "Random",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Mert phone on slack",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFHJR9VLL/p1572995472002800",
    "Channel": "Random",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Schedule shared by Sanjay",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1597784321001100",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Schedule link sent on slack",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1597784321001100",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Testing instructions from Lijian",
    "Entity": "Link",
    "Sub-type": "Confluence",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1622655742048000",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Xai post by Sanjay",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1622082518019800",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Stanford link from Lijian",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1621272477009200",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Picture from first day",
    "Entity": "Picture",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1621266606006400",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Bug tracker from Surendra",
    "Entity": "Link",
    "Sub-type": "Jira",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1620929956003700",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Architecture slides from Sanjay",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1620012630004200",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Architecture slides from Omer",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1620157166017600",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Architecture slides by Yucheng",
    "Entity": "File",
    "Sub-type": "Ppt",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1620004251003300",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Architecture presentation by Shuchen",
    "Entity": "Link",
    "Sub-type": "Confluence",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1620003375002500",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Rights link from Laurentiu",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1619898063003000",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Groundtruth for slack",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1619733460000800",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Updated prepoposal from Sanjay",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1618934045006200",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Prepoposal",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1618865179001900",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Trova address",
    "Entity": "Location",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1616180166001200",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Dashboard link from Tae",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1613553683010800",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Public slack channels",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1611359011001100",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "BERT from Omer",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1610467529002500",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Abstract shared by Kevin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1622579551014400",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Event detection paper",
    "Entity": "Link",
    "Sub-type": "Epub",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1622579551014400",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "NLP talk",
    "Entity": "Event",
    "Sub-type": "Zoom",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1619798775000800",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "TF ranking from Yucheng",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1618983755000300",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Email serch article from Sanjay",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1615586349001000",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Email strategies",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1615586340000700",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Paper about successful search",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1615586324000300",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Synonym article from Tae",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1610165265005700",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Scale link from Shuchen",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HY7V73GU/p1618774627002400",
    "Channel": "Random",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Cloud",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HY7V73GU/p1611863679016600",
    "Channel": "Random",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Presentation written by Holly",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01TMEP2W0K/p1621623919014300",
    "Channel": "Standup",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Onboarding bucket list",
    "Entity": "Link",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01TMEP2W0K/p1620839278000900",
    "Channel": "Standup",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Future bucket list",
    "Entity": "Link",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01TMEP2W0K/p1620839223000400",
    "Channel": "Standup",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Notes from the architecture workshop",
    "Entity": "Link",
    "Sub-type": "Confluence",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01TMEP2W0K/p1619806273002700",
    "Channel": "Standup",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Basecamp slides",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01TMEP2W0K/p1619460627004500",
    "Channel": "Standup",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Fireside chat",
    "Entity": "Event",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1600978996000700",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Timesheets info",
    "Entity": "Picture",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1594671115024100",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "GNU radio",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1572029236000800",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Antennas instructions from Jingning",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1572029181000200",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Bob Horst's Linkedin profile",
    "Entity": "Link",
    "Sub-type": "Linkedin",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1562611719001900",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "First week materials from Dash",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1561390752001300",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Work hours info from Stephen",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1558730388000900",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Company link from Sanjay",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1552509073000500",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Emotions article sent by Jingning",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1552197432000200",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "IBM links from Jinjun",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1549512144007400",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Alchemy piazza",
    "Entity": "Link",
    "Sub-type": "Piazza",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1549335107000800",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Evaluation templates by Sam",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1547934684002100",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Model slides from Sanjay",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1547911791001300",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Model slides shared on Alchemy",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1547911791001300",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Form 397",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFH208QHE/p1547852095001900",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Drone demo shared by Mert",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CFHJR9VLL/p1572390643000900",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "ACM library link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1622837275015500",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "ECIR paper from Laurentiu",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1615588142001600",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Query expansion paper",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1615588142001600",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Search characterization",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1615586349001000",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Paper by Narang from Sanjay",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01JB0Q4Z8B/p1615586340000700",
    "Channel": "Papers",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Tianyi presentation",
    "Entity": "File",
    "Sub-type": "Mp4",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/C017ZANKF2Q/p1600022656006000",
    "Channel": "Vertext_public",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Adit link from Yucheng",
    "Entity": "Event",
    "Sub-type": "Zoom",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/C017ZANKF2Q/p1597332710008900",
    "Channel": "Vertext_public",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Doodle from Henry",
    "Entity": "Link",
    "Sub-type": "Doodle",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CMFC8C6A3/p1570315379001700",
    "Channel": "Cohort2019b",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Omer email",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CMFC8C6A3/p1568340725000600",
    "Channel": "Cohort2019b",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Model from Sanjay",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CMFC8C6A3/p1567740718002500",
    "Channel": "Cohort2019b",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Alchemy folder shared by Henry",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CMFC8C6A3/p1567739924000500",
    "Channel": "Cohort2019b",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "RokWire meeting",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CMFC8C6A3/p1567625909001400",
    "Channel": "Cohort2019b",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Paper on voice conversion",
    "Entity": "Link",
    "Sub-type": "Github",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CMFC8C6A3/p1567495029000200",
    "Channel": "Cohort2019b",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Self driving car shared by Tae",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CMFC8C6A3/p1567123804002800",
    "Channel": "Cohort2019b",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Project discovery sent by Sanjay",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CMFC8C6A3/p1567081055002000",
    "Channel": "Cohort2019b",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Second poll from Yucheng",
    "Entity": "Link",
    "Sub-type": "Doodle",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CMFC8C6A3/p1566330472004000",
    "Channel": "Cohort2019b",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Doodle by Yucheng",
    "Entity": "Link",
    "Sub-type": "Doodle",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CMFC8C6A3/p1565994919000600",
    "Channel": "Cohort2019b",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Startup about meeting notes",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1609316546070600",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Trova workspace",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1609282828069400",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Atante slides by Shuchen",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1609177751068800",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Atante email from Shuchen",
    "Entity": "Picture",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1608757140062400",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Slack bot shared by Yucheng",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1608745811055600",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Soc2 slides sent by Surendra",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1608315506052200",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Names list shared by Sanjay",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1608073180040900",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Slack search",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1607099378051000",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "SBIR comments by Roland",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1606948052050200",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Updated analysis by Tae",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1606628850040300",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Github link from Tae",
    "Entity": "Link",
    "Sub-type": "Github",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1606163174028800",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Papers",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1605710550010300",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Resume folder from Sanjay",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1605709822009100",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Support letter by Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1605543241000900",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "SBIR meeting",
    "Entity": "Event",
    "Sub-type": "Zoom",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1605114453056000",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Company address",
    "Entity": "Location",
    "Sub-type": "Address",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1604347744025300",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Competitors list by Tae",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1603737578005900",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Team info shared on slack",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1603733677003800",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "SBIR draft shared by Tae",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1603701357000200",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "SAM registration info",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1603473697135200",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "SBIR meeting",
    "Entity": "Event",
    "Sub-type": "Zoom",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1603378720110000",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "NSF requirements",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1603317635109100",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Vertext demo by Shuchen",
    "Entity": "Link",
    "Sub-type": "YouTube",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1603135016094400",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Tae workflow",
    "Entity": "Link",
    "Sub-type": "Confluence",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1602865794072200",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Meeting with Surendra",
    "Entity": "Event",
    "Sub-type": "Zoom",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1602818500070400",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Registration Shuchen",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1602687650060600",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Discord from Shuchen",
    "Entity": "Link",
    "Sub-type": "Discord",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1602520463048200",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Accompany article sent by Surendra",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1602274441042200",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Inbox search article",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1602268282040500",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Linkedin profile from Surendra",
    "Entity": "Link",
    "Sub-type": "Linkedin",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1602266588040100",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Ankur's email",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1602097236030100",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Email clients from Shuchen",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1601670292004000",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "SBIR Workshop",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1601487386001700",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Surendra's phone",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1601048055003000",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Surendra's wechat id",
    "Entity": "ID",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1601048055003000",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Microsoft research papers",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1600877026009800",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Market research from Tae",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1599732028000200",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Queries from Tae",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1599449014015700",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Frontiers agenda",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1597948642005600",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Application form sent by Tae",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1597942732003900",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Funding requirement from Shuchen",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1597942582003100",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Contacts list by Sanjay",
    "Entity": "Link",
    "Sub-type": "Google Sheet",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1597941928002300",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "IBM logo from Jinjun",
    "Entity": "Link",
    "Sub-type": "IBM Box",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1597430899007800",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Final video with comments",
    "Entity": "File",
    "Sub-type": "Video",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1597429740004800",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Questions for Adit by Tae",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1597115078071500",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Draft for the beta post",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1596477568011000",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Slides for Amy Zhang",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1596081129004700",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Landing page draft",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1595368836014700",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Google Analytics by Tae",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1595228861000800",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Test account by Tae",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1595228861000800",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Slogans by Tae",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1594379293076200",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Evaluation folder shared by Shuchen",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1594177894069700",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Meeting with Dakuo",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1593657798034300",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "EMNLP CFP",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1593561053007100",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Link for Dakuo",
    "Entity": "Event",
    "Sub-type": "Zoom",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1591304096008900",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Questions for Dakuo sent by Tae",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1591215012006000",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Final pitch deck",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1589560836030900",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Beta from Tae",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1586809050019900",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Updated labeling tool",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1586600150006400",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Search keys from Yucheng",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1586581046003800",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Labelling tasks by Yucheng",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1586575459002900",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Deep query dissertation",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1585795490009800",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "IBM slack dataset from Sanjay",
    "Entity": "Link",
    "Sub-type": "Google Drive (csv)",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1585416826001200",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Disentanglement presentation from Yucheng",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1584985960009900",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Annotation list by Tae",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1584384063000200",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Annotation tool",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1583956253003300",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Baseline slides from Shuchen",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1583783051006600",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Features brainstorming",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1582574023002600",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Colloquial language",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1581354754006400",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Paper by Amy Zhang",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1576968734001000",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "IBM thread by Tae",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1576614733026800",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "IBM meeting",
    "Entity": "Event",
    "Sub-type": "Webex",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1575302991001900",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Heng Ji paper from Tae",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1574104640004100",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "vm email",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1573943221006500",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "vm password",
    "Entity": "Password",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1573943221006500",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Dataset format by Yucheng",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1573934637002500",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Detailed pipeline from Shuchen",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1573316049002100",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Slack recap by Yucheng",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1572218962000200",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Slack recap shared on slack",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1572218962000200",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Poll by Rishab",
    "Entity": "Link",
    "Sub-type": "Whenisgood",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1571599962005600",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Repo from Tae",
    "Entity": "Link",
    "Sub-type": "Github",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1571348836004500",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Disentanglement datasets from Yucheng",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1571267570001700",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Disentanglement datasets from Yucheng",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1571267570001700",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Doodle for October 14",
    "Entity": "Link",
    "Sub-type": "WhenIsGood",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1570994232000600",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Slack architecture from Omer",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1569375155000100",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Seminar invite from Prof. Patel",
    "Entity": "Link",
    "Sub-type": "Outlook",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1569272246000100",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Slides from Rishab",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1569091091000100",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "sensei corpus shared by yucheng",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1580767154000200",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "where are the json files by tae",
    "Entity": "Location",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://alchemy2019.slack.com/archives/CN7G6KHV1/p1584384078001200",
    "Channel": "Vertext",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Snapon slides shared in #general",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1624377672105500",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "June presentation about snapon",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1624377672105500",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Article on brave search shared by Surendra",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1624378618107500",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Avatar picture sent by Holly",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1624498326109400",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Avatar fam",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1624570515111900",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Conceptnet",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HY7V73GU/p1624324691020400",
    "Channel": "Random",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Mediterranean restaurant shared by Elena",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HY7V73GU/p1624574751025900",
    "Channel": "Random",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Vietnamese place shared by Elena",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HY7V73GU/p1624574751025900",
    "Channel": "Random",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "El toro",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HY7V73GU/p1624574751025900",
    "Channel": "Random",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Survey results from Holly",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C025HTEH57C/p1624028706001700",
    "Channel": "User-study-group",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Matrix results by Holly",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C025HTEH57C/p1624028706001700",
    "Channel": "User-study-group",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Result spreadsheet sent by Holly",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C025HTEH57C/p1624028726002300",
    "Channel": "User-study-group",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Security document by Holly",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C025HTEH57C/p1624554374000200",
    "Channel": "User-study-group",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Security document shared with Elena and Kevin",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C025HTEH57C/p1624554374000200",
    "Channel": "User-study-group",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "How trova works from Holly",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C025HTEH57C/p1624554374000200",
    "Channel": "User-study-group",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Gmail knowledge graph error by Lijian",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C022XQB27LH/p1624917397008800",
    "Channel": "Troubleshooting",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Dbpedia",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C024Z93DBHN/p1624285111001200",
    "Channel": "Testingreleases",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Sus calculator by Elena",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C024Z93DBHN/p1624288936003000",
    "Channel": "Testingreleases",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Grammar link shared by Elena",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C024Z93DBHN/p1624321834004800",
    "Channel": "Testingreleases",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Elena's comments from June 21st",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C024Z93DBHN/p1624321878005200",
    "Channel": "Testingreleases",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Json file from Elena",
    "Entity": "File",
    "Sub-type": "Txt",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C024Z93DBHN/p1625108990001700",
    "Channel": "Testingreleases",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Oven link from Holly",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C024Z93DBHN/p1625153106002100",
    "Channel": "Testingreleases",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Neeva link shared by Sanjay",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1625746903147200",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Oreo pizza shared by Chak",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1625202458135100",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Nice pizza place by Elena",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1625200844131400",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Bento place by Yaning",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1625203172139000",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Product model slides by Yucheng",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1625769200152000",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Observations on Neeva by Holly",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1625855129161100",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Poll on neeva's subscription",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1625863836162100",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Randomized SVD article sent by Chak",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1626376999207700",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Gitflow model shared by Chak",
    "Entity": "File",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1626461985210200",
    "Channel": "General",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Loading design by Holly",
    "Entity": "File",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01K96R5UVA/p1624548435007700",
    "Channel": "ui",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Features bucket list by HollY",
    "Entity": "Link",
    "Sub-type": "Notion",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01K96R5UVA/p1625592017018500",
    "Channel": "ui",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Google guidelines from Surendra",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01K96R5UVA/p1626275745004100",
    "Channel": "ui",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Zambian restaurant menu",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://trova-hq.slack.com/archives/C01HY7V73GU/p1626379516049300",
    "Channel": "ui",
    "Platform": "Slack",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser2@gmail.com; trova.testuser11@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "",
    "Entity": "",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "",
    "Accounts": "",
    "Login-email": ""
  },
  {
    "Query": "Development log written by Sanjay",
    "Entity": "File",
    "Sub-type": "Google Slides",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/presentation/d/1K5ry72R9APmH_s3B4qI57CBT8OR-mlimB3WA0iAPUfQ/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Search history",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/spreadsheets/d/1B8TuhWlWkQXvzWPeABAsCdEXZj2xGO_67xbmw_MjI_Y/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Information management",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1XTgZ6MMBgjB-_7FnWzbm6DYD6Bm8TStV/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Social information article",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1XTgZ6MMBgjB-_7FnWzbm6DYD6Bm8TStV/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Feedback form",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1MaPxoGPlQBAFwqK2VoDiHsQ3gP6mF5ZV/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Responses of user survey",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1ypLf5U5t8Q9_2e5bdGb9z7W-ieKk9RPW/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Plan written by Holly",
    "Entity": "File",
    "Sub-type": "Google Slides",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/presentation/d/1qDGVI-vYBRWI-T8DUWSrpSfwbWRgd4I4P5gd1-Xwmbw/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Search behavior by Kevin",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/document/d/1imZgAM33ZhlFZPp8prcZRfNjmX_uexQ53crHtSn7Bw4/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Folder about Holly",
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/19J5IX2dhyabIA3B8bLf0Ow3fRlIDUUMM?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "cv folder shared by sanjay",
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/1hvJ2ZwHwlYDxaaVmE6y0Ezf11mRU5c-H?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Speech recognition paper shared by Heting",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1Om9c0AtDyC0XHp6_5b_gxJlDnLIT0cM2/view",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "ID instructions by Lijian",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/document/d/12LJR3AqBN-NIYqRmOf3cXz6IxbHhyObAeTfNsuW9y5I/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Query guidelines by Elena",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/document/d/16Sln7pfsuO9XjefUa_CzlPCiNrlkBT_sqCSdqb43odc/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Results from Heting",
    "Entity": "File",
    "Sub-type": "Txt",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1SfkW5H3XTQpgb6upL1vGLU8h3h3a3Wm4/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Releases slides from Elena",
    "Entity": "File",
    "Sub-type": "Google Slides",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/presentation/d/1SmlzPEsw5bUwU0C5KZOq_lKA61A2mEq4YawrFn4ZBZQ/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "June UI update by Holly",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/presentation/d/16QRofBhvUAEYAye9pK7o1pLXswrtzc_4axGKKDCw134/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Website overview",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1eWmX0QkU_tz_1mZR8NrLdfcLQfYyXYrt/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Privacy policy",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1L4QhfZViOAiYLj60zVTT0YLi35cE1Mm_/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Terms of service draft",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1edaSZ_gNnUN-SEoAxJ_p-cBu6oHutsIM/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Definitive terms of service",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/19oXbk53GjPtHhhW8nV90tWBcORPfbj6l/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Release tests from Omer",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/spreadsheets/d/1OkQrQwuqQflej0QVAcQA1qlZFlSPZR0PTbEBCCV-lyM/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Dev issues by Chak",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/document/d/1ncSqsBsP2NreVWphA2HSh2hEtyVVxO4LalCcg-Pt9PU/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Aws datasets notes",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1cAcARN0Q3xegn0JteZLLihvbJVM-0BHS/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Query parser by Yucheng",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/document/d/1oIWNogv746TBzI42GMQtQN_DvJC2mBQwYaaPoFpN2JQ/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Yucheng",
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/1D3-sd27tz_-dlhKha5XeIMNGoaCNA1Gn?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Search results",
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/137qqGFtEi4Xi1Z3C2DfVX4oC4ApSVtXf?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Search evaluation",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/15dJxjjsCLx0H-512zqeTh4cnvcZbgUDL/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Mailbox parser",
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/1tbA9zM5h1QbkasHNXLvBzspbr3lyurxF?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Old parser",
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/1qSaayxteGJRVEmGc56DF5SLBuYNLHQr-?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Test for old parser",
    "Entity": "File",
    "Sub-type": "Py",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1HPJRiUbtdOLUXrpFvAO2iieZnyD329rj/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "May architecture workshop",
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/1XwMr2fkOBiKM_TyePdsDZ4NRbY45PmZX?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Architecture slides",
    "Entity": "File",
    "Sub-type": "Google Slides",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1CvBEdHb3wEGLer5n_EXVUU0DTsUFR1lN/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Architecture overwiev",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1i8SWq779Q2EKaC3xkhp_3b8VhJNiJ4ny/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "App verification from June",
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/10DAZVshqLyGDgeatTyUy3iRHoyiVD-CP?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Business policy",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1rd3Z64V8WThzz_-tUxjYMFGaIvldJQ-Y/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Slack verification draft",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1XlsOqSLDfi0FPa7rsLygB1uYPn5jGhUr/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Search analysis by Elena",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/document/d/1gk3sBk3mJaaReLBGeBuUnoY5A_CPB4ZYvqIptYIAEhE/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Poster by Kevin",
    "Entity": "File",
    "Sub-type": "Google Drawings",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/drawings/d/19GBwF0cjlgc9DXlQ5UHeE8z9fwJPoAzVeJbiPOsTK6o/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Omega instructions by Kevin",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/document/d/1Ji33GsmQFJ8l2bZ6vddjj9qB5PDERPeJHYEBx4Savvg/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "random table shared by Kevin",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/spreadsheets/d/1-W7StIgkoeC06uAGxRVGQ4PrcAIdtO-5OuP7MPh5qag/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Review of chapter 1",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/0B7YIyHsiDmiYWWJFMElIbTJEaW13dkhWczAwQ3RHZ1VVcDhj/view?usp=sharing&resourcekey=0-Mfsj2aLPUMHmPQrUOYzEPA",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Homework 4 for 241",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/spreadsheets/d/1WYmmF-IDr4bXSnP36QUedzdTLxQyzUalHpPv-IpOims/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Names list shared by Sanjay",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/spreadsheets/d/1biev9bLay8J_uI8zl91bZ1Ufz9aiAubM4tKof804sLk/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Preproposal",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/document/d/123Ab3fTl1W6C880KBvZkIW1-ww0btmXbF8m0F4xCliM/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Trove dataset",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/spreadsheets/d/1kxog0TtcNB3qmiMWNau5M2KW0qsisjwmcblDf7rvx8Y/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Evaluation folder shared by Sam",
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/1F81yPKnKfSBf0bn26b6Fau4IjQBdXc9R?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Ideas from sanjay",
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/1WnBKbdxZniUdgDG8AaCss5-F5wiT54Vl?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "weekly slides",
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/19n4GJ5D8WcorsAHXsED3xftOEJZ0GiUz?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Description prompt by Ruihao",
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/document/d/1AK-VgUREd33ibtfB6F_IS5hMHoa-by6XugxbhdlOh3s/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Project list",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/spreadsheets/d/1mgdT-W17xJpvOcfGLh5mZzPqMjJOPfmB9TAqyf3jCMw/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Evaluation template",
    "Entity": "File",
    "Sub-type": "Google Slides",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/presentation/d/1ESGWwqvjFeuvPXJZGhBBSCTV5GK-3wUnt_rw4gOAYHo/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Week 1 ppt from Edwin",
    "Entity": "File",
    "Sub-type": "Google Slides",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/presentation/d/1izGS5BN7Wce7Ct7VFZ5NQhbFoThWPjHQxKMXprx5v70/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Papers shared by Sanjay",
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/1BsjttzNewbxav4ypl1mPAkBVaDm0DT-W?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Vertext paper",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1jAQmugg-I_FFNs-o6TuDDkEolICuKh74/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "paper review by omer",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/18w3UKmExQYBJNMa1KzLeUvNcyPFIoEZQ/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "resume folder from Sanjay",
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/1hvJ2ZwHwlYDxaaVmE6y0Ezf11mRU5c-H?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Grades table",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1wJibi7BPsKMbgcdPdL0AybERmtBqOZe4/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Paper on feeling of knowing",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/10UeqIkWK6IDSEiHIi-xqKSq4pBu7S8qV/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "unified search",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1gx6VGePkcJCaIWDExvCbds8mFWYfweLu/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "sis paper from 2006",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1gWlkG9Fmhi0yDeNnoOUui2Tb2v9S1UJO/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "artlicle on search difficulty",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1zmyhusTz6FTcDSWEl3zPfet2QLcUxeF3/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "pim paper by wang",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/10O2-gwpEEQwvuHuU6ogu89zvgOKk-KZR/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "a lifelog browser",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1iLMjcUT0Dah6M3hYukiJ-cdZCfKeGa9U/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Sis paper from 2003",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1zbShJw5j_RWIog2i2CDWsAyrilwVUMPL/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "spring assignment table",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1CevVl8BLnVVnz1tsPC8R3enwVSQaJvqj/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Flyer for caffettino",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1_buSYCSksRT4Ov_pS68ntXx5KIMJ7pR9/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "cineforum 2021",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1p1AMEfA40Ucu4ZTh_cCyj3Q2dcIonutR/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Comments for Week 14",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/1ljEiM-PsR85TIJ5h_kENAaju7XndMpZT?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Actlf summer 2020",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1yNZKKKU1szMEkJCoW05IWSOcS5F8caP0/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": 505,
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/1yqyem4zcAjivOrsTPxx1kJAURuNjz2Kj?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Russel article on anxiety",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/19WiPlqkTXgu-jBF8vwbPws5hfcjHyRZn/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Presentation on online teaching",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1htV014Ug6WJKR-kz__QfswPFTa_Wu2Iv/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Article about online teaching by Payne",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1FlknYj9HpsMAuMGgFBQWQi9R78wPiuup/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Week 4 materials",
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/1Y3h_xF2uC2Ee6-7tYzIj_oL_Z85Zf8LZ?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Presentation for week 4",
    "Entity": "File",
    "Sub-type": "Google Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/drive/folders/1lX7njbaUDM63-8ASZiqsFC-9nkAF1DwJ?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Presentation overview",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1spuDd_KDS-nMTAEU2U13gZWatoncXYyS/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "489 proposal",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1g_TKjzrMpeNXOvQyzn7cGAYpkbNGIYm8/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "DeKeyeser 2000",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1VZ0XqDZ6QU9cVc4uR3qVPihDs8CoSwBO/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Presentation signin",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/14Dkyumlcuu57epJh4ocFZq7qyn7nqIvT/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Evaluation criteria for presentation",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1jiAV5O1CITrdq-6si6V5ZxDGs7z7Bkwb/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Backup presentation for 489",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1RdriDi1gosEPo0YP3NdOZXftYfOpdzu4/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Speech recognition article shared by Heting",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1Om9c0AtDyC0XHp6_5b_gxJlDnLIT0cM2/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Result by Heting",
    "Entity": "File",
    "Sub-type": "Txt",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1SfkW5H3XTQpgb6upL1vGLU8h3h3a3Wm4/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Fake image project by Sanjay",
    "Entity": "File",
    "Sub-type": "Google Slides",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1HiLh21fRZIyMR_YjNoDiDBFqHm2FbYnd/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Definitive terms of service",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/19oXbk53GjPtHhhW8nV90tWBcORPfbj6l/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Query parser written by Yucheng",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/document/d/1oIWNogv746TBzI42GMQtQN_DvJC2mBQwYaaPoFpN2JQ/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Transformer library by Heting",
    "Entity": "File",
    "Sub-type": "Ipynb",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1o3JXhPjzLH7DCAjbIa5KRQDcVnNQu6-G/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "json helpers",
    "Entity": "File",
    "Sub-type": "Py",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1dq_DVghqdQeHPBCs1rGGcZ2dm6kuO-qC/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "vertext messages",
    "Entity": "File",
    "Sub-type": "Json",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1mrXlE046VT0Nbx32fNe0SBXYdDy1xgKY/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Warner & Richardson 2017",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1EYLoCxG-cNgM5nHcyxybutoZ9dqN6-M4/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Rubric for teaching philosophy",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1nRNZlc3KM1sd25ZS7bbRi-nXGGa8Ao9u/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "UM paper on teaching philosophy",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/12aUW0eQsI9-JfQsxH0Sh0vCW8Hv0FJ1r/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Teaching statement as a portrait",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://drive.google.com/file/d/1QSutBXkxxRqyf9HORZIW_6jYaOW4FcxJ/view?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "Neeva idea dump",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://docs.google.com/document/d/1W6HMXHzG3mDszKyYDhv09wN9WhM-9JgKBpkqE6N24YM/edit?usp=sharing",
    "Channel": "",
    "Platform": "GDrive",
    "Accounts": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com",
    "Login-email": "trova.testuser5@gmail.com; trova.testuser7@gmail.com; trova.testuser10@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com; trova.testuser13@gmail.com"
  },
  {
    "Query": "",
    "Entity": "",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "",
    "Accounts": "",
    "Login-email": ""
  },
  {
    "Query": "Week 13 materials",
    "Entity": "File",
    "Sub-type": "Dropbox Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/sh/lhx9z04ift836fb/AAA5DxqkAxC_6qEBaTbAOMxZa?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Comments from Week 14",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/scl/fi/r8ayk0ntoo8sfhibqugcw/Comments.docx?dl=0&rlkey=krp39bx26x26o3uua5ui8xfeq",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": 505,
    "Entity": "File",
    "Sub-type": "Dropbox Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/sh/nfewnmu1sw50i7j/AADJgvI_iwyHdd8nnXh9hmnYa?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Week 4 slides",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/scl/fi/z3h644prw52ek39ccjm1x/ITAL-505.pptx?dl=0&rlkey=wejessctswwyq1tj36iwi2cfn",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Definitive presentation for week 4",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/aerse1clt1094hk/ITAL%20505.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Field reflection folder",
    "Entity": "File",
    "Sub-type": "Dropbox Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/sh/bt09kg2775qknr5/AABi8ehcFuqBfX66DQRs_1fPa?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "MLA report from Week 1",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/tkium1osx1018z9/Final%20MLA%20report%20.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Strategies paper by Kumaravidelu",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/vujy3iqha94nwno/Kumaravidelu%20%282003%29%20Beyond%20methods%3A%20macrostrategies%20for%20language%20teaching.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Language teaching history",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/rwhre6oyi17tzxu/History%20of%20Language%20Teaching.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Chapter 4",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/vewykd42p7v52co/Kumar%202006%20Chapter%204.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Principles chapter by Brandl",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/59zzr6x5ihlhqg3/Brandl%20%282001%29%20Principles%20of%20CLT%20and%20Task-Based%20Instruction.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Planning by Brandl",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/2q058ef6cyk0bzz/Brandl%20%282008%29%20Short-term%20and%20Daily%20Planning.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Lesson design",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/qug37zoaacrt8d4/Lesson%20Design.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "TL comprensibility",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/qntmt65ttlgbjzo/Facilitating%20target%20language%20comprehensibility.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Allen 2010",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/c1o7xtpuvndx24f/Allen%202010.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "MLA report",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/01pww5spsylppks/Foreign%20Languages%20and%20Higher%20Education_%20New%20Structures%20for%20a%20Changed%20World%20_%20Modern%20Language%20Association.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Understanding multiliteracies",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/k0pib40w14dkm2b/Understanding%20the%20multiliteracies%20framework.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Introducing vocabulary",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/zrqiu6se571nf2r/Brandl%20%282008%29.%20Getting%20started%3A%20introducing%20vocabulary.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Chapter 6 by Rankin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/xsbl6g0sz3kmsth/Rankin%202018.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Supporting your brain",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/jk1h8wltc2m8a82/Schuetze%20%282018%29.%20Supporting%20your%20brain%20learning%20words.pdf.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Gioconda",
    "Entity": "File",
    "Sub-type": "Jpg",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/6hg04vgj1465isl/687px-Mona_Lisa%2C_by_Leonardo_da_Vinci%2C_from_C2RMF_retouched.jpg?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Cat story",
    "Entity": "File",
    "Sub-type": "html",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/qnpyusimkjtztzk/Cat%20story.html?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Cinema paradiso",
    "Entity": "File",
    "Sub-type": "jpg",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/7q0qiwc7vb09k8w/cinemaparadiso-1%20%281%29.jpg?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Maraini flyer",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/id3cjsgb941hf94/ILCS%20Maraini%2019%20nov.%202020.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Trova",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/sh/cme14s44r1kvdw2/AADOTtdNi26HIMw65JEDWo2Ya?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "citl application",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/6cc2ohvfsis7bf7/gtc-application-citl-2013.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Game based learning",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/dksrmoohguaflwn/An%20Approach%20to%20D%20igital%20Game%20-%20b%20ased%20L%20earnin.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Connectives",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/oinwtqyao5zu2hh/Connectives.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Baek & Park 2019",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/gqncwfvy9felei4/Baek%20%26%20Park%20%282019%29.%20LEARNING%20A%20LANGUAGE%20THROUGH%20GAMING.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Xu 2020",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/dq2c13r9v4rsc4v/Xu2020_Article_AScopingReviewOfDigitalGame-ba.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Chapter about grammar written by Brandl",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/vdbm0nk9goh4ps1/Brandl%20%282008%29.%20Grammar%20and%20language%20learning.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Fornara & Lomicka 2019",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/8vwf5uwqf411ezd/Fornara%20%26%20Lomicka%202019.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Grammar by pad",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/0q4oqysffwwbsfu/Reconceptualizing%20grammar%20and%20vocabulary%20as%20meaning-making%20resources%20-%20PAD.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Inductive presentation from Paesani",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/y8a8dr2tc0h0gmq/Paesani%20%282005%29.%20Literary%20texts%20and%20grammar%20instruct%E2%80%A6ive%20presentation.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Hltp 3",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/whybegqwbjigqsl/HLTP%20%233.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "PAD chapter on reading",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/p03wddrsua763ho/PAD%20-%20Teaching%20reading%20as%20construction%20meaning%20from%20texts.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Peer response paper by Turpin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/gw1s679ev29f5yi/Training%20Foreign%20Language%20Learners%20to%20be%20Peer%20Responders%3A%20A%20Multiliteracies%20Approach.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Teaching to write",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/wv7rooprqc96jun/Teaching%20Writing%20as%20Designing%20Meaning%20Through%20Texts.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "High leverage practices 2",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/odr2q8uslugd30g/High%20Leverage%20Teaching%20Practices%20%232.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Chapter on video listening",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/6f7mfhxbcjzlumf/Teaching%20video-mediated%20listening%20as%20constructing%20meaning%20from%20texts.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Labelling tool slides",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/scl/fi/yz9l5alzds56feui34i2b/Labeling-Tool-Roadmap.pptx?dl=0&rlkey=r577cccdmwnfavkx0pktmijy5",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Trova log",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/scl/fi/0dr24sabz6da33plild0i/Trova-Development-Log.pptx?dl=0&rlkey=sr6vtm6jhyihjeyzupdv3hdxn",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "SIS slides",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/scl/fi/f59vj9vqcgqyd75c2xxev/Stuff-I-ve-Seen.pptx?dl=0&rlkey=nd4vvu0k3j4s2o5lf0hoeumu2",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Queries",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/scl/fi/njfdswehalv4qq2umslel/Trove.xlsx?dl=0&rlkey=1jovtwrn2dx05apukf4bpz5ci",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Readings",
    "Entity": "File",
    "Sub-type": "Dropbox Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/sh/dghb7j2ykk6huwu/AADO2Use-DIddzxOFz3-tS7Za?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Amazon readings",
    "Entity": "File",
    "Sub-type": "Dropbox Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/sh/p3vy4q05pijts6j/AABy-jm5bXyiCytrYSM9v8Fga?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Real time recommendation from 2020",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/xlu5mahwi72dh2s/Ma%20et%20al%20%282020%29.%20Temporal-Contextual%20Recommendation%20in%20Real-Time.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Bandits approach paper",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/f9dn9eqjs8k0pja/multi_armed_bandits.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "pmf",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/qyw9c0pmb4zx34v/pmf.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Amazon recommendations",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/1mwcod4gswcn88w/Amazon.com%20Recommendations%20Item-to-Item%20Collaborative%20Filtering.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Smith and linden 2017",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/zkaihw9fj0hh36g/Smith%20%26%20Linden%20%282017%29.%20Two%20decades%20of%20recommender%20system%20at%20amazon.com.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Email search",
    "Entity": "File",
    "Sub-type": "Dropbox Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/sh/vg1u9u326seeotw/AAAI1IN2i8sAdxPoi6X_w0CRa?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Selection bias article",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/pff2ujq0a6vuemw/LTR_w_selection_bias_in_personal_search.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Situational context ranking by Zamani",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/kz0845uqkatqcbe/situational_context_for_ranking_in_personal_search.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Paper about tf ranking",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/0l4xb2q2fqikq5k/TF-ranking.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personal search",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/sh/bs7t91drykmv5al/AACAYstjdzDQCRmOryccIsrga?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Bert article from 2021",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/77mpdwdoonzmzi8/Rethink%20Training%20of%20BERT%20Rerankers%20in%20Multi-Stage%20Retrieval%20Pipeline.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "bergman 2008",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/kt1h5mbkfpb9op7/bergman2008.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "rank by time or relevance",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/9zj04xecyinyfnr/RankByTimeByRelevance-CIKM2015.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Using provenance",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/b3di20oo3psvoe9/Using%20Provenance%20to%20Aid%20in%20Personal%20File%20Search.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "June substitutes",
    "Entity": "File",
    "Sub-type": "Dropbox Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/sh/blg6dts1b45erfd/AACXbjURrD8mwn-1LLn0vUbCa?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "snapon",
    "Entity": "File",
    "Sub-type": "Dropbox Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/sh/6c4978jy5uf93sh/AAAMwMiHIfsqYrRkdVqpwY9ia?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "June overbought items",
    "Entity": "File",
    "Sub-type": "Png",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/gh3dgdxgyf9xjb4/overbought.png?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Underselling items in June",
    "Entity": "File",
    "Sub-type": "Png",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/s034sgjetiz5mbl/underbought.png?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Item count",
    "Entity": "File",
    "Sub-type": "Json",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/xve5lqwdf6bg6j0/item2count_145.json?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Occurences",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/2egpy4bb8azdd2n/occurrences.csv?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Purchases histogram",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/scl/fi/64r9469bckib7kwltd2iq/product_purchase_histogram.pptx?dl=0&rlkey=dnzhvz83is8falbteih0aclgw",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Definitive purchase histogram",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/749xymruw7u5wxd/product_purchase_histogram.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "June histogram",
    "Entity": "File",
    "Sub-type": "Dropbox Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/sh/6w95lkozbbn79qq/AABgotLy1LIu0QFkndiwib8Ca?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Phase 1",
    "Entity": "File",
    "Sub-type": "Dropbox Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/sh/na0pjsnxglctr83/AADWH6HEd_s80gB9Dwa3AoFma?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "deep network embedding",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/78m8uxln9i85hvu/deep_network_embedding.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Ebay paper from 10 years ago",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/jh5sbmc0lrhsdrs/ebay.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Inferring products network",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/yp0e6q8lnrepi18/inferring_network.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "item2vec",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/9f1jmf6vwc2to3a/item2vec.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Linked vae article",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/p097l2gzd3ofg2z/linked_vae.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "nn product embedding",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/qowf2jrwykynzal/nn_product_embedding.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "shopper",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/7oy095iezhtwqrs/shopper.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "ivhq certificate",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/9l425omqqby5m8q/IVHQ%20certficate.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "personal statement",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/rfl7uvi0v1b2es9/undergraduate%20application%20personal%20statement.pages?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Yaning",
    "Entity": "File",
    "Sub-type": "Dropbox Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/sh/q8m7ny57ii1s34l/AADV9R5plD2sM_Nb0z_YqijIa?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "underbought json",
    "Entity": "File",
    "Sub-type": "Json",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/4b3dircq1p457pq/underbought_lut.json?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "overbought json",
    "Entity": "File",
    "Sub-type": "Json",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/a05u1lmfcxuhhgu/overbought_lut.json?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "json file without pics",
    "Entity": "File",
    "Sub-type": "Json",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/qtf87edcql886sh/without_pictures.json?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "actfl summer 2020",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/joymjfkyvuax8f9/ACTFL%20-%20Summer%202020%20copy.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Russel article on anxiety",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/kj5yzgues7ulitn/Russell.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Paper for week 13",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/z63xz2aczzqrabr/WarnerRichardson%282017%29.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Teaching philosophy rubric",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/uw2mxqj7d082bis/TeachingPhilosophyRubric.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Um teaching philosophy",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/45r4k4sy1w36xy5/Teaching%20Philosopy%20with%20Rubric_UM.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Teaching statement as portrait",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/61v905pppk283ho/Teaching%20Statement%20as%20Self-Portrait%20_%20Chronicle%20Community.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "World language standards",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/xpyyvq4cyxt5hn5/World-ReadinessStandardsforLearningLanguages.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "can do statements",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/egrk89fcx0ho2we/Novice%20Can-Do_Statements.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "assessment chapter by clementi & terrill",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/sqsd83nz6zliln9/Assessment%20Clementi%20%20Terrill.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Culture standards",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/lr6hequ4o2z2h45/Cultures_Standard.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Teaching for dialogue",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/hfbricydxx7815e/Making%20a%20difference%3A%20Language%20teaching%20for%20intercultural%20and%20international%20dialogue.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Paper by Kramsch",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/xp4v0zjem9uqq1r/Kramsch%20%282013%29.%20Teaching%20Culture%20and%20Intercultural%20Competence.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "snapon slides from may",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/scl/fi/v1pqrqeql3cb23jgr3rqf/0531.pptx?dl=0&rlkey=qgmwpjiow2i4ue9pjevcpidfx",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "slides for june first",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/scl/fi/vqtdnx9t80g45wvy4mxrl/0601.pptx?dl=0&rlkey=csv25aybsqymto6mesv23i5jr",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "definitive slides for june 7",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/9undspjb71ur1e3/0607.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "slides for june 7",
    "Entity": "File",
    "Sub-type": "Ppt",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/scl/fi/uhqd1mzge5g6l2ec39q63/0607.pptx?dl=0&rlkey=n0gev4el3me59ngbv6tz76yub",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "intro folder",
    "Entity": "File",
    "Sub-type": "Dropbox Folder",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/sh/ifmnrvkoo46keab/AAC4-GJRxoctXpQN1ze1kFmva?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "target selection",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/6dn28swusvg311b/Target%20app%20selection.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Paper about stuff ive seen",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://www.dropbox.com/s/s67tjaz056ycr5u/Stuff_Ive_Seen_A_System_for_Personal_Information_.pdf?dl=0",
    "Channel": "",
    "Platform": "Dropbox",
    "Accounts": "trova.searchtest@gmail.com",
    "Login-email": "trova.testuser4@gmail.com; trova.testuser8@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "",
    "Entity": "",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "",
    "Accounts": "",
    "Login-email": ""
  },
  {
    "Query": "Gmail format results reported by Omer",
    "Entity": "Jira ticket",
    "Sub-type": "Task",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-1",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Null check by Lijian",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-2",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Blank page assigned to Vali",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-3",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Blank page to Vali",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-3",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Format by Omer",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-4",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Slack results ticket",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-5",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Result ticket filed by Surendra",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-6",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Result ticket assigned to Vali",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-6",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Failed login by Lijian",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-7",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Google drive modal from Lijian",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-8",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Multiple accounts to Vali",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-10",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Dots misplacement reported by Lijian",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-11",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Status code validation",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-12",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Problem with dropbox account url",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-13",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "id instead of username",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-15",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "feedback color change by Yucheng",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-14",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "feedback color change to Holly",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-14",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Ticket about slack accounts by Yucheng",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-16",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Slack accounts to Vali",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-16",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "GDrive popup window",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-17",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Keyword highlight",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-18",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "# in direct messages",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-19",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Click database by Holly",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-20",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Click database assigned to Vali",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-20",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Signup button reported by Omer",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-21",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "gmail entities by display",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-22",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Floating dots by Lijian",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-23",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "How it works update for Vali",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-24",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "How it works update created by Holly",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-24",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Slack search crash",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-25",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Privacy policy ticket by Holly",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-26",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Privacy policy ticket assigned to me",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-26",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "wrong pages",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "web-27",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Dropbox shared spaces from Lijian",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-28",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Epic ticket by Holly",
    "Entity": "Jira ticket",
    "Sub-type": "Epic",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-29",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Image error reported by Holly",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-30",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Dropbox autoconnection to Lijian",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-31",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Result highlight by Omer",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-32",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Query highlight in results to Vali",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-32",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Signin page bug reported by Shuchen",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-34",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Filter bug reported by Elena",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-35",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Empty slack messages",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-36",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "html display from Shuchen",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-37",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Holly's ticket about slack messages",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-38",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Filter bug by Holly",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-39",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Filter issue to Vali",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-39",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Improvement for result area",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-40",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Arrows bug by Elena",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-41",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Arrows ticket for Vali",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-41",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "go to message ticket",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-42",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Clickable links ticket for Vali",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-43",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Clickable link from Elena",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-43",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "connect button from Omer",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-44",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Important sorting bug by Kevin",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-45",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Design update requested by Holly",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-46",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Signin logo bug by Holly",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-47",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Adding privacy",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-48",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Improvement about footer by Holly",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-49",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Improvement about footer for Vali",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-49",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Signin reminder",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-50",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Font ticket by Holly",
    "Entity": "jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-51",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Font ticket to Vali",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-51",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Responsive design improvement",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-52",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Teams usernames",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-55",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Layout bug reported by Holly",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-53",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Time in slack messages",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-54",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Safari logo",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-56",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Link concatenation by Yaning",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-57",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Task about privacy update from Holly",
    "Entity": "Jira ticket",
    "Sub-type": "Task",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-58",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Task about privacy for Vali",
    "Entity": "Jira ticket",
    "Sub-type": "Task",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-58",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Slack channels names",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-59",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Ranking bug reported by Kevin",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-60",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "No results ticket by Omer",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-1",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Slack usernames",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-2",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Issue about slack messages",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-3",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "slack results from shuchen",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-4",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "slack results ticket for chak",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-4",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Knowledge graph bug reported by Omer",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-5",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Disentanglement bug from me",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-6",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Double messsages problem",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-7",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "error 500",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-9",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "slack search bug for Shuchen",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-11",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Bug about slack search by Omer",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-11",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "sender is not matched",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-12",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "sender bug by Omer",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-12",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "gmail client secret",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-15",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Ticket on quotation by Yaning",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-16",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Locahost bug",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-17",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Link problem reported by Omer",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-18",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Link bug assigned to Shuchen",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-18",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "No results found",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-20",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "k8s issue from omer",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-21",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Timeout by kevin",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-22",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Timeout ticket assigned to Lijian",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-22",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Second font ticket by Holly",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-61",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Teams bug from Chak",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-62",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Parser bug reported by Kevin",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-63",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Loading design",
    "Entity": "Jira ticket",
    "Sub-type": "Improvement",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-64",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Slack message without preview",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-65",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Slack message stuck",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-66",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Duplicated slack message",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-67",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Unresponsive buttons",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-68",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Ticket about tabs by Elena",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-69",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Names in slack preview",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "WEB-70",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "wrong slack results ticket to shuchen",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-31",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "number of slack results",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-20",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Results mismatch from Kevin",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-29",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Update is not working",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-28",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Clickable links",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-27",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Go to message malfunction",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-24",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Repeated entity ticket by omer",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-23",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Unclickable gmail links",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-27",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Go to message bug",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-26",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Update bug by omer",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-28",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Reranker mismatch from Kevin",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-29",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Error in vector indexing",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-32",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Ticket about wrong slack results",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-31",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Update of gmail results assigned to Shuchen",
    "Entity": "Jira ticket",
    "Sub-type": "Task",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-33",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Empty gmail results",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-36",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Expaned message in gmail results",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-37",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Ticket about edge cases by Yaning",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-34",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Teams go to message bug filed by Yucheng",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-39",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Dev malfunction ticket assigned to Shuchen",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-40",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "Bug about html email display to Shuchen",
    "Entity": "Jira ticket",
    "Sub-type": "Bug",
    "Date and time": "",
    "Subject": "",
    "IDs": "BAC-42",
    "Channel": "",
    "Platform": "Jira",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser9@gmail.com"
  },
  {
    "Query": "",
    "Entity": "",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "",
    "Accounts": "",
    "Login-email": ""
  },
  {
    "Query": "Scrum meeting info",
    "Entity": "Event",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625595081101?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625594727139&teamName=gotrova.ai&channelName=Testing&createdTime=1625595081101",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Scrum link by Elena",
    "Entity": "Link",
    "Sub-type": "Google Meet",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625594727139?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625594727139&teamName=gotrova.ai&channelName=Testing&createdTime=1625594727139",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Development log",
    "Entity": "File",
    "Sub-type": "Google Slides",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625609678983?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625594727139&teamName=gotrova.ai&channelName=Testing&createdTime=1625609678983",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Article on tf rank",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "",
    "Accounts": "",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Slack output from Shuchen",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:7a13deee47914b1db79699c50169d482@thread.tacv2/1621464758123?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=0de0bd56-5098-48c9-858a-194295433882&parentMessageId=1621464758123&teamName=trova-search-test&channelName=General&createdTime=1621464758123",
    "Channel": "General",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Doordash link from Elena",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625601286446?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625601286446&teamName=gotrova.ai&channelName=Testing&createdTime=1625601286446",
    "Channel": "",
    "Platform": "",
    "Accounts": "",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Elena's promo code",
    "Entity": "Code",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625601304270?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625601286446&teamName=gotrova.ai&channelName=Testing&createdTime=1625601304270",
    "Channel": "",
    "Platform": "",
    "Accounts": "",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Dropbox issue shared by Elena",
    "Entity": "Link",
    "Sub-type": "Jira",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "",
    "Accounts": "",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Screenshot shared by Shuchen",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "WEB-28 sent to Elena",
    "Entity": "Link",
    "Sub-type": "Jira",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Feature bucket list from Shuchen",
    "Entity": "File",
    "Sub-type": "Google Slides",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:b01a8f44d459485a9bafdfb24a3a6d77@thread.tacv2/1620697685671?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=0de0bd56-5098-48c9-858a-194295433882&parentMessageId=1620697685671&teamName=trova-search-test&channelName=Planning&createdTime=1620697685671",
    "Channel": "Planning",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Architecture slides by Yuchen",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:b01a8f44d459485a9bafdfb24a3a6d77@thread.tacv2/1620318514100?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=0de0bd56-5098-48c9-858a-194295433882&parentMessageId=1620318514100&teamName=trova-search-test&channelName=Planning&createdTime=1620318514100",
    "Channel": "Planning",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Marcos dataset sent by Shuchen",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:a30ad7fcf81b4b2d9a7c7370afc3e915@thread.tacv2/1620697646765?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=0de0bd56-5098-48c9-858a-194295433882&parentMessageId=1620697646765&teamName=trova-search-test&channelName=Marketing%20and%20PR&createdTime=1620697646765",
    "Channel": "Marketing and PR",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Weather forecast link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:7a13deee47914b1db79699c50169d482@thread.tacv2/1625185079927?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=0de0bd56-5098-48c9-858a-194295433882&parentMessageId=1625152469409&teamName=trova-search-test&channelName=General&createdTime=1625185079927",
    "Channel": "General",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Neapolitan pizza place",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625618424090?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625601286446&teamName=gotrova.ai&channelName=Testing&createdTime=1625618424090",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Basil thai website",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625618424090?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625601286446&teamName=gotrova.ai&channelName=Testing&createdTime=1625618424090",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Holly's bucket list",
    "Entity": "Link",
    "Sub-type": "Notion",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:b01a8f44d459485a9bafdfb24a3a6d77@thread.tacv2/1625618594908?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=0de0bd56-5098-48c9-858a-194295433882&parentMessageId=1620697685671&teamName=trova-search-test&channelName=Planning&createdTime=1625618594908",
    "Channel": "Planning",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Lunch wheel",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625620178838?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625601286446&teamName=gotrova.ai&channelName=Testing&createdTime=1625620178838",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "QR code sent to test.user1",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "User survey link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Survey results shared with trova.testuser11",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Results spreadsheet",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Paper about difficult searches",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Confluence page on search behaviour",
    "Entity": "Link",
    "Sub-type": "Confluence",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625622550330?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625622109711&teamName=gotrova.ai&channelName=Testing&createdTime=1625622550330",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Booking link shared by Elena",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625622784664?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625622688056&teamName=gotrova.ai&channelName=Testing&createdTime=1625622784664",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Trova address",
    "Entity": "Location",
    "Sub-type": "Address",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625624146404?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625623273957&teamName=gotrova.ai&channelName=Testing&createdTime=1625624146404",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Link to bing work by trova.testuser6",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625624528441?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625624528441&teamName=gotrova.ai&channelName=Testing&createdTime=1625624528441",
    "Channel": "",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "FAQs shared with trova.testuser6",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Comments by trova.testuser6",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Snapon slides written by Trova Admin",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625625238041?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625625238041&teamName=gotrova.ai&channelName=Testing&createdTime=1625625238041",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Trove",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625626398652?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625626296131&teamName=gotrova.ai&channelName=Testing&createdTime=1625626398652",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Baseline queries from Elena",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625626601919?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625626296131&teamName=gotrova.ai&channelName=Testing&createdTime=1625626601919",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Presentation on Stuff i've seen",
    "Entity": "File",
    "Sub-type": "Google Slides",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625627082006?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625626717839&teamName=gotrova.ai&channelName=Testing&createdTime=1625627082006",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Chipotle link shared in testing",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625666781401?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625626717839&teamName=gotrova.ai&channelName=Testing&createdTime=1625666781401",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Test account credentials by trova.testuser6",
    "Entity": "Credentials",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625667296639?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625667148385&teamName=gotrova.ai&channelName=Testing&createdTime=1625667296639",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "x.ai link shared by trova.testuser6",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625668766282?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625668766282&teamName=gotrova.ai&channelName=Testing&createdTime=1625668766282",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Searching to eliminate",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625669161317?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625669161317&teamName=gotrova.ai&channelName=Testing&createdTime=1625669161317",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Paper on mobile unified search",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625669161317?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625669161317&teamName=gotrova.ai&channelName=Testing&createdTime=1625669161317",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "PIM article shared by Elena",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625669161317?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625669161317&teamName=gotrova.ai&channelName=Testing&createdTime=1625669161317",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "IDs instructions by trova.testuser10",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625669815528?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625669815528&teamName=gotrova.ai&channelName=Testing&createdTime=1625669815528",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Query guidelines shared by trova.testuser11",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625669960377?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625669960377&teamName=gotrova.ai&channelName=Testing&createdTime=1625669960377",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Security practices by trova.testuser1",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625670159121?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625670159121&teamName=gotrova.ai&channelName=Testing&createdTime=1625670159121",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Sus calculator shared by Elena",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625670462262?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625670409857&teamName=gotrova.ai&channelName=Testing&createdTime=1625670462262",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Survey by Elena",
    "Entity": "Link",
    "Sub-type": "Google Forms",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625670556674?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625670556674&teamName=gotrova.ai&channelName=Testing&createdTime=1625670556674",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Planning presentation by trova.testuser10",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625670668969?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625670668969&teamName=gotrova.ai&channelName=Testing&createdTime=1625670668969",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "How trova works",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625670919660?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625670919660&teamName=gotrova.ai&channelName=Testing&createdTime=1625670919660",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Onboarding bucket list",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625671504958?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625671504958&teamName=gotrova.ai&channelName=Testing&createdTime=1625671504958",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "Search history by trova.testuser10",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625671876018?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625671876018&teamName=gotrova.ai&channelName=Testing&createdTime=1625671876018",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "App link sent by Elena",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625672425339?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625672425339&teamName=gotrova.ai&channelName=Testing&createdTime=1625672425339becbf202b6eb&parentMessageId=1625671876018&teamName=gotrova.ai&channelName=Testing&createdTime=1625671876018",
    "Channel": "Testing",
    "Platform": "Teams",
    "Accounts": "cloud@gotrova.ai",
    "Login-email": "trova.testuser6@gmail.com; trova.testuser10@gmail.com"
  },
  {
    "Query": "",
    "Entity": "",
    "Sub-type": "",
    "Date and time": "",
    "Subject": "",
    "IDs": "",
    "Channel": "",
    "Platform": "",
    "Accounts": "",
    "Login-email": ""
  },
  {
    "Query": "G2m to do list from Simon",
    "Entity": "List",
    "Sub-type": "",
    "Date and time": "Mar 19, 2021, 12:10 AM",
    "Subject": "Final Decision: G2M 3.0",
    "IDs": "<CALV-+1dYNbmBQnMQDGQsCvAa9N=Kh_VepWQ306Lo=hh-Gzc8ew@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify offer",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Mar 17, 2021, 12:16 PM",
    "Subject": "RE: AW: Contact Form [ ref:_00DG0Cbyq._5001M1fs6ZJ:ref ]",
    "IDs": "<CAC=hQbm4_+g9gkqXnKZP174ihm2-vR6G+3gCxQxD9H-6HJ3_Dw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Offer to EUTEC",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Mar 17, 2021, 12:16 PM",
    "Subject": "RE: AW: Contact Form [ ref:_00DG0Cbyq._5001M1fs6ZJ:ref ]",
    "IDs": "<CAC=hQbm4_+g9gkqXnKZP174ihm2-vR6G+3gCxQxD9H-6HJ3_Dw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Updated offer from Personify",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Wed, Mar 17, 1:37 PM",
    "Subject": "RE: AW: Contact Form [ ref:_00DG0Cbyq._5001M1fs6ZJ:ref ]",
    "IDs": "<CAC=hQbnA84Ny5HyMcSd=osBO9k2LYgL6L6T+AjK7NJOoNX6hXQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Updated eutec offer",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Wed, Mar 17, 1:37 PM",
    "Subject": "RE: AW: Contact Form [ ref:_00DG0Cbyq._5001M1fs6ZJ:ref ]",
    "IDs": "<CAC=hQbnA84Ny5HyMcSd=osBO9k2LYgL6L6T+AjK7NJOoNX6hXQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "eutec address",
    "Entity": "Location",
    "Sub-type": "",
    "Date and time": "Wed, Mar 17, 2:09 PM",
    "Subject": "RE: AW: Contact Form [ ref:_00DG0Cbyq._5001M1fs6ZJ:ref ]",
    "IDs": "<9D86ECC7-D10C-41A7-9F69-0524757F6981@eutec.org>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify PayPal link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, Mar 17, 6:23 PM",
    "Subject": "RE: AW: Contact Form [ ref:_00DG0Cbyq._5001M1fs6ZJ:ref ]",
    "IDs": "<1704BF39-A817-4A78-9A3C-C7D8C23737B7@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Korean customer from Philip",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Thu, Mar 18, 9:30 PM",
    "Subject": "Payment check",
    "IDs": "<007701d71c67$c6c5a5d0$5450f170$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "March PO from Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Mar 18, 7:55 PM",
    "Subject": "PO from Japan",
    "IDs": "<005601d71c5a$936e4230$ba4ac690$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Ai crib from surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Mar 17, 10:49 PM",
    "Subject": "your thoughts",
    "IDs": "<CAKVuy5FjE8WJW=Df+OEMSWXrAgJkdzmaBObKnX2WPzCt3jDJXA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "AI crib sent to Byron",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Mar 17, 10:49 PM",
    "Subject": "your thoughts",
    "IDs": "<CAKVuy5FjE8WJW=Df+OEMSWXrAgJkdzmaBObKnX2WPzCt3jDJXA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "MacBook suggestions",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "Tue, Mar 16, 5:43 AM",
    "Subject": "Request Device",
    "IDs": "<CAKng2fHB9iTdgWz4NXJm149ZgPe_V9=v6JzcJ3P=oG+61crxMQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Pricing",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Mar 17, 2021, 3:41 PM",
    "Subject": "RE: contract call [ ref:_00DG0Cbyq._5001M1f1JVH:ref ]",
    "IDs": "<5bxt_000000000000000000000000000000000000000000000QQ4S5G00VuZmhGORQ7OGAEzkW3PzzA@sfdc.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "MHM invoice from Khoa",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, March 16, 2021, 3:58 PM",
    "Subject": "SOC2 Invoice",
    "IDs": "<7D1C1D15-974E-45D5-B1C2-126401FC35B7@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "MHM payment details from Khoa",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, March 16, 2021, 3:58 PM",
    "Subject": "SOC2 Invoice",
    "IDs": "<7D1C1D15-974E-45D5-B1C2-126401FC35B7@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "mhm contract from Khoa",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, March 16, 2021, 3:58 PM",
    "Subject": "SOC2 Invoice",
    "IDs": "<7D1C1D15-974E-45D5-B1C2-126401FC35B7@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Support link from Loron",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Tue, Mar 16, 2021, 2:57 PM",
    "Subject": "RE: INF5601W panels - Mac Driver",
    "IDs": "<MWHPR08MB34052B9EE523426C3F7456169E6B9@MWHPR08MB3405.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Goshen it director",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Thu, Mar 11, 2021 6:43 AM",
    "Subject": "Re: Looking at panels",
    "IDs": "<MWHPR08MB34052B9EE523426C3F7456169E6B9@MWHPR08MB3405.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Rick Davis email from Tod",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Wed, Mar 10, 2021, 6:23 PM",
    "Subject": "Looking at panels",
    "IDs": "<MWHPR08MB34052B9EE523426C3F7456169E6B9@MWHPR08MB3405.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Rick Davis' number from Tod",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Wed, Mar 10, 2021, 6:23 PM",
    "Subject": "Looking at panels",
    "IDs": "<MWHPR08MB34052B9EE523426C3F7456169E6B9@MWHPR08MB3405.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "SOC2 client profile from Khoa",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Mon, Mar 15, 8:35 PM",
    "Subject": "SOC 2 Auditing service from MHM Corporation",
    "IDs": "<F23EBD77-1F66-491A-A742-D0F1F9A807A8@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "SOC2 contract draft from Khoa",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Mon, Mar 15, 8:35 PM",
    "Subject": "SOC 2 Auditing service from MHM Corporation",
    "IDs": "<F23EBD77-1F66-491A-A742-D0F1F9A807A8@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Updated soc2 from dustin",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Tue, Mar 16, 2:02 PM",
    "Subject": "SOC 2 Auditing service from MHM Corporation",
    "IDs": "<MWHPR0801MB37225F585BA7247E373C53E2876B9@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "SSA by Snowflake",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Mon, Feb 1, 2021 at 10:38 PM",
    "Subject": "Re: Vendor Security Assessment For Personify Presenter [Urgent Feedback Required] [ ref:_00DG0Cbyq._5001M1eydje:ref ]",
    "IDs": "<CAC=hQbn9Pkq9Tz30qD8m833qgip4rZuWDoLCe8sq2v-atx=P5A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "ssa sent to personify",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Mon, Feb 1, 2021 at 10:38 PM",
    "Subject": "Re: Vendor Security Assessment For Personify Presenter [Urgent Feedback Required] [ ref:_00DG0Cbyq._5001M1eydje:ref ]",
    "IDs": "<CAC=hQbn9Pkq9Tz30qD8m833qgip4rZuWDoLCe8sq2v-atx=P5A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "List of CC services",
    "Entity": "List",
    "Sub-type": "",
    "Date and time": "Fri, Mar 12, 1:52 PM",
    "Subject": "List all CC Services",
    "IDs": "<CALV-+1ezFSvPq484zWEzscPBJBCx3qx_SrEJR_6g7uUVd+fZ9A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Website design review from Shauli",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Mar 10, 10:07 AM",
    "Subject": "Website design review",
    "IDs": "<CAAmcMVQ8qp5ABr4nLwC7TeP8F0uDTA9KYt=k2BBQ1=6+rCnecQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Recap of social accounts from Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Mar 1, 6:57 PM",
    "Subject": "Accounts and previous marketing",
    "IDs": "<CAKVuy5G6KGLbwYZUeQEf1hWwgMPoL8=L6a2ucORzRk7FjTGbEg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Social accounts recap to Shauli",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Mar 1, 6:57 PM",
    "Subject": "Accounts and previous marketing",
    "IDs": "<CAKVuy5G6KGLbwYZUeQEf1hWwgMPoL8=L6a2ucORzRk7FjTGbEg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Marcom from Surendra",
    "Entity": "Link",
    "Sub-type": "OneDrive",
    "Date and time": "Mon, Mar 1, 6:57 PM",
    "Subject": "Accounts and previous marketing",
    "IDs": "<CAKVuy5G6KGLbwYZUeQEf1hWwgMPoL8=L6a2ucORzRk7FjTGbEg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Marcom to Shauli",
    "Entity": "Link",
    "Sub-type": "OneDrive",
    "Date and time": "Mon, Mar 1, 6:57 PM",
    "Subject": "Accounts and previous marketing",
    "IDs": "<CAKVuy5G6KGLbwYZUeQEf1hWwgMPoL8=L6a2ucORzRk7FjTGbEg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "New website link from Simon",
    "Entity": "Link",
    "Sub-type": "Figma",
    "Date and time": "Tue, Mar 2, 12:11 AM",
    "Subject": "Accounts and previous marketing",
    "IDs": "<CALV-+1e1ntwOCFt4muP=j=JP6S4QUh5mw=4TSQAG4W=WsmeUww@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Marketing matrix from Philip",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Mar 11, 2021, 8:49 PM",
    "Subject": "Accounts and previous marketing",
    "IDs": "<00d201d716ea$5c364da0$14a2e8e0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Marketing matrix to Shauli",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Mar 11, 2021, 8:49 PM",
    "Subject": "Accounts and previous marketing",
    "IDs": "<00d201d716ea$5c364da0$14a2e8e0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "ChromaCam features link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, Jan 27, 2021, 7: 44 PM",
    "Subject": "[EXT EMAIL] RE: Request for Demo [ ref:_00DG0Cbyq._5001M1f0Bgp:ref ]",
    "IDs": "<1CD84CBF-BA53-4137-8267-E589FEA624F8@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Jason tuttle number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Mar 11, 2021, 11:00 AM",
    "Subject": "RE: 00024526 - Quote 10 annual licenses. [ ref:_00DG0Cbyq._5001M1f0Bgp:ref ]",
    "IDs": "<MN2PR13MB3927492DC53ADF9E508BE2B7C8909@MN2PR13MB3927.namprd13.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Keyword Analysis written by Shauli",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Mar 10, 9:56 AM",
    "Subject": "Status",
    "IDs": "<CAAmcMVSCPW9kbscS-AqPvP9nKUk-cCRAoEyGpbP-d1ZTsv+MxA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Keyword Analysis sent to Surendra",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Mar 10, 9:56 AM",
    "Subject": "Status",
    "IDs": "<CAAmcMVSCPW9kbscS-AqPvP9nKUk-cCRAoEyGpbP-d1ZTsv+MxA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Competitors Analysis from Shauli",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Mar 10, 9:56 AM",
    "Subject": "Status",
    "IDs": "<CAAmcMVSCPW9kbscS-AqPvP9nKUk-cCRAoEyGpbP-d1ZTsv+MxA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Competitors Analysis shared with Surendra",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Mar 10, 9:56 AM",
    "Subject": "Status",
    "IDs": "<CAAmcMVSCPW9kbscS-AqPvP9nKUk-cCRAoEyGpbP-d1ZTsv+MxA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "IOS 10 folder",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Tue, Mar 9, 8:57 PM",
    "Subject": "IOS SDK 1.0 - Invitation to collaborate",
    "IDs": "<00000000000009ba0f05bd25d5a2@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Neoperl address",
    "Entity": "Location",
    "Sub-type": "",
    "Date and time": "Mar 9, 2021, 3:58 PM",
    "Subject": "RE: WG: AW: AW: AW: Company account [ ref:_00DG0Cbyq._5001M1f1ZWx:ref ]",
    "IDs": "<lci9i000000000000000000000000000000000000000000000QPQ2CR00Sy5jSML5S6-MX1tz0E0UBQ@sfdc.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "PsySeg slides from Sanjay",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Mon, Mar 8, 6:27 PM",
    "Subject": "PsySeg Overview - Invitation to edit",
    "IDs": "<000000000000af9c1e05bd0f9eca@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "ChromaCam setup",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, Mar 3, 2021, 10:42 AM",
    "Subject": "Re: [External] : Re: Question about Personify Roadmap and a bit more",
    "IDs": "<CAC=hQbm73W3w4EBaEWQQRWguQCNMP-=M7bs+VQGuPB5veMdR6A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Links for presenter",
    "Entity": "List",
    "Sub-type": "",
    "Date and time": "Mar 5, 2021, 8:05 PM",
    "Subject": "Re: [External] : Re: Question about Personify Roadmap and a bit more",
    "IDs": "<CAC=hQbm2fJhjXTS+azYCLc8nFCKbY+zXe+3iDsCV4MdW4HXbhg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify brochure",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mar 5, 2021, 8:05 PM",
    "Subject": "Re: [External] : Re: Question about Personify Roadmap and a bit more",
    "IDs": "<CAC=hQbm2fJhjXTS+azYCLc8nFCKbY+zXe+3iDsCV4MdW4HXbhg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Presenter update ppt",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Mar 8, 2021, 4:34 PM",
    "Subject": "Re: [External] : Re: Question about Personify Roadmap and a bit more",
    "IDs": "<CALV-+1ew+4XcTJt=9xJCAgSwX4f63S2mDq51Em_DjiWqN=-_Kw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Sanjay feb invoice",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Mar 8, 10:13 AM",
    "Subject": "Feb invoice",
    "IDs": "<MWHPR0801MB372243B25203FCFFC28A31E387939@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Feb invoice to Dustin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Mar 8, 10:13 AM",
    "Subject": "Feb invoice",
    "IDs": "<MWHPR0801MB372243B25203FCFFC28A31E387939@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Security document from Jeremiah",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "Fri, Mar 5, 1:28 PM",
    "Subject": "Chromacam and Personify Presenter Security Information - Invitation to edit",
    "IDs": "<000000000000279a8d05bccf1750@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Deadline for Cisco invoice",
    "Entity": "Date",
    "Sub-type": "",
    "Date and time": "Oct., 29, 2020 1:56 PM",
    "Subject": "FW: 33326026695: Approved - Invoice 20200827CSI - to Cisco (ANID: AN01001638440) - Notification from Ariba Network-Personify Inc-600670",
    "IDs": "<CC17EE39-A3D1-4161-8776-995BA5849FC9@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Surendra number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Thu, Mar 4, 4:07 PM",
    "Subject": "Personify Payments",
    "IDs": "<91C1CE8F-1DCE-498F-BCA3-8000D86880B1@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Meeting info with Keith",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Fri, Mar 5, 10:28 AM",
    "Subject": "Surendra / Keith",
    "IDs": "<SN6PR11MB28803FACECF9734831E742D2DB969@SN6PR11MB2880.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Meeting info with Surendra",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Fri, Mar 5, 10:28 AM",
    "Subject": "Surendra / Keith",
    "IDs": "<SN6PR11MB28803FACECF9734831E742D2DB969@SN6PR11MB2880.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify support link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Feb 3, 2021 11:13 PM",
    "Subject": "no camera found [ ref:_00DG0Cbyq._5001M1f1EDG:ref ]",
    "IDs": "<fd6ea86312cd42c68f2c27e43d3c3376@olb.de>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Script download from Personify",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Freitag, 12. Februar 2021 11:24",
    "Subject": "회신: AW: no camera found [ ref:_00DG0Cbyq._5001M1f1EDG:ref ]",
    "IDs": "<005001d70180$0480cab0$0d826010$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Public installer from Hai",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Thu, Feb 18, 9:59 PM",
    "Subject": "WG: AW: no camera found [ ref:_00DG0Cbyq._5001M1f1EDG:ref ]",
    "IDs": "<CAGMeF1QchOVJpK-dhitsZQWeDgeUVxotzoqLhRQ=uuBjt-kqGw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Public installer sent to Philip",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Feb 19, 2021, 5:56 PM",
    "Subject": "WG: AW: no camera found [ ref:_00DG0Cbyq._5001M1f1EDG:ref ]",
    "IDs": "<CAL43u-VYpgEWc2W6wT_nutXvPwBA7UEVN7kxfjS-3bew6Td0bA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Slack link to Jeremiah",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Feb 19, 2021, 5:56 PM",
    "Subject": "WG: AW: no camera found [ ref:_00DG0Cbyq._5001M1f1EDG:ref ]",
    "IDs": "<CAL43u-VYpgEWc2W6wT_nutXvPwBA7UEVN7kxfjS-3bew6Td0bA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Slack link from Long",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Feb 19, 2021, 5:56 PM",
    "Subject": "WG: AW: no camera found [ ref:_00DG0Cbyq._5001M1f1EDG:ref ]",
    "IDs": "<CAL43u-VYpgEWc2W6wT_nutXvPwBA7UEVN7kxfjS-3bew6Td0bA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Issues list from Philip",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Tue, Mar 2, 5:50 AM",
    "Subject": "WG: AW: no camera found [ ref:_00DG0Cbyq._5001M1f1EDG:ref ]",
    "IDs": "<011101d70f5a$44b561d0$ce202570$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Google Analytics account from Simon",
    "Entity": "Link",
    "Sub-type": "Google Analytics",
    "Date and time": "Thu, Mar 4, 3:38 PM",
    "Subject": "Accounts and Continuity",
    "IDs": "<CALV-+1d7ThqyqAF5cdgNHQAnO0Ucy0r+sHanfYSNa7w8XbLtBA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "SOW from Shauli",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Mar 4, 2:48",
    "Subject": "Personify Inc SOW for Marketing",
    "IDs": "<CAAmcMVT2NLpvag7mkeeyawdwQ0rv6fbL-c7U-P-5V5dBHKS7LQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "SOW to Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Mar 4, 2:48",
    "Subject": "Personify Inc SOW for Marketing",
    "IDs": "<CAAmcMVT2NLpvag7mkeeyawdwQ0rv6fbL-c7U-P-5V5dBHKS7LQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Tim's email",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Thu, Mar 4, 11:55 AM",
    "Subject": "Please create Personify email",
    "IDs": "<CAEuirr61O8z2PU2hfodYNALXzKfoXFjsLuRTMLxEvk3nwsKoDA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "March PO from Japan by Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Mar 3, 6:53 AM",
    "Subject": "PO from Japan",
    "IDs": "<027f01d7102c$370c08e0$a5241aa0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "SDK slides from Khoa",
    "Entity": "File",
    "Sub-type": "Google Slides",
    "Date and time": "Tue, Mar 2, 1:07 PM",
    "Subject": "App<->SDK Improvements/Enhancements - Invitation to edit",
    "IDs": "<00000000000076163805bc92725d@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Jeremiah's number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Mar 1, 2021, 6:03 PM",
    "Subject": "Re: 00025066 - Refund [ ref:_00DG0Cbyq._5001M1frMuP:ref ]",
    "IDs": "<CAC=hQbnOmqF_Vj_F-SvxNy_ws1fCLwbsA+cPCv-_V0Ep6q+ODg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "February salaries from Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Feb 26, 2021, 12:22 PM",
    "Subject": "Operation expense estimate 2021-03",
    "IDs": "<CAL43u-V+uWgU0dj9J7xGekYZDW5f8Hcnt05QTWENQPoNeZsL5Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "February salaries sent to Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Feb 26, 2021, 12:22 PM",
    "Subject": "Operation expense estimate 2021-03",
    "IDs": "<CAL43u-V+uWgU0dj9J7xGekYZDW5f8Hcnt05QTWENQPoNeZsL5Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "March estimate by Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Feb 26, 2021, 12:22 PM",
    "Subject": "Operation expense estimate 2021-03",
    "IDs": "<CAL43u-V+uWgU0dj9J7xGekYZDW5f8Hcnt05QTWENQPoNeZsL5Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "March estimate shared with Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Feb 26, 2021, 12:22 PM",
    "Subject": "Operation expense estimate 2021-03",
    "IDs": "<CAL43u-V+uWgU0dj9J7xGekYZDW5f8Hcnt05QTWENQPoNeZsL5Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Acord form from Jeremiah",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Friday, February 12, 2021 5:12 PM",
    "Subject": "[EXTERNAL] RE: Personify ChromaCam contact [ ref:_00DG0Cbyq._5001M1f2LFF:ref ]",
    "IDs": "<5rtPP000000000000000000000000000000000000000000000QONF9D00A1hf-IABSZmz_50ientPIg@sfdc.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify admin guide",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Feb 25, 2021, 5:57 PM",
    "Subject": "RE: Contact Form [ ref:_00DG0Cbyq._5001M1frl6d:ref ]",
    "IDs": "<dc9RA000000000000000000000000000000000000000000000QP3ZVT00WyM83Yl_S8mBHCXfjTeolg@sfdc.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify tutorial",
    "Entity": "Link",
    "Sub-type": "YouTube",
    "Date and time": "Feb 25, 2021, 5:57 PM",
    "Subject": "RE: Contact Form [ ref:_00DG0Cbyq._5001M1frl6d:ref ]",
    "IDs": "<dc9RA000000000000000000000000000000000000000000000QP3ZVT00WyM83Yl_S8mBHCXfjTeolg@sfdc.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Notices for electricity from Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Feb 25, 2021, 4:47 PM",
    "Subject": "1551 McCarthy Blvd., Milpitas - PGE SHUTDOWNS",
    "IDs": "<7937718B-68DA-40F3-BAA9-146DFD17C10C@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify login",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, 24 Feb 2021 at 01:34",
    "Subject": "Reassign Chromacam license",
    "IDs": "<qnoCM000000000000000000000000000000000000000000000QP220E00WXHCxM4UToS7qTaLSG5--Q@sfdc.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Link to startup info",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Feb 24, 2021, 6:51 AM",
    "Subject": "Media interview request",
    "IDs": "<CAJ87cEq6Q9k31vtqPvrQWjO08=qkzqCvL=DzRD3SOf833E-LiQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "SDK Segmentation folder from Khoa",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Tue, Feb 23, 10:42 AM",
    "Subject": "Personify Segmentation SDK (PsySeg) Release 3.6.11.5 - Invitation to collaborate",
    "IDs": "<00000000000005ba9105bc039938@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Agent number in Vietnam",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Monday, February 22, 2021 12:29 PM",
    "Subject": "RE: Re: Vietnam visa application_MTSTW",
    "IDs": "<CAL43u-WC5tC21x-2VjQJGwzOW0VjC9OJzd=sa_K-6CXkuq-Pug@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Steven's number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Fri, Feb 19, 2021 3:19 PM",
    "Subject": "Re: Vietnam visa application_MTSTW",
    "IDs": "<CAL43u-WC5tC21x-2VjQJGwzOW0VjC9OJzd=sa_K-6CXkuq-Pug@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Whiteboard meeting info",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Tue, Feb 23, 4:45 PM",
    "Subject": "Invitation: Whiteboard and others @ Wed Feb 24, 2021 4pm - 5pm (PST) (Surendra Arora)",
    "IDs": "<000000000000b90eb005bc08ac16@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify roadmap",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Tue, Feb 23, 12:24 AM",
    "Subject": "Question about Personify Roadmap and a bit more",
    "IDs": "<CALV-+1dPoUpMzZNshzvU_hXOWaVdn=S0gs9MiT=hxqDK33sx4w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "List of services from Long",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "Feb 22, 2021, 9:05 PM",
    "Subject": "Personify business continuity plans",
    "IDs": "<CAL43u-Uj-qaCiFjgyEgp=VH=zu60hdR9S7DC83L+BAryONoGtQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "List of services sent to Tim",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "Feb 22, 2021, 9:05 PM",
    "Subject": "Personify business continuity plans",
    "IDs": "<CAL43u-Uj-qaCiFjgyEgp=VH=zu60hdR9S7DC83L+BAryONoGtQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Phlilp invoice for Janauary",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Jan 24, 2021, 4:12 PM",
    "Subject": "Jan 2021 Invoice - Philip Lee",
    "IDs": "<00d501d6f29e$011a1750$034e45f0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Google invoice from Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 24, 2021, 4:12 PM",
    "Subject": "Jan 2021 Invoice - Philip Lee",
    "IDs": "<00d501d6f29e$011a1750$034e45f0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Background check from Mike",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Feb 22, 2021, 1:51 PM",
    "Subject": "Re: Personify Personnel Security Policy",
    "IDs": "<BY5PR19MB4033217300027CF524ED2FD4C8819@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Business protection agreement from Mike",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Feb 22, 2021, 1:51 PM",
    "Subject": "Re: Personify Personnel Security Policy",
    "IDs": "<BY5PR19MB4033217300027CF524ED2FD4C8819@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Employee form to Khoa",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Feb 22, 2021, 1:51 PM",
    "Subject": "Re: Personify Personnel Security Policy",
    "IDs": "<BY5PR19MB4033217300027CF524ED2FD4C8819@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Offboarding form to Khoa",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Feb 22, 2021, 1:51 PM",
    "Subject": "Re: Personify Personnel Security Policy",
    "IDs": "<BY5PR19MB4033217300027CF524ED2FD4C8819@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "SOC2 Worksheet from Khoa",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Mon, Feb 22, 10:51 AM",
    "Subject": "SOC2 Worksheet - Invitation to edit",
    "IDs": "<000000000000bdd71105bbef9e1d@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "R&D meeting info",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Mon, Feb 22, 6:19 AM",
    "Subject": "Invitation: R&D Work and Priorities updates @ Thu Feb 25, 2021 7pm - 8pm (PST) (Surendra Arora)",
    "IDs": "<000000000000a928ee05bbebd1bf@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "IOS meeting update",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Feb 23, 2021, 9:31 PM",
    "Subject": "Updated invitation: IOS SDK sync @ Tue Feb 23, 2021 7:30pm - 8pm (PST) (Surendra Arora)",
    "IDs": "<00000000000032ef1405bc0cabbd@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "IOS meeting details",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Mon, Feb 22, 6:15 AM",
    "Subject": "Invitation: IOS SDK sync @ Tue Feb 23, 2021 7:30pm - 8pm (PST) (Surendra Arora)",
    "IDs": "<000000000000415fc205bbebc018@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Corporate folder shared by Long",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Fri, Feb 19, 12:06 AM",
    "Subject": "Corporate - Invitation to view",
    "IDs": "<0000000000001d72f205bbaa4209@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Feb Japan PO by Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Feb 17, 10:29 PM",
    "Subject": "PO(20 x PP OA) from Japan",
    "IDs": "<00a001d705ae$97b09720$c711c560$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Presenter intro",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Jan 15, 4:08 AM",
    "Subject": "WG: Company licence chomacam",
    "IDs": "<010501d6eb26$67b13680$3713a380$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Link about presenter",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Fri, Jan 15, 4:08 AM",
    "Subject": "WG: Company licence chomacam",
    "IDs": "<010501d6eb26$67b13680$3713a380$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify phone number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Fri, Feb 12, 1:30 PM",
    "Subject": "00024554 - Chromacam Licenses [ ref:_00DG0Cbyq._5001M1f0Kyl:ref ]",
    "IDs": "<CAC=hQb=Sy-iDNY70PKFT64vAXBAtkVVgw7YSj44mOae84eRX0g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Updates on meeting with Citadel",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Wed, Feb 17, 2:55 PM",
    "Subject": "Webex meeting changed: Personify Chromacam for Citadel Credit Union",
    "IDs": "<1795907785.18985141613595354414.JavaMail.nobody@rsj7rmd001.webex.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Termination agreement for Personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Feb 16, 2021, 4:32 PM",
    "Subject": "FW: Personify (Foxconn)_2020-0382_Partially Executed Termination Agreement",
    "IDs": "<DM6PR11MB33402A3A815F69AB72FF3ADBB1879@DM6PR11MB3340.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Chromacam download",
    "Entity": "Link",
    "Sub-type": "Google Drive",
    "Date and time": "Donnerstag, 4. Februar 2021 06:19",
    "Subject": "회신: ChromaCam without Login [ ref:_00DG0Cbyq._5001M1f13MA:ref ]",
    "IDs": "<00ec01d6fdff$8695f270$93c1d750$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Infocus business protection agreement from Mike",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Feb 11, 5:20 PM",
    "Subject": "Re: Code of Business Conduct",
    "IDs": "<BY5PR19MB4033AB6BCED3F54513324994C88C9@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Infocus COI from Mike",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Feb 11, 5:20 PM",
    "Subject": "Re: Code of Business Conduct",
    "IDs": "<BY5PR19MB4033AB6BCED3F54513324994C88C9@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Infocus ethics from Mike",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Feb 11, 5:20 PM",
    "Subject": "Re: Code of Business Conduct",
    "IDs": "<BY5PR19MB4033AB6BCED3F54513324994C88C9@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Infocus confidentiality policy from Mike",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Feb 11, 5:20 PM",
    "Subject": "Re: Code of Business Conduct",
    "IDs": "<BY5PR19MB4033AB6BCED3F54513324994C88C9@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify employee form from Mike",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Feb 11, 2021, 8:22 PM",
    "Subject": "Re: Code of Business Conduct",
    "IDs": "<BY5PR19MB40339070721B432D76E7BD55C88B9@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify COI from Mike",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Feb 11, 2021, 8:22 PM",
    "Subject": "Re: Code of Business Conduct",
    "IDs": "<BY5PR19MB40339070721B432D76E7BD55C88B9@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify business ethics from Mike",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Feb 11, 2021, 8:22 PM",
    "Subject": "Re: Code of Business Conduct",
    "IDs": "<BY5PR19MB40339070721B432D76E7BD55C88B9@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify confidentiality policy from Mike",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Feb 11, 2021, 8:22 PM",
    "Subject": "Re: Code of Business Conduct",
    "IDs": "<BY5PR19MB40339070721B432D76E7BD55C88B9@BY5PR19MB4033.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Wiseup po from philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, Feb 9, 11:03 PM",
    "Subject": "PO from Hitachi Japan",
    "IDs": "<00ef01d6ff6a$0c85cd40$259167c0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "W9 form from Personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, Feb 9, 1:40 PM",
    "Subject": "RE: FW: 00024790 - CC Pro licenses. [ ref:_00DG0Cbyq._5001M1f1edO:ref ]",
    "IDs": "<A15BE9CA-246F-44C2-BD48-250AE9F8179E@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "ach vendor form from boh",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Feb 9, 2021, 2:38 PM",
    "Subject": "RE: FW: 00024790 - CC Pro licenses. [ ref:_00DG0Cbyq._5001M1f1edO:ref ]",
    "IDs": "<6ba7e9e6234946a19b32c96fa432b565@EXMBX2-CPF.bankoh.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "New vendor form sent by Kristine",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Feb 9, 2021, 2:38 PM",
    "Subject": "RE: FW: 00024790 - CC Pro licenses. [ ref:_00DG0Cbyq._5001M1f1edO:ref ]",
    "IDs": "<6ba7e9e6234946a19b32c96fa432b565@EXMBX2-CPF.bankoh.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Compiled ach form from Dustin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Feb 9, 2021, 4:16 PM",
    "Subject": "RE: FW: 00024790 - CC Pro licenses. [ ref:_00DG0Cbyq._5001M1f1edO:ref ]",
    "IDs": "<FA41E33F-B9A1-4DDC-B276-064A6116267D@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Compiled new vendor set up form from Dustin",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Feb 9, 2021, 4:16 PM",
    "Subject": "RE: FW: 00024790 - CC Pro licenses. [ ref:_00DG0Cbyq._5001M1f1edO:ref ]",
    "IDs": "<FA41E33F-B9A1-4DDC-B276-064A6116267D@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Chromacam quote",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Feb 9, 2021, 4:16 PM",
    "Subject": "RE: FW: 00024790 - CC Pro licenses. [ ref:_00DG0Cbyq._5001M1f1edO:ref ]",
    "IDs": "<FA41E33F-B9A1-4DDC-B276-064A6116267D@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Chromacam log collection script",
    "Entity": "File",
    "Sub-type": "Zip",
    "Date and time": "Monday, 08. 02 2021 23:37",
    "Subject": "Chromacam Beta Test Issue",
    "IDs": "<CAC=hQbmUw06cn7MrjgZuPFa5-8waabk_m5-7Jh_1XwaYJieFjg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "CC logs upload",
    "Entity": "Link",
    "Sub-type": "Google Drive",
    "Date and time": "Monday, 08. 02 2021 23:37",
    "Subject": "Chromacam Beta Test Issue",
    "IDs": "<CAC=hQbmUw06cn7MrjgZuPFa5-8waabk_m5-7Jh_1XwaYJieFjg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Chromacam Production version",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Monday, 08. 02 2021 23:37",
    "Subject": "Chromacam Beta Test Issue",
    "IDs": "<CAC=hQbmUw06cn7MrjgZuPFa5-8waabk_m5-7Jh_1XwaYJieFjg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Slack signoff from Long",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Feb 4, 2021, 10:29 AM",
    "Subject": "Sign-off for release Presenter for Win 3.0.6.5",
    "IDs": "<CAL43u-VpSwn-FVXKJUyNx6Nu2h3_s=YpvA8-y64CbykzZz4sog@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Slack signoff to Simon",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Feb 4, 2021, 10:29 AM",
    "Subject": "Sign-off for release Presenter for Win 3.0.6.5",
    "IDs": "<CAL43u-VpSwn-FVXKJUyNx6Nu2h3_s=YpvA8-y64CbykzZz4sog@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Feedback on 3013 from Holly",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Fri, Feb 5, 7:31 PM",
    "Subject": "Re: Sign-off for release Presenter for Win 3.0.6.5",
    "IDs": "<CAP7yWZj4=h+Scjw9PBUbxnLsLrakA9E2GmmqkGusjZCa3uApRA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Feedback on 3013 to Simon",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Fri, Feb 5, 7:31 PM",
    "Subject": "Re: Sign-off for release Presenter for Win 3.0.6.5",
    "IDs": "<CAP7yWZj4=h+Scjw9PBUbxnLsLrakA9E2GmmqkGusjZCa3uApRA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Khoa's address",
    "Entity": "Location",
    "Sub-type": "Address",
    "Date and time": "Mon, Feb 8, 12:29 AM",
    "Subject": "Re: We heard you and we agree",
    "IDs": "<9B671BF9-36B9-45B5-94AE-712C29410376@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Transition kit email from Simon",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Thu, Feb 4, 12:51 AM",
    "Subject": "Re: Get ready to return the Developer Transition Kit.",
    "IDs": "<CALV-+1fLHJHp8LLE940+TXrhFVpvm7pVaJ4B5_0tFdAkjvhzCQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Transition kit email to Richard",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Thu, Feb 4, 12:51 AM",
    "Subject": "Re: Get ready to return the Developer Transition Kit.",
    "IDs": "<CALV-+1fLHJHp8LLE940+TXrhFVpvm7pVaJ4B5_0tFdAkjvhzCQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Termination letter with edits to Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Tue, Dec 8, 2020, 2:28 PM",
    "Subject": "Termination Letter",
    "IDs": "<DM6PR11MB3340D7498CA2059F44E549C9B1CD0@DM6PR11MB3340.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Termination letter with edits from Svetlana",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Tue, Dec 8, 2020, 2:28 PM",
    "Subject": "Termination Letter",
    "IDs": "<DM6PR11MB3340D7498CA2059F44E549C9B1CD0@DM6PR11MB3340.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Clean termination letter by Svetlana",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Tue, Dec 8, 2020, 2:28 PM",
    "Subject": "Termination Letter",
    "IDs": "<DM6PR11MB3340D7498CA2059F44E549C9B1CD0@DM6PR11MB3340.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Clean termination letter to Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Tue, Dec 8, 2020, 3:45 PM",
    "Subject": "Termination Letter",
    "IDs": "<DM6PR11MB3340D7498CA2059F44E549C9B1CD0@DM6PR11MB3340.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Surendra's number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Tue, Dec 8, 2020, 3:49 PM",
    "Subject": "Termination Letter",
    "IDs": "<B9D3ACA2-1B3C-46A4-8AD3-E6CC68025034@foxconn.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Termination letter with Personify",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Feb 4, 7:03 PM",
    "Subject": "Termination Letter",
    "IDs": "<DM6PR11MB3340279EFB7D2E67AA95818CB1B29@DM6PR11MB3340.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Clean termination letter for personify",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Feb 4, 7:03 PM",
    "Subject": "Termination Letter",
    "IDs": "<DM6PR11MB3340279EFB7D2E67AA95818CB1B29@DM6PR11MB3340.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "License with Illinois",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Feb 5, 11:27 AM",
    "Subject": "Termination Letter",
    "IDs": "<BYAPR11MB333552EE228B99D40DF25A45B1B29@BYAPR11MB3335.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "License with Personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Feb 5, 11:27 AM",
    "Subject": "Termination Letter",
    "IDs": "<BYAPR11MB333552EE228B99D40DF25A45B1B29@BYAPR11MB3335.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Illinois license amendment",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Feb 5, 11:27 AM",
    "Subject": "Termination Letter",
    "IDs": "<BYAPR11MB333552EE228B99D40DF25A45B1B29@BYAPR11MB3335.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify license amendment",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Feb 5, 11:27 AM",
    "Subject": "Termination Letter",
    "IDs": "<BYAPR11MB333552EE228B99D40DF25A45B1B29@BYAPR11MB3335.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Meeting about taxes",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Fri, Feb 5, 3:50 PM",
    "Subject": "Re: Personify (OldCo) taxes",
    "IDs": "<F79E9716-DFED-4FD8-84C6-2487E99D55AF@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Live demo with Langley",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "2/1/2021 8:54 AM",
    "Subject": "RE: [EXT EMAIL] RE: Request for Demo [ ref:_00DG0Cbyq._5001M1f0Bgp:ref ]",
    "IDs": "<BzFb3000000000000000000000000000000000000000000000QO2J9C00vQABKu6aTHOBIb0Ylu9_1g@sfdc.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Unicode camera from Long",
    "Entity": "Link",
    "Sub-type": "Github",
    "Date and time": "Feb 4, 2021, 8:34 PM",
    "Subject": "Re: Ticket 00022913",
    "IDs": "<CAL43u-V_yU9oXhF9kaxSBms+ra52Mg3xOvqagAMQWe-dquMWYA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Context results from Holly",
    "Entity": "Link",
    "Sub-type": "Facebook",
    "Date and time": "Thu, Feb 4, 8:35 AM",
    "Subject": "Re: PP and CC contest 2020",
    "IDs": "<C3052F68-B809-46A5-BDAE-02E8E9E91AE5@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Context results to Philip",
    "Entity": "Link",
    "Sub-type": "Facebook",
    "Date and time": "Thu, Feb 4, 8:35 AM",
    "Subject": "Re: PP and CC contest 2020",
    "IDs": "<C3052F68-B809-46A5-BDAE-02E8E9E91AE5@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Signoff link from Long",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Feb 4, 2021, 11:11 AM",
    "Subject": "Sign-off for release ChromaCam for Mac 1.0.3.63",
    "IDs": "<CAL43u-Ve__VtoTHKoUbQccEQpCT1L92V+_FtfgqDELArxG8W2Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "December january invoice from Sanjay",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Feb 4, 9:59 AM",
    "Subject": "Dec and Jan invoice",
    "IDs": "<E2978538-7ADA-4BA2-8A8B-48F37DCDAABC@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Dec invoice to Dustin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Feb 4, 9:59 AM",
    "Subject": "Dec and Jan invoice",
    "IDs": "<E2978538-7ADA-4BA2-8A8B-48F37DCDAABC@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Jan invoice to Dustin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Feb 4, 9:59 AM",
    "Subject": "Dec and Jan invoice",
    "IDs": "<E2978538-7ADA-4BA2-8A8B-48F37DCDAABC@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Schock address",
    "Entity": "Location",
    "Sub-type": "Address",
    "Date and time": "Feb 3, 2021, 1:41 AM",
    "Subject": "Antwort: RE: Contact Form [ ref:_00DG0Cbyq._5001M1f13JG:ref ]",
    "IDs": "<OF478B0022.C3E2D817-ONC1258671.002905A3-C1258671.002A47F7@schock-metall.de>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify sales email",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Feb 3, 2021, 1:41 AM",
    "Subject": "Antwort: RE: Contact Form [ ref:_00DG0Cbyq._5001M1f13JG:ref ]",
    "IDs": "<OF478B0022.C3E2D817-ONC1258671.002905A3-C1258671.002A47F7@schock-metall.de>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Surendra's address",
    "Entity": "Location",
    "Sub-type": "Address",
    "Date and time": "Sat, Jan 30, 10:28 AM",
    "Subject": "Re: Samsung - NDA and SEA",
    "IDs": "<D030D1D2-E025-4AD3-8AFF-A6371A122F9E@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Number surendra",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Sat, Jan 30, 10:28 AM",
    "Subject": "Re: Samsung - NDA and SEA",
    "IDs": "<D030D1D2-E025-4AD3-8AFF-A6371A122F9E@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "January salaries from Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Feb 1, 2021, 11:05 AM",
    "Subject": "Operation expense estimate 2021-02",
    "IDs": "<CAL43u-V+Frbi_2oq0yVg3MmoB5yHOKR8YprYkjvL84-EMKM-KA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Estimated February costs from Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Feb 1, 2021, 11:05 AM",
    "Subject": "Operation expense estimate 2021-02",
    "IDs": "<CAL43u-V+Frbi_2oq0yVg3MmoB5yHOKR8YprYkjvL84-EMKM-KA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Suggestions for iphone",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Jan 27, 1:46 AM",
    "Subject": "Request device",
    "IDs": "<CAKng2fHgw_9VzbFyem9iBi8Ne0K_KJyZnsxcUwhiKJw9BjmG-w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Updated suggestions for iphone",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Thu, Jan 28, 11:34 PM",
    "Subject": "Request device",
    "IDs": "<CAKng2fGDLCKr5rMXt6rSivN+F4+CnoHYW7MHsgNndQZaP8EaWA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Tet spreasheet shared by Long",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Thu, Jan 28, 11:11 PM",
    "Subject": "WFH -- Working remote tracking - Tet holiday 2021 - Invitation to edit",
    "IDs": "<000000000000842e0d05ba03083e@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Tet workplan",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Thu, Jan 28, 11:11 PM",
    "Subject": "WFH -- Working remote tracking - Tet holiday 2021 - Invitation to edit",
    "IDs": "<000000000000842e0d05ba03083e@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify registration link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Jan 21, 2021, 10:43 PM",
    "Subject": "Re: 00024373 - RE: Not for profit 501(c)3 RCF (Rotary Childrens Fund) - request for support [ ref:_00DG0Cbyq._5001M1ezTdI:ref ]",
    "IDs": "<CAP7yWZhMJyzEX5hW3e8_obH-qyLvsjxfYa1vh=HTJXwhx8AAqQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Invoice for Beyer",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Jan 27, 12:34 PM",
    "Subject": "RE: 00024491 - Chromacam licenses - purchase by invoice [ ref:_00DG0Cbyq._5001M1f013P:ref ]",
    "IDs": "<5CCFC441-9715-4B17-BFBD-118CE3BE48EE@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Updated Beyer invoice",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 27, 2021, 12:50 PM",
    "Subject": "RE: 00024491 - Chromacam licenses - purchase by invoice [ ref:_00DG0Cbyq._5001M1f013P:ref ]",
    "IDs": "<0C692252-61A7-4FFD-8F5E-6D49966F6B20@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Definitive plan from Long",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Tue, Jan 26, 10:10 PM",
    "Subject": "Re: Visual Studios Upgrade",
    "IDs": "<CAL43u-UMaq6Su=Jma_JnMU31s4MCwc13PCWMyX=umcWZGmnGxQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Definitive plan to Hai",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Tue, Jan 26, 10:10 PM",
    "Subject": "Re: Visual Studios Upgrade",
    "IDs": "<CAL43u-UMaq6Su=Jma_JnMU31s4MCwc13PCWMyX=umcWZGmnGxQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Plan proposals shared by Hai",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "Tue, 26 Jan 2021 at 09:15",
    "Subject": "Re: Visual Studios Upgrade",
    "IDs": "<CAL43u-UMaq6Su=Jma_JnMU31s4MCwc13PCWMyX=umcWZGmnGxQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Estimation by Hai",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "Thu, Jan 21, 2021 at 11:00 AM",
    "Subject": "Re: Visual Studios Upgrade",
    "IDs": "<CAL43u-UMaq6Su=Jma_JnMU31s4MCwc13PCWMyX=umcWZGmnGxQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Estimation shared with Simon",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "Thu, Jan 21, 2021 at 11:00 AM",
    "Subject": "Re: Visual Studios Upgrade",
    "IDs": "<CAL43u-UMaq6Su=Jma_JnMU31s4MCwc13PCWMyX=umcWZGmnGxQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Upgrades spreasheet from Hai",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "Mon, 18 Jan 2021 at 13:30",
    "Subject": "Re: Visual Studios Upgrade",
    "IDs": "<CAL43u-UMaq6Su=Jma_JnMU31s4MCwc13PCWMyX=umcWZGmnGxQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Spreadsheet about upgrades sent to Simon",
    "Entity": "File",
    "Sub-type": "Google Sheets",
    "Date and time": "Mon, 18 Jan 2021 at 13:30",
    "Subject": "Re: Visual Studios Upgrade",
    "IDs": "<CAL43u-UMaq6Su=Jma_JnMU31s4MCwc13PCWMyX=umcWZGmnGxQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "New Personify address",
    "Entity": "Location",
    "Sub-type": "Address",
    "Date and time": "Tue, Jan 26, 11:01 AM",
    "Subject": "Invoice/Receipt Address",
    "IDs": "<19EBFC45-0861-4E79-B25E-6C152550821A@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Tugboat guide",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 26, 2021, 7:14 PM",
    "Subject": "Personify - Onboarding with Tugboat Logic",
    "IDs": "<CABpd3rAPzHw70QUw-vC01EBi01X_yxqQXGwWccKJiWgh+RcPMw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Customer email from Loron",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Tue, Jan 26, 3:51 PM",
    "Subject": "Presales ticket 00024522",
    "IDs": "<018901d6f42d$57d57180$07805480$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Stockholder draft written by Christine",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Jan 19, 2021, 1:39 PM",
    "Subject": "Re: FW: 2021 - Personify, Inc. - DE annual report",
    "IDs": "<CAHz_o-4A5CYLhMYKmcKzx=f5O2GWHMqY7f2OOj8vjOEQo_20yw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Board draft written by Christine",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Jan 19, 2021, 1:39 PM",
    "Subject": "Re: FW: 2021 - Personify, Inc. - DE annual report",
    "IDs": "<CAHz_o-4A5CYLhMYKmcKzx=f5O2GWHMqY7f2OOj8vjOEQo_20yw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Definitive stockholders sent by Dustin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 25, 2021, 1:32 PM",
    "Subject": "RE: FW: 2021 - Personify, Inc. - DE annual report",
    "IDs": "<6CECC6A9-7E67-4FB7-9AEE-8C3CBAF9BC5F@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Definitive stockholders shared with Christine",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 25, 2021, 1:32 PM",
    "Subject": "RE: FW: 2021 - Personify, Inc. - DE annual report",
    "IDs": "<6CECC6A9-7E67-4FB7-9AEE-8C3CBAF9BC5F@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Definitive board meetingconsent from Dustin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 25, 2021, 1:32 PM",
    "Subject": "RE: FW: 2021 - Personify, Inc. - DE annual report",
    "IDs": "<6CECC6A9-7E67-4FB7-9AEE-8C3CBAF9BC5F@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Definitive board consent to Christine",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 25, 2021, 1:32 PM",
    "Subject": "RE: FW: 2021 - Personify, Inc. - DE annual report",
    "IDs": "<6CECC6A9-7E67-4FB7-9AEE-8C3CBAF9BC5F@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "PayPal statement for OldCo",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Jan 25, 11:39 AM",
    "Subject": "Paypal account",
    "IDs": "<E1E37D49-21EC-4460-9591-71034C2F7FA5@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Headen kpi review to dustin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jan 21, 4:40 PM",
    "Subject": "2020 Q4 KPI - Haeden Bridge, Korea",
    "IDs": "<006a01d6f046$73f21430$5bd63c90$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Headen Bridge revised invoice from Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jan 21, 4:40 PM",
    "Subject": "2020 Q4 KPI - Haeden Bridge, Korea",
    "IDs": "<006a01d6f046$73f21430$5bd63c90$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Chromacam price request from Softwareone",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 22, 2021, 3:12 AM",
    "Subject": "Purchase Price Request (SWO) DEC-PPQ-122184 Klingel medical metal GmbH",
    "IDs": "<7bfc3723-bc17-41ba-ab57-3a45644ae2f9@CHPVS00556.domain.global>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Quote from Personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 22, 2021, 4:14 PM",
    "Subject": "RE: Purchase Price Request (SWO) DEC-PPQ-122184 Klingel medical metal GmbH",
    "IDs": "<A52F967F-6565-49DF-BFAA-11D671C81B4F@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "New year meeting",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Fri, Jan 22, 11:49 AM",
    "Subject": "Invitation: Happy New Year to VN team video @ Fri Jan 22, 2021 1pm - 1:30pm (PST) (Surendra Arora)",
    "IDs": "<00000000000050d8aa05b980cf52@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Wise up kpi review to surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jan 21, 9:49 PM",
    "Subject": "2020 Q4 KPI - Wise Up, Japan",
    "IDs": "<010501d6f071$a831b950$f8952bf0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Tugboat contract from Khoa",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jan 21, 2021, 11:39 AM",
    "Subject": "soc2",
    "IDs": "<CADTtM3-D6QmMZk-Lr+p+v1O4CVzwsLL7=aKQ_+JTQAzdJtHqsw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Samsung link from Philip",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Tue, Jan 19, 5:18 AM",
    "Subject": "Samsung's Knox",
    "IDs": "<017301d6ee54$d0c0d410$72427c30$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Japan log from Philip",
    "Entity": "File",
    "Sub-type": "Zip",
    "Date and time": "Dec 2, 2020, 12:50 AM",
    "Subject": "PP Recording issue",
    "IDs": "<06fa01d6c877$692368c0$3b6a3a40$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Top priority list from Long",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Jan 15, 2021, 1:44 AM",
    "Subject": "Re: PP Recording issue",
    "IDs": "<CAL43u-XCQ2Y=Ojan6JjC9ArK-Otoqi4DQtWXSes=JLbPrUq88Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Top priority list shared with Simon",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Jan 15, 2021, 1:44 AM",
    "Subject": "Re: PP Recording issue",
    "IDs": "<CAL43u-XCQ2Y=Ojan6JjC9ArK-Otoqi4DQtWXSes=JLbPrUq88Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Link for quality from Phuc Le",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Jan 20, 2021, 3:26 AM",
    "Subject": "Re: PP Recording issue",
    "IDs": "<6F65FC47-1B97-49D3-A1B0-9912F82DDE4E@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Revenue summary to Surendra",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Tue, Jan 19, 8:35 PM",
    "Subject": "Finance data for KPI with the partners",
    "IDs": "<02a101d6eed4$f5ee9760$e1cbc620$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Transaction report shared with Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Tue, Jan 19, 8:35 PM",
    "Subject": "Finance data for KPI with the partners",
    "IDs": "<02a101d6eed4$f5ee9760$e1cbc620$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify receipt",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, Jan 19, 3:35 PM",
    "Subject": "Fwd: Not authorized credit card transaction [ ref:_00DG0Cbyq._5001M1ezCEm:ref ]",
    "IDs": "<CABnbrUbXMfv38Z4eJby=quMvSXar5YDwuHiKQ++oPVASToNqsg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Hiseva meeting info",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Jan 19, 2021, 2:39 PM",
    "Subject": "Invitation: Seva < > Personify intro @ Tue Jan 19, 2021 1pm - 1:30pm (PST) (Surendra Arora)",
    "IDs": "<000000000000b58dfd05b946d5ad@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Voicemail sent by Loron",
    "Entity": "File",
    "Sub-type": "Mp3",
    "Date and time": "Friday, January 15, 2021 11:27 AM",
    "Subject": "Voicemail from (973) 302-5993",
    "IDs": "<024801d6eb78$f11caec0$d3560c40$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Jira Huyen",
    "Entity": "Link",
    "Sub-type": "Jira",
    "Date and time": "Jan 14, 2021, 10:02 PM",
    "Subject": "[JIRA] Huyen Nguyen mentioned you on WEB-2609",
    "IDs": "<01EW23B4C41EABZC82RA58Z28Q@personify.atlassian.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Allen's phone",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "1/7/2021 7:27 AM",
    "Subject": "RE: Contact Form [ ref:_00DG0Cbyq._5001M1e1CxQ:ref ]",
    "IDs": "<vEsUh000000000000000000000000000000000000000000000QML5EZ00z6Yn_5R2R7ylIYc6S23CuA@sfdc.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Users spreadsheet from Personify",
    "Entity": "File",
    "Sub-type": "Csv",
    "Date and time": "Jan 8, 2021, 11:58 AM",
    "Subject": "Re: 00024104 - ChromaCam Pricing [ ref:_00DG0Cbyq._5001M1e1CxQ:ref ]",
    "IDs": "<CAN6k-eV3OmSa_oCa9=+pD+7b+oXGJ93PVXSOkPAiha9b3X9JZQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Ie link from Hai",
    "Entity": "Link",
    "Sub-type": "Support",
    "Date and time": "Jan 12, 2021, 10:47 PM",
    "Subject": "Reports of customers getting \"Unsecured browser error",
    "IDs": "<CAGMeF1T+CH_20AfjEFrdLWpnze+kyX2Q1cEwc1o4S_L1NvFkwg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Updated meeting about browser error",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Tue, Jan 12, 6:47 PM",
    "Subject": "Updated invitation: Reports of customers getting \"Unsecured browser error\" @ Tue Jan 12, 2021 8pm - 8:30pm (PST) (Surendra Arora)",
    "IDs": "<000000000000a5edc405b8bd7b3d@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Meeting about browser error",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Tue, Jan 12, 6:45 PM",
    "Subject": "Invitation: Reports of customers getting \"Unsecured browser error\" @ Tue Jan 12, 2021 8am - 8:30am (PST) (Surendra Arora)",
    "IDs": "<00000000000095b47605b8bd7412@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Updated rd meeting",
    "Entity": "Event",
    "Sub-type": "Meeting",
    "Date and time": "Tue, Jan 12, 3:47 PM",
    "Subject": "Invitation: Update with VN R&D team @ Tue Jan 12, 2021 3pm - 3:45pm (PST) (Surendra Arora)",
    "IDs": "<0000000000001c385405b8baf781@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Msi installer",
    "Entity": "Link",
    "Sub-type": "Google Drive",
    "Date and time": "Jan 11, 2021, 6:24 PM",
    "Subject": "Re: ChromaCam Login Setup",
    "IDs": "<CAC=hQbkoXNc3_qpeKTeDRd4hQTPPhhZh1NyxjAPvmH9NTvgfNA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "QA testing from Jeremiah",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Mon, Jan 11, 10:37 PM",
    "Subject": "QA testing of VMWare VDI",
    "IDs": "<CAC=hQbk5NMDyS7hPCQMot1BNY3bkJJt-ZMFgtpYtxfTRT3pd1w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify invoice",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jun 10, 2020, 2:10 PM",
    "Subject": "FW: AW: ChromaCam Lifetime Purchase Receipt - DMI GmbH & Co.KG (00019282) [ ref:_00DG0Cbyq._5001M1YqJGD:ref ]",
    "IDs": "<8D829CB5-A270-4FAF-8CD3-642BA053D0EB@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Second personify invoice",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jun 16, 2020, 3:39 PM",
    "Subject": "RE: AW: ChromaCam Lifetime Purchase Receipt - DMI GmbH & Co.KG (00019282) [ ref:_00DG0Cbyq._5001M1YqJGD:ref ]",
    "IDs": "<BD1460B5-6FCC-4F94-86EA-3DE173C49174@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Order from Japan sent by Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Jan 6, 6:12 AM",
    "Subject": "PO(Japan), License request",
    "IDs": "<004e01d6e425$26d87090$748951b0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Insight PO",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Jan 6, 10:49 AM",
    "Subject": "RE: Purchase Order 43360771 // Insight Direct (UK) Limited",
    "IDs": "<LNXP265MB13720ADDDE4DDBBE85AA0C2D86D00@LNXP265MB1372.GBRP265.PROD.OUTLOOK.COM>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Sendgrid pricing",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Thu, Jan 7, 12:12 AM",
    "Subject": "Approval Sendgrid replacement for Sendy",
    "IDs": "<CALV-+1f3dK3hy8zBwEBs-fMYhjSUPbN7wJ8s12BWpfjY-xUpKg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Lead roles shared by Long",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Jan 6, 4:28 PM",
    "Subject": "Personify Application Technical Lead roles (HaiLam) - Invitation to comment",
    "IDs": "<00000000000062c22405b842d6bf@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Application table shared with Surendra",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Jan 6, 4:28 PM",
    "Subject": "Personify Application Technical Lead roles (HaiLam) - Invitation to comment",
    "IDs": "<00000000000062c22405b842d6bf@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "W9 from trustmark",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 2, 2020, 10:51 AM",
    "Subject": "RE: 00022227 RE: Order [ ref:_00DG0Cbyq._5001M1cID4z:ref ]",
    "IDs": "<DM6PR13MB39085E0432F3A459FEE6F150A0F30@DM6PR13MB3908.namprd13.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "ACH by Trustmark",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 2, 2020, 10:51 AM",
    "Subject": "RE: 00022227 RE: Order [ ref:_00DG0Cbyq._5001M1cID4z:ref ]",
    "IDs": "<DM6PR13MB39085E0432F3A459FEE6F150A0F30@DM6PR13MB3908.namprd13.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Completed ach from personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 2, 2020, 12:32 PM",
    "Subject": "RE: 00022227 RE: Order [ ref:_00DG0Cbyq._5001M1cID4z:ref ]",
    "IDs": "<58993FA9-57D6-4AF1-B45F-228FDCD10732@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Voided personify check",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 2, 2020, 12:32 PM",
    "Subject": "RE: 00022227 RE: Order [ ref:_00DG0Cbyq._5001M1cID4z:ref ]",
    "IDs": "<58993FA9-57D6-4AF1-B45F-228FDCD10732@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Signed w9 from personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 2, 2020, 12:32 PM",
    "Subject": "RE: 00022227 RE: Order [ ref:_00DG0Cbyq._5001M1cID4z:ref ]",
    "IDs": "<58993FA9-57D6-4AF1-B45F-228FDCD10732@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "New cc versions",
    "Entity": "Link",
    "Sub-type": "Conxme Drive",
    "Date and time": "Jan 5, 2021, 9:10 AM",
    "Subject": "Re: ChormaCam issues",
    "IDs": "<CAC=hQbkPBxo-AAnnj2d1VCNHuXOE9qQ0pMYCvk7LD84txm9=vg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Financial report from Dustin",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Jan 5, 2021, 12:48 PM",
    "Subject": "Financial Reporting Package-Personify 2020 12",
    "IDs": "<MWHPR0801MB37222659464CA84ABD778F3987D10@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Report sent to Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Jan 5, 2021, 12:48 PM",
    "Subject": "Financial Reporting Package-Personify 2020 12",
    "IDs": "<MWHPR0801MB37222659464CA84ABD778F3987D10@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Presenter beta",
    "Entity": "Link",
    "Sub-type": "Conxme Drive",
    "Date and time": "Dec 15, 2020, 5:28 PM",
    "Subject": "Re: Finastra issues list",
    "IDs": "<CAC=hQbkAyvzi9im-wWQLNbWbANozuDxAocg+bDWpt27X+NCpbg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Whale beta from Philip",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Thu, Dec 31, 2020, 5:50 PM",
    "Subject": "Naver Corporation(Korea)",
    "IDs": "<002c01d6dfcf$abcf6b50$036e41f0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Plan from Philip",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Mon, Jan 4, 6:07 AM",
    "Subject": "Forecast & plan 2021",
    "IDs": "<011501d6e292$38f98eb0$aaecac10$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Plan shared with Surendra",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Mon, Jan 4, 6:07 AM",
    "Subject": "Forecast & plan 2021",
    "IDs": "<011501d6e292$38f98eb0$aaecac10$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Patent checklist from Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Dec 24, 2020, 1:15 PM",
    "Subject": "Please review Personify IP checklist for Ian",
    "IDs": "<F3B199B4-FAE5-47C1-974B-FAD909606253@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Patent checklist edited by Sanjay",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Dec 31, 2020, 1:06 PM",
    "Subject": "Re: Please review Personify IP checklist for Ian",
    "IDs": "<D05F5C5A-5488-40A5-9762-4E2C8F06B953@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Psyseg release from Khoa",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Dec 31, 2020, 3:02 AM",
    "Subject": "Re: Release of PsySeg, Personify SDK",
    "IDs": "<28808EF6-CF4D-4525-9280-513FC36B7B30@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "vcube offer to Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Wed, Dec 30, 2020, 12:03 AM",
    "Subject": "V-cuve(Japan) Offer",
    "IDs": "<006e01d6de71$84319140$8c94b3c0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Offer for Madly to Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Dec 21, 2020, 4:45 PM",
    "Subject": "Madly Offer",
    "IDs": "<002301d6d7ea$ef170270$cd450750$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Revised madly offer to Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Dec 29, 2020, 11:28 PM",
    "Subject": "회신: Madly Offer",
    "IDs": "<004301d6de6c$a91331d0$fb399570$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Vdi link from Jeremiah",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Dec 29, 2020, 10:41 AM",
    "Subject": "Migros Bank Meeting",
    "IDs": "<CAC=hQbnK8BM=mKdDYs5vXzcoMhN1u+MNnRrKtaLbGxFpzV1PRQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Vietnam bonus",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Tue, Dec 29, 2020, 11:07 AM",
    "Subject": "Operation expense estimate 2021-01",
    "IDs": "<CAL43u-UMscAr=wtRhKpD7AeZOMf4D7S0p=0+QG7e-buA6oA--Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "January estimates from Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Tue, Dec 29, 2020, 11:07 AM",
    "Subject": "Operation expense estimate 2021-01",
    "IDs": "<CAL43u-UMscAr=wtRhKpD7AeZOMf4D7S0p=0+QG7e-buA6oA--Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "December payslip sent by Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Tue, Dec 29, 2020, 11:07 AM",
    "Subject": "Operation expense estimate 2021-01",
    "IDs": "<CAL43u-UMscAr=wtRhKpD7AeZOMf4D7S0p=0+QG7e-buA6oA--Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "December paycheck to Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Tue, Dec 29, 2020, 11:07 AM",
    "Subject": "Operation expense estimate 2021-01",
    "IDs": "<CAL43u-UMscAr=wtRhKpD7AeZOMf4D7S0p=0+QG7e-buA6oA--Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Legal invoice",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 29, 2020, 1:49 PM",
    "Subject": "FW: 2020 Legal Fees",
    "IDs": "<722B15CC-447E-45B9-BA9C-B34C15002358@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Newswatch pricing",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 28, 2020, 3:30 AM",
    "Subject": "Re: Follow Up: Personify TV Feature - When to Connect",
    "IDs": "<7C8D434D-CA5C-4617-BC18-8F558C0269AC@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Article about Newswatch",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 28, 2020, 3:30 AM",
    "Subject": "Re: Follow Up: Personify TV Feature - When to Connect",
    "IDs": "<7C8D434D-CA5C-4617-BC18-8F558C0269AC@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Offer letter from Personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Dec 18, 2020, 3:40 PM",
    "Subject": "Personify Internship Offer - Abhinav Pola",
    "IDs": "<MWHPR19MB09268CCC695A4C950665B146C8C30@MWHPR19MB0926.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify employement application",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Fri, Dec 18, 2020, 3:40 PM",
    "Subject": "Personify Internship Offer - Abhinav Pola",
    "IDs": "<MWHPR19MB09268CCC695A4C950665B146C8C30@MWHPR19MB0926.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Pola cv",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 10, 2020, 10:35 AM",
    "Subject": "Software Engineer Internship",
    "IDs": "<CABcqsJSGxWiwiMw82JZWCD8Eyhpy9xL7=XTC3unuc-TigT07gg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "SOC2 wiki",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Thu, Dec 17, 2020, 11:55 PM",
    "Subject": "Slides of today meeting.",
    "IDs": "<CAL43u-XD3zzwcZiUELhHxvv_wgV+hRQwdJR5pXjH7bRTzas+ig@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "2021 ppt",
    "Entity": "FIle",
    "Sub-type": "PPT",
    "Date and time": "Dec 17, 2020, 11:55 PM",
    "Subject": "Slides of today meeting.",
    "IDs": "<CAL43u-XD3zzwcZiUELhHxvv_wgV+hRQwdJR5pXjH7bRTzas+ig@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "SOC2 research by Khoa from Long",
    "Entity": "FIle",
    "Sub-type": "PPT",
    "Date and time": "Dec 17, 2020, 11:55 PM",
    "Subject": "Slides of today meeting.",
    "IDs": "<CAL43u-XD3zzwcZiUELhHxvv_wgV+hRQwdJR5pXjH7bRTzas+ig@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Roadmap for 2021",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Dec 18, 2020, 12:19 AM",
    "Subject": "Re: Slides of today meeting.",
    "IDs": "<CAL43u-UMZ_vcF1HRC17ymjpBC-to9aJCVs_-iTX34RZgS4kVyg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Evaluation copy from Personify",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Dec 17, 2020, 2:43 PM",
    "Subject": "Re: Partner for us",
    "IDs": "<25E1A766-BC03-4E6F-9D28-8BD521100561@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Evaluation copy to Farokh",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Dec 17, 2020, 2:43 PM",
    "Subject": "Re: Partner for us",
    "IDs": "<25E1A766-BC03-4E6F-9D28-8BD521100561@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "External sdk folder",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Wed, Dec 16, 2020, 2:34 PM",
    "Subject": "SDK External - Invitation to collaborate",
    "IDs": "<000000000000f5528105b69acc99@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Resignation letter draft from Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Tue, Dec 8, 2020, 12:34 PM",
    "Subject": "Resignation letter",
    "IDs": "<C8DCFDEF-B092-4A77-A8F7-3F20E2B328C7@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Resignation letter shared by Sanjay",
    "Entity": "Link",
    "Sub-type": "UOFI Adobe",
    "Date and time": "Dec 16, 2020, 11:32 AM",
    "Subject": "Re: Resignation letter",
    "IDs": "<B96E875C-1A91-4B58-928B-ACCC0D03CBFA@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Madly CEO from Philip",
    "Entity": "Link",
    "Sub-type": "LinkedIn",
    "Date and time": "Dec 16, 2020, 1:19 AM",
    "Subject": "Madly, US Company",
    "IDs": "<00b701d6d37b$d60183f0$82048bd0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Madly director from Philip",
    "Entity": "Link",
    "Sub-type": "LinkedIn",
    "Date and time": "Dec 16, 2020, 1:19 AM",
    "Subject": "Madly, US Company",
    "IDs": "<00b701d6d37b$d60183f0$82048bd0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Google prototype from Surendra",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Dec 16, 2020, 3:47 PM",
    "Subject": "Re: Madly, US Company",
    "IDs": "<122E85A8-B336-4B4B-A470-6EB5022593AF@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Simon's number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Mon, Dec 14, 2020, 4:23 PM",
    "Subject": "Re: 00023659 - RE: Fwd: Contact Form [ ref:_00DG0Cbyq._5001M1dyDmf:ref ]",
    "IDs": "<CALV-+1fk0KzErG4uG0hj5s6vG1CeU37ReQivF-qa999dztnuGQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Salesforce link from Loron",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Dec 14, 2020, 1:17 PM",
    "Subject": "Presales ChromaCam 10 to 20 users",
    "IDs": "<012101d6d24d$d2b35090$7819f1b0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify offer letter",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Dec 11, 2020, 6:57 PM",
    "Subject": "Personify Internship Offer - Aashna Mehta",
    "IDs": "<MWHPR19MB0926974EB7D7F004125C9626C8C90@MWHPR19MB0926.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Signed offer letter by Ashna",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Dec 14, 2020, 11:23 AM",
    "Subject": "Re: Personify Internship Offer - Aashna Mehta",
    "IDs": "<CAHK2KLvykCbjEMZHw3s-=JkTc+DCA8e-mTu=2BUWVfgOvG4gLg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Offer letter by Personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Dec 11, 2020, 6:57 PM",
    "Subject": "Personify Internship Offer - Rohan Patel",
    "IDs": "<MWHPR19MB092621B04C87015228A92DA6C8C90@MWHPR19MB0926.namprd19.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Rohan offer letter",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Sun, Dec 13, 2020, 8:58 PM",
    "Subject": "Re: Personify Internship Offer - Rohan Patel",
    "IDs": "<F6DAC037-F1F4-4BAF-A6D2-0F33149F1B3A@gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Cvs from Khoa",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, Dec 8, 2020, 10:32 AM",
    "Subject": "Re: UIUC students",
    "IDs": "<D4350950-3D64-4777-A9C5-3EE92DD8A935@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Voicemail from Loron",
    "Entity": "File",
    "Sub-type": "Mp3",
    "Date and time": "Fri, Dec 11, 2020, 4:53 PM",
    "Subject": "FW: Voicemail from (866) 521-6995",
    "IDs": "<004401d6d010$7db38720$791a9560$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Voicemail from Surendra",
    "Entity": "File",
    "Sub-type": "Mp3",
    "Date and time": "Dec 11, 2020, 4:59 PM",
    "Subject": "Fwd: Voicemail from (866) 521-6995",
    "IDs": "<854E8FD5-420D-466D-B83D-8A54669864CA@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Epoccam link shared by Philip",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Fri, Dec 11, 2020, 4:58 AM",
    "Subject": "Epoccam",
    "IDs": "<009801d6cfac$a2e2deb0$e8a89c10$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Chromacam beta download",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Dec 4, 2020, 5:54 PM",
    "Subject": "Re: New version of ChromaCam",
    "IDs": "<CAC=hQbn+sOVdDf6YxvP+65U3OE8m+qk96QUsfwi1+CRAo1V+ig@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Log from MeyerBrown",
    "Entity": "File",
    "Sub-type": "Log",
    "Date and time": "Dec 7, 2020, 11:10 AM",
    "Subject": "RE: New version of ChromaCam",
    "IDs": "<02f6a86c836b4147b838d5074e8001c2@mayerbrown.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "MSI manual from Jeremiah",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Dec 7, 2020, 11:33 AM",
    "Subject": "Re: New version of ChromaCam",
    "IDs": "<CAC=hQbmAiOO_7JZR+yMW-TWUuBeBV-LsaOPO9Wcgq=12RtaU_g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Enterprise installer sent by Jeremiah",
    "Entity": "Link",
    "Sub-type": "Google Drive (conxme)",
    "Date and time": "Dec 8, 2020, 6:24 PM",
    "Subject": "Re: New version of ChromaCam",
    "IDs": "<CAC=hQbnbye9LpfhguvKL=n+f=W8KCDmn-WZ18O=NgrVEMsgNoQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Slack link for Mac",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Dec 3, 2020, 9:28 PM",
    "Subject": "Sign-off for release Presenter for Mac 3.0.9.2 (full Account upgrade and status feature)",
    "IDs": "<CAL43u-VDK92pkC4-=awYUjobEbzyUyoWJ19Vi5HwXAroBJ5Exw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "CC signoff on slack",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Sat, Nov 28, 2020, 7:44 AM",
    "Subject": "RSign-off for release ChromaCam for Mac 1.0.2.61 (missing Slides feature, Apt-in, bug report, limit login 3 times, timestamp & drop fps...)",
    "IDs": "<CAL43u-VKbWh-qOVakvHbFiwg-7Wm+ODfTjqGH-cZN=-qjf4qww@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Recap by Holly",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Dec 9, 2020, 1:50 PM",
    "Subject": "Re: PP for Pexip",
    "IDs": "<A6CDD545-8CB5-4386-BD1C-06618A7E0010@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Datasheet to Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Dec 9, 2020, 1:50 PM",
    "Subject": "Re: PP for Pexip",
    "IDs": "<A6CDD545-8CB5-4386-BD1C-06618A7E0010@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Resignation draft for Sanjay",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Dec 7, 2020, 3:06 PM",
    "Subject": "Re: Remove Sanjay from Personify",
    "IDs": "<CAHz_o-4=x0FG9HUo1Dr3-PUxeGgA=Tds+3AFW75EHknTi2Sw9Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Officers certificate written by Christine",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Dec 8, 2020, 11:19 AM",
    "Subject": "Re: Remove Sanjay from Personify",
    "IDs": "<CAHz_o-4xPQGttWyR-C_nbaZTVtoTswHvYQE8OmyGgbCFjFoMHg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Resume from Patel",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 10, 2020, 10:45 AM",
    "Subject": "Interested in Software Engineering Internship at Personify",
    "IDs": "<F1FBC3A1-D3C9-4FF4-81BF-6CE7B00C827D@illinois.edu>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Link from Khoa",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Dec 7, 2020 at 12:30 PM Khoa Tran",
    "Subject": "Follow up on Internship position",
    "IDs": "<D40BA543-DE3D-4B64-B16A-C0A2B1EDF9FD@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Stock retention calculation",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Sun, 9 Jun 2019 at 12:06",
    "Subject": "Bonus/retention suggestion (via known stock model) for everyone in VNOffice",
    "IDs": "<CAL43u-XieTiiia63mTffpPdG5pAjyCuML76WefFHO7dPBay3SA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Long's stock",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Sun, 9 Jun 2019 at 12:06",
    "Subject": "Bonus/retention suggestion (via known stock model) for everyone in VNOffice",
    "IDs": "<CAL43u-XieTiiia63mTffpPdG5pAjyCuML76WefFHO7dPBay3SA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Total stock vn",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Sun, 9 Jun 2019 at 12:06",
    "Subject": "Bonus/retention suggestion (via known stock model) for everyone in VNOffice",
    "IDs": "<CAL43u-XieTiiia63mTffpPdG5pAjyCuML76WefFHO7dPBay3SA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Stock rate sent by Long",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Sun, 9 Jun 2019 at 12:06",
    "Subject": "Bonus/retention suggestion (via known stock model) for everyone in VNOffice",
    "IDs": "<CAL43u-XieTiiia63mTffpPdG5pAjyCuML76WefFHO7dPBay3SA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Total vn budget",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Sun, 9 Jun 2019 at 12:06",
    "Subject": "Bonus/retention suggestion (via known stock model) for everyone in VNOffice",
    "IDs": "<CAL43u-XieTiiia63mTffpPdG5pAjyCuML76WefFHO7dPBay3SA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "VN bonus",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Mon, Dec 7, 2020, 5:28 PM",
    "Subject": "Bonus for VN team v1.2.xlsx",
    "IDs": "<0000000000003cba4905b5e82f12@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Aryaman's cv",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 10, 2020, 1:35 P",
    "Subject": "Software Engineer Intern position",
    "IDs": "<CAO8CUwatKc6GNOGXTh-H30QmdHNOZmZ8zc3m6jMsKLQ337chyg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "License agreement with Pexip",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Wednesday, December 2, 2020 9:54 PM",
    "Subject": "Personify - License Agreement - Pexip_V5.0(1 Dec 2020) (002)",
    "IDs": "<004701d6c8a3$51c4e150$f54ea3f0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Signed agreement from Personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 2, 2020, 6:52 PM",
    "Subject": "회신: Personify - License Agreement - Pexip_V5.0(1 Dec 2020) (002)",
    "IDs": "<009a01d6c90e$9111b430$b3351c90$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Signed contract by Tom Erik",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Dec 7, 2020, 3:15 AM",
    "Subject": "RE: Personify - License Agreement - Pexip_V5.0(1 Dec 2020) (002)",
    "IDs": "<AS8PR01MB7560884048CADD2D532AC2A2C6CE0@AS8PR01MB7560.eurprd01.prod.exchangelabs.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Marketing draft from Ian",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Fri, Dec 4, 2020, 3:24 PM",
    "Subject": "Draft Marketing Agreement",
    "IDs": "<F4F2AF5D-CFE2-4A2B-B377-59102FC59D73@quinnpacific.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Due dilingence by Ian",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Fri, Dec 4, 2020, 3:24 PM",
    "Subject": "Draft Marketing Agreement",
    "IDs": "<F4F2AF5D-CFE2-4A2B-B377-59102FC59D73@quinnpacific.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "All chromacam versions by Long",
    "Entity": "Link",
    "Sub-type": "Google Drive",
    "Date and time": "Dec 2, 2020, 9:17 AM",
    "Subject": "Re: PC Specs for Migros Bank",
    "IDs": "<CAL43u-X_L3gC9in57y4GRBdP4=CBoHzjuj46kjDZ5GVKXrKgwA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "No login watermark msi",
    "Entity": "Link",
    "Sub-type": "Google Drive",
    "Date and time": "Dec 2, 2020, 9:17 AM",
    "Subject": "Re: PC Specs for Migros Bank",
    "IDs": "<CAL43u-X_L3gC9in57y4GRBdP4=CBoHzjuj46kjDZ5GVKXrKgwA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "November salaries shared by Long",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Dec 2, 2020, 10:07 AM",
    "Subject": "Operation expense estimate 2020-12",
    "IDs": "<CAL43u-V4wagQu9PB4PWxXvCXUX10N1XrBJ7agsUsrQwgipiJcA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Vietnam costs for december",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Dec 2, 2020, 10:07 AM",
    "Subject": "Operation expense estimate 2020-12",
    "IDs": "<CAL43u-V4wagQu9PB4PWxXvCXUX10N1XrBJ7agsUsrQwgipiJcA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Screenshots from Long",
    "Entity": "File",
    "Sub-type": "Image",
    "Date and time": "Dec 3, 2020, 9:52 PM",
    "Subject": "Re: Operation expense estimate 2020-12",
    "IDs": "<CAL43u-VvOdPvyuK1M7pzuGMcn2E4upL96+T9LswGKezEBccesw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Roadmap shared by Khoa",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Wed, Dec 2, 2020, 5:23 PM",
    "Subject": "SDK / R&D Roadmap - Invitation to edit",
    "IDs": "<0000000000003ddc0005b583888f@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Slack receipt from Simon",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Dec 2, 2020, 12:28 PM",
    "Subject": "[Slack Receipt] Re: Credit Card not going through on Slack",
    "IDs": "<CALV-+1fP88ZNLQ3rez-Tw-FfiNq5H+bs2ME8we2aKWOOjLSH8g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "DNS slides shared by Suresh",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Tue, Dec 1, 2020, 5:01 PM",
    "Subject": "RE: Responses to Technical Questions",
    "IDs": "<DM6PR11MB26357FD69DD1D0520BCA0ECD9FF40@DM6PR11MB2635.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Nov financial report by Dustin",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Dec 1, 2020, 2:14 PM",
    "Subject": "Financial Reporting Package-Personify 2020 11.xlsx",
    "IDs": "<MWHPR0801MB3722EC05EE9F1A2E01597A0087F40@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "November report to Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Dec 1, 2020, 2:14 PM",
    "Subject": "Financial Reporting Package-Personify 2020 11.xlsx",
    "IDs": "<MWHPR0801MB3722EC05EE9F1A2E01597A0087F40@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Jabber demo from Khoa",
    "Entity": "File",
    "Sub-type": "Mp4",
    "Date and time": "Oct 19, 2020, 1:35 PM",
    "Subject": "Re: BOA Jabber issue",
    "IDs": "<D173EF1D-8CE1-49C5-AC54-A2B61B4A2387@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Evaluation link from Simon",
    "Entity": "Link",
    "Sub-type": "Google Drive (conxme)",
    "Date and time": "Nov 18, 2020, 12:51 PM",
    "Subject": "Re: BOA Jabber issue",
    "IDs": "<CALV-+1e6PPL_M8cQX31kGgJSy6yP4PuL91F+6h+ScudYsRFfsA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Evaluation link to David",
    "Entity": "Link",
    "Sub-type": "Google Drive (conxme)",
    "Date and time": "Nov 18, 2020, 12:51 PM",
    "Subject": "Re: BOA Jabber issue",
    "IDs": "<CALV-+1e6PPL_M8cQX31kGgJSy6yP4PuL91F+6h+ScudYsRFfsA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify eula",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Nov 30, 2020, 3:41 PM",
    "Subject": "00023296 RE: Contact Form [ ref:_00DG0Cbyq._5001M1d3nD5:ref ]",
    "IDs": "<aslH5000000000000000000000000000000000000000000000QKMPLK00Ibtrp9xrRf2FaoCKkf4FGg@sfdc.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "2621 signoff on slack",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Mon, Nov 23, 2020, 10:40 AM",
    "Subject": "Re: Windows 2.6.2.0 Release Notes",
    "IDs": "<CAL43u-ViLVgS2C+NqBtMCD53W+57q52Ri07TakbE3jkBkYCK+A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Resume sent by Ragini",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 29, 2020, 8:27 PM",
    "Subject": "Personify Software Engineering Internship- Resume, Coverletter",
    "IDs": "<CH2PR11MB429410E1A42B8A970A8EF5AAF4F50@CH2PR11MB4294.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Cover letter written by Ragini",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 29, 2020, 8:27 PM",
    "Subject": "Personify Software Engineering Internship- Resume, Coverletter",
    "IDs": "<CH2PR11MB429410E1A42B8A970A8EF5AAF4F50@CH2PR11MB4294.namprd11.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Vendor information form sent by Dustin",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Nov 18, 2020, 12:58 PM",
    "Subject": "RE: New legal contact for Personify",
    "IDs": "<091AE6AF-D937-4589-B954-68F0761ED170@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "W9 shared by Christine",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 19, 2020, 9:57 AM",
    "Subject": "Re: New legal contact for Personify",
    "IDs": "<CAHz_o-4ryZad1SYnAedL_htefV6CF8LPv6t0-jks=KN3W_E5QQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "VIF compiled by Christine",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Nov 19, 2020, 9:57 AM",
    "Subject": "Re: New legal contact for Personify",
    "IDs": "<CAHz_o-4ryZad1SYnAedL_htefV6CF8LPv6t0-jks=KN3W_E5QQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Farmer engagement letter",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 19, 2020, 9:57 AM",
    "Subject": "Re: New legal contact for Personify",
    "IDs": "<CAHz_o-4ryZad1SYnAedL_htefV6CF8LPv6t0-jks=KN3W_E5QQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Conxme resume from surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 17, 2020, 5:06 PM",
    "Subject": "ConxM candidate",
    "IDs": "<ABBEC111-89A9-4B2D-AAF1-A4128032E7CD@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Clion link from Viet",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, Nov 18, 2020, 2:45 AM",
    "Subject": "[R&D] Development IDE",
    "IDs": "<CAMovQvdPSbaRH0=7bbgtU9qoxVAOKDUuZ2M-=fRHuquy5iRGuQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "BVS NDA from Philip",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Nov 12, 2020, 12:54 AM",
    "Subject": "전달: Reviewed NDA",
    "IDs": "<00ad01d6b8c0$b6e85780$24b90680$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "bvs nda signed",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 13, 2020, 4:38 PM",
    "Subject": "Re: Reviewed NDA",
    "IDs": "<36F29111-68B9-4946-8C44-E1FC26751369@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "New machine by Viet",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, Nov 11, 2020, 8:06 PM",
    "Subject": "[SDK] Hardware request for ARM64 support",
    "IDs": "<CAMovQvfK6KzSjWZRabYfYcnjOnZ6q5fXJjrNeW1GWuAFhB5w4w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Models sent by Holly",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Thu, Nov 12, 2020, 8:37 PM",
    "Subject": "Re: Presenter MKT material",
    "IDs": "<874FDCA9-AC1E-44D2-9403-F0F089852EE4@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Templates shared with Philip",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Thu, Nov 12, 2020, 8:37 PM",
    "Subject": "Re: Presenter MKT material",
    "IDs": "<874FDCA9-AC1E-44D2-9403-F0F089852EE4@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Applications by Khoa",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Tue, Nov 10, 2020, 9:04 PM",
    "Subject": "Intern Applications - jobs@personifyinc.com - Invitation to collaborate",
    "IDs": "<000000000000b7f25205b3cc0e4f@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Good resume sent by Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, Nov 10, 2020, 10:47 AM",
    "Subject": "Really good resume",
    "IDs": "<0CC609E8-0232-408B-B157-4BD4CD80FD69@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Linkedin customer by Simon",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Nov 9, 2020, 11:43 AM",
    "Subject": "Hopin.to",
    "IDs": "<CALV-+1ftS8Z2N=L5n68e5Ef+7EOM40JhRNz-rG9YQjZf2y2ZHw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Jira notification from Long",
    "Entity": "Link",
    "Sub-type": "Jira",
    "Date and time": "Fri, Nov 6, 2020, 1:01 AM",
    "Subject": "[JIRA] Long Truong mentioned you on APPS-1424",
    "IDs": "<01EPE5R1WA9V9YEWD6430ERF5G@personify.atlassian.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Maintainance at Oak Creek",
    "Entity": "Date",
    "Sub-type": "",
    "Date and time": "Oct 6, 2020, 6:25 PM",
    "Subject": "1551 McCarthy Blvd., Milpitas - Notice",
    "IDs": "<BYAPR05MB44711EDE368BC986568DE1E4A90D0@BYAPR05MB4471.namprd05.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Windows desktop from Mike",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Sat, Aug 8, 2020 at 12:27 AM",
    "Subject": "Re: [EXTERNAL] personify: psycameratransforms.dll failing",
    "IDs": "<CAL43u-WLSV=P1SyG=5_NC5GPmMNTJCuoan1nKT3UTHCEY-vyGg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Evaluation agreement from Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 5, 2020, 5:19 AM",
    "Subject": "ClassPoint Singapore startup NDA & Eval. agreement",
    "IDs": "<00ad01d6b365$91436430$b3ca2c90$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Nondisclosure agreement Inknoe",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 5, 2020, 5:19 AM",
    "Subject": "ClassPoint Singapore startup NDA & Eval. agreement",
    "IDs": "<00ad01d6b365$91436430$b3ca2c90$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Inknoe evaluation to Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 5, 2020, 10:37 AM",
    "Subject": "Re: ClassPoint Singapore startup NDA & Eval. agreement",
    "IDs": "<F11BB8A7-E503-4DD4-B521-87482A6B9C84@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Inknoe nondisclosure to Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Nov 5, 2020, 10:37 AM",
    "Subject": "Re: ClassPoint Singapore startup NDA & Eval. agreement",
    "IDs": "<F11BB8A7-E503-4DD4-B521-87482A6B9C84@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Release notes from Long",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Mon, Nov 2, 2020, 5:38 AM",
    "Subject": "Sign-off for release ChromaCam for Mac 1.0.2.56 (missing Slides feature, Apt-in, bug report, limit login 3 times...)",
    "IDs": "<CAL43u-WbC_SxkL8DJr9dCyv9Mx4po4oA7vHtDFdPy02oCVZ8WA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Test reports from Long",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Mon, Nov 2, 2020, 5:38 AM",
    "Subject": "Sign-off for release ChromaCam for Mac 1.0.2.56 (missing Slides feature, Apt-in, bug report, limit login 3 times...)",
    "IDs": "<CAL43u-WbC_SxkL8DJr9dCyv9Mx4po4oA7vHtDFdPy02oCVZ8WA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Oct results sent by Dustin",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Nov 2, 2020, 3:19 PM",
    "Subject": "Personify Oct Financials",
    "IDs": "<MWHPR0801MB3722FD2B387B4510B4CCC8CF87100@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "October results shared with Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Nov 2, 2020, 3:19 PM",
    "Subject": "Personify Oct Financials",
    "IDs": "<MWHPR0801MB3722FD2B387B4510B4CCC8CF87100@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Vendor info form from Dustin",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Fri, Oct 9, 2020, 2:30 PM",
    "Subject": "RE: Sanjay's monthly fee",
    "IDs": "<5AE0D94F-4A1C-4E83-A656-6B5A245AB38E@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Compiled vendor form by Sanjay",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Nov 2, 2020, 12:25 PM",
    "Subject": "Re: Sanjay's monthly fee",
    "IDs": "<4A6DCF04-3D0D-420D-9D63-FA8B186BE717@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Phase 2 plan from Long",
    "Entity": "Link",
    "Sub-type": "Atlassian",
    "Date and time": "Wed, Oct 28, 2020, 11:52 PM",
    "Subject": "Re: Bank of America Hai's Demo Cisco Jabber",
    "IDs": "<CAL43u-U1xhjMFtdmsk-Jqz=KPDSMdZZeFuFr_u8Wt6akG3AGTQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Phase 2 link to Simon",
    "Entity": "Link",
    "Sub-type": "Atlassian",
    "Date and time": "Wed, Oct 28, 2020, 11:52 PM",
    "Subject": "Re: Bank of America Hai's Demo Cisco Jabber",
    "IDs": "<CAL43u-U1xhjMFtdmsk-Jqz=KPDSMdZZeFuFr_u8Wt6akG3AGTQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Machines links from Viet",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Fri, Oct 30, 2020, 4:07 AM",
    "Subject": "[SDK] Hardware request",
    "IDs": "<CAMovQveyex_ZOigdrJArj9EV-bzFGw_WLSY8_3vyKYAx_5cu7g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Github account",
    "Entity": "Email address",
    "Sub-type": "",
    "Date and time": "Fri, Oct 30, 2020, 12:28 PM",
    "Subject": "Need a generic email account",
    "IDs": "<5015493B-96F9-4465-BB40-099503A7F750@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Jd draft sent by Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Mon, Oct 26, 2020, 5:32 PM",
    "Subject": "UIUC intern",
    "IDs": "<A5AA3C9A-8F7D-4E6F-953E-50F678A0236F@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Updated job description",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Oct 29, 2020, 2:44 PM",
    "Subject": "Re: UIUC intern",
    "IDs": "<458B48D3-DEB3-4AB3-96E0-6D2A49993C4C@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Definitive jd sent by Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Oct 29, 2020, 3:10 PM",
    "Subject": "Re: UIUC intern",
    "IDs": "<DDB3C628-E80E-40E1-BA6B-AFB68335DC57@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Deepar github from Simon",
    "Entity": "Link",
    "Sub-type": "Github",
    "Date and time": "Oct 30, 2020, 3:32 AM",
    "Subject": "Fwd: I'd like to learn more about integrating deepar into our video conf...",
    "IDs": "<BYAPR08MB5543181186A1FB2F29EEF684A5150@BYAPR08MB5543.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Collaboration folder from Khoa",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Thu, Oct 29, 2020, 6:50 PM",
    "Subject": "LongD/Cong collaboration - Invitation to edit",
    "IDs": "<00000000000077441805b2d7f27b@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Pricing slide by Philip",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Tue, Oct 27, 2020, 6:26 PM",
    "Subject": "DeepAR and pricing",
    "IDs": "<002601d6acb8$a17fde40$e47f9ac0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Virtual AV estimate",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Sun, Oct 25, 2020, 11:37 PM",
    "Subject": "Estimate #14 from Virtual AV",
    "IDs": "<E8FD6AB1-377B-4E26-9E62-15D54CB66D9A@virtualav.io>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "rd jd from viet",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "Fri, Oct 23, 2020, 10:23 PM",
    "Subject": "[JD-R&D] Javascript, iOS, Android Engineering for R&D Teams",
    "IDs": "<CAMovQveVV47foL+ZPpkM3RGgnvfx6Pd=UO2Z+K7ip=7zb0Yigg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "New jd shared by Long",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "Oct 24, 2020, 6:58 AM",
    "Subject": "Re: [JD-R&D] Javascript, iOS, Android Engineering for R&D Teams",
    "IDs": "<CAL43u-UDgM__Rrf=XesSe_a7eGkcPCUqduWQfs4YOCHAJTVCCg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Senior engineer folder",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Thu, Oct 22, 2020, 7:12 PM",
    "Subject": "Senior Research and Product Development Engineer (C++, Algorithm, R&D) - Invitation to edit",
    "IDs": "<00000000000067dd9f05b24b6e08@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Comment by Simon on Jira",
    "Entity": "Link",
    "Sub-type": "Jira",
    "Date and time": "Thu, Oct 22, 2020, 3:51 PM",
    "Subject": "[JIRA] Simon Ng mentioned you on APPS-1382",
    "IDs": "<01EN918WJM62RMBDH0QZD0FM5D@personify.atlassian.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Finastra problems",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Oct 12, 2020, 6:14 AM",
    "Subject": "RE: FW: [EXT] RE: Cannot get past login screen [ ref:_00DG0Cbyq._5001M1aehi4:ref ]",
    "IDs": "<HE1PR08MB2923CE9DA4FE28609801DC0FE0070@HE1PR08MB2923.eurprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Issues list from Simon",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Oct 12, 2020, 5:44 PM",
    "Subject": "Fwd: FW: [EXT] RE: Cannot get past login screen [ ref:_00DG0Cbyq._5001M1aehi4:ref ]",
    "IDs": "<CALV-+1dGsU=XE9haZbTszuU+DJHVmUAAyaJXA4MNpGUbHGtwKQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Updated finastra issues",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Oct 14, 2020, 4:47 AM",
    "Subject": "RE: FW: [EXT] RE: Cannot get past login screen [ ref:_00DG0Cbyq._5001M1aehi4:ref ]",
    "IDs": "<HE1PR08MB292354AD13A806B2585DDBB2E0050@HE1PR08MB2923.eurprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Cisco assessment",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Oct 16, 2020, 10:50 AM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<D89C8A3B-D7AF-4A02-935A-BB063E4CFF55@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Assesment from Khoa",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Oct 16, 2020, 10:50 AM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<D89C8A3B-D7AF-4A02-935A-BB063E4CFF55@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Trip survey from Long",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Oct 15, 2020, 6:34 PM",
    "Subject": "Re: Team building trip 2020 options to get approval.",
    "IDs": "<CAL43u-WTaPup3z39fUth-wNJqB2NcRX45ksyU8cxfg1csusunQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Jira comment from Khoa",
    "Entity": "Link",
    "Sub-type": "Jira",
    "Date and time": "Wed, Oct 14, 2020, 6:18 PM",
    "Subject": "[JIRA] Khoa Tran mentioned you on APPS-1196",
    "IDs": "<01EMMPG2J2JRRSNFHY1JAEE294@personify.atlassian.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Car invoice from Lisa",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tuesday, October 13, 2020 6:07 PM",
    "Subject": "FW: Invoice # 9539-1",
    "IDs": "<3132F165-B2ED-46F7-80AB-1A4EA1F56DDC@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Guide from Loi",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "Tue, Oct 13, 2020, 2:50 AM",
    "Subject": "QLM Quick Guide - Invitation to edit",
    "IDs": "<0000000000008013d005b188acb8@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Pilot from Andrew",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Wed, Jul 8, 2020 at 4:27 PM",
    "Subject": "Re: today's call",
    "IDs": "<CAEU0P5aX3HeT=mEQghVge-v-wR_1SyXDLo7dahp09MHd47Oy6w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "James number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Fri, Oct 9, 2020, 10:24 AM",
    "Subject": "RE: ChromaCam",
    "IDs": "<ad29db05880d424b92c12c4c6153f7a0@mayerbrown.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Rack from Surendra",
    "Entity": "Link",
    "Sub-type": "Amazon",
    "Date and time": "Wed, Oct 7, 2020, 3:14 PM",
    "Subject": "1551 McCarthy 113 project",
    "IDs": "<D7BCCCCC-33A0-4ACD-A3DE-EE09F027A2E4@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Rack found by Ramon",
    "Entity": "Link",
    "Sub-type": "Amazon",
    "Date and time": "Oct 8, 2020, 9:54 AM",
    "Subject": "RE: 1551 McCarthy 113 project",
    "IDs": "<BYAPR08MB5061697C83430F607547A8ABC20B0@BYAPR08MB5061.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Test results from Khoa",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Wed, Sep 16, 2020, 1:14 PM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<46FFFC85-FEB4-41E3-A6BA-00CD423ED22E@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Comparison results to Keith",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Wed, Sep 16, 2020, 1:14 PM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<46FFFC85-FEB4-41E3-A6BA-00CD423ED22E@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Rsupport link from Philip",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Sun, Oct 4, 2020, 11:09 PM",
    "Subject": "회신: Notice of Information, From Haeden Bridge",
    "IDs": "<004801d69acd$469ac690$d3d053b0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Jeremiah's external ip",
    "Entity": "Location",
    "Sub-type": "IP address",
    "Date and time": "Sep 30, 2020, 3:23 PM",
    "Subject": "Re: Offline Activation Product Management",
    "IDs": "<CAC=hQbmRErJkK2k9BExLWWgF-2vskw41jKDvribV20iuMSczYQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "AMD laptop link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Tuesday, August 11, 2020 at 2:47 AM",
    "Subject": "RE: StarLeaf / Personify",
    "IDs": "<CAKVuy5Gtb9_BuN1k0d0B4rT+K5pYAKO6JNGy4ykEkhh_b_hpcA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Core update sent to Sam",
    "Entity": "Link",
    "Sub-type": "Dropbox",
    "Date and time": "Wednesday, August 5, 2020 at 3:02 AM",
    "Subject": "Re: StarLeaf / Personify",
    "IDs": "<CAKVuy5Gtb9_BuN1k0d0B4rT+K5pYAKO6JNGy4ykEkhh_b_hpcA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify update from Andrew",
    "Entity": "Link",
    "Sub-type": "Dropbox",
    "Date and time": "Wednesday, August 5, 2020 at 3:02 AM",
    "Subject": "Re: StarLeaf / Personify",
    "IDs": "<CAKVuy5Gtb9_BuN1k0d0B4rT+K5pYAKO6JNGy4ykEkhh_b_hpcA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Starleaf user revenue",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Sep 18, 2020, 5:12 AM",
    "Subject": "Re: StarLeaf / Personify commercial discussion",
    "IDs": "<AM7P194MB07563C7754A0BF7B2CE244CB823F0@AM7P194MB0756.EURP194.PROD.OUTLOOK.COM>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "New test link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Thu, Oct 1, 2020, 8:45 PM",
    "Subject": "[Campaign sent] Apology with NEW Test Link",
    "IDs": "<01000174e6fcaa72-ee8e5ca2-b148-433f-9029-c239b7b18c1f-000000@email.amazonses.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Correct study link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Thu, Oct 1, 2020, 5:55 PM",
    "Subject": "Re: Invitation to card-sorting study for ChromaCam",
    "IDs": "<CALV-+1fGounj_qVLJZBbAr4sfuWXCr9Y0e1RJ0F+10dsAEYLdg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify sentry file",
    "Entity": "File",
    "Sub-type": "Csv",
    "Date and time": "Thu, Sep 17, 2020, 1:50 PM",
    "Subject": "Re: FW: Bulk purchase [ ref:_00DG0Cbyq._5001M1ay2Fy:ref",
    "IDs": "<CAN6k-eWFcyN2j3KCK+3rCV-mKWWTxVhNuPcPWWjCd2q0wy3ACQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Member list from sentry",
    "Entity": "File",
    "Sub-type": "Csv",
    "Date and time": "Sep 17, 2020, 4:14 PM",
    "Subject": "RE: FW: Bulk purchase [ ref:_00DG0Cbyq._5001M1ay2Fy:ref ]mailed-by:sentryone.com",
    "IDs": "<CAN6k-eWFcyN2j3KCK+3rCV-mKWWTxVhNuPcPWWjCd2q0wy3ACQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Hitachi slides from Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Sep 24, 2020, 5:40 AM",
    "Subject": "전달: Thank you for the meeting / Hitachi Solutions",
    "IDs": "<018701d6925f$3015ece0$9041c6a0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Presenter ussues video",
    "Entity": "Link",
    "Sub-type": "Google Drive",
    "Date and time": "Sep 29, 2020, 5:55 PM",
    "Subject": "Presenter 2 screen issue on Windows",
    "IDs": "<CAC=hQb=jm5k9hrQ9xthYjWY5fQN7eFdWQHcEiPBSi8RG9ey+HQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Oracles machines",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Aug 21, 2020, 6:42 AM",
    "Subject": "RE: Personify introductions of new team and version 3.0 / Quotation #0222640904 Personify Presenter 3.0",
    "IDs": "<7469c121-fc22-46ec-9722-3872f0ff1112@default>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Offscreen video sent to Iulian",
    "Entity": "Link",
    "Sub-type": "Google Drive",
    "Date and time": "Sep 25, 2020, 5:37 PM",
    "Subject": "Re: Personify introductions of new team and version 3.0 / Quotation #0222640904 Personify Presenter 3.0",
    "IDs": "<CAC=hQbmF+pm7w2J8nBxid22hivKL1yruCSYZAB43Lr6LnX5TBQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "GPU-Z App",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "9/1/2020 6:13 PM",
    "Subject": "Personna is freezing while using it [ ref:_00DG0Cbyq._5001M1ayP73:ref ]",
    "IDs": "<DB7PR08MB3724EDEF76C45A907F1FB7C59F3F0@DB7PR08MB3724.eurprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "LMI slides from Khoa",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Sep 28, 2020, 6:01 PM",
    "Subject": "Re: Personify SDK Integration",
    "IDs": "<DC322CC2-5210-4A8F-926F-1D3FEDFEAD64@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "sdk evolution slides",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Mon, Sep 28, 2020, 6:00 PM",
    "Subject": "Personify SDK Improvements - Invitation to edit",
    "IDs": "<0000000000006e4e8805b067a27a@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Preliminary september results",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Sep 28, 2020, 4:35 PM",
    "Subject": "Financial Reporting Package-Personify 2020 09.xlsx",
    "IDs": "<MWHPR0801MB372277142BECADFC47BFD59687350@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "PortraitNet",
    "Entity": "Link",
    "Sub-type": "Github",
    "Date and time": "Friday, September 4, 2020 3:28 PM",
    "Subject": "Re: Proposition - Personify SDK",
    "IDs": "<010501d68284$9dbdbd80$d9393880$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Link to Openvino",
    "Entity": "Link",
    "Sub-type": "Github",
    "Date and time": "Friday, September 4, 2020 3:28 PM",
    "Subject": "Re: Proposition - Personify SDK",
    "IDs": "<010501d68284$9dbdbd80$d9393880$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Slides from Viet",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Sep 24, 2020, 6:11 PM",
    "Subject": "Re: [Source Code Protection] Share source code with Cisco team",
    "IDs": "<93168EF1-993C-461A-9AFF-89DD5D66C04B@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "UPS machines from Long",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Sep 21, 2020, 11:16 AM",
    "Subject": "Fwd: UPS request",
    "IDs": "<CAL43u-Vz7dR5W_4sLZ7JMCv0-p-KGOMgqHw3L=NmEDhQh2gQHA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Charging station agreemen from Gin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Sep 23, 2020, 2:09 PM",
    "Subject": "1551 McCarthy Blvd., Milpitas",
    "IDs": "<BYAPR05MB447170E7F10E397F56CB7DD0A9380@BYAPR05MB4471.namprd05.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Calc sheet by Ginny",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Sep 23, 2020, 2:09 PM",
    "Subject": "1551 McCarthy Blvd., Milpitas",
    "IDs": "<BYAPR05MB447170E7F10E397F56CB7DD0A9380@BYAPR05MB4471.namprd05.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "AIE sent by Dustin",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Sep 22, 2020, 2:58 PM",
    "Subject": "RE: Personify Payments",
    "IDs": "<46768C91-68A2-4CC6-836B-806DD3376293@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "PG&E number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Sep 22, 2020, 12:44 PM",
    "Subject": "PG&E and Internet",
    "IDs": "<CAKVuy5Fp9-iAMxjqfAY=jFoYa6REBeiT=zGrGk5j4Joa3tsVcA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "AT&T number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Sep 22, 2020, 12:44 PM",
    "Subject": "PG&E and Internet",
    "IDs": "<CAKVuy5Fp9-iAMxjqfAY=jFoYa6REBeiT=zGrGk5j4Joa3tsVcA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Ginny Poole's phone",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Sep 22, 2020, 12:44 PM",
    "Subject": "PG&E and Internet",
    "IDs": "<CAKVuy5Fp9-iAMxjqfAY=jFoYa6REBeiT=zGrGk5j4Joa3tsVcA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Account number from Dustin",
    "Entity": "Account number",
    "Sub-type": "",
    "Date and time": "Tue, Sep 22, 2020, 1:23 PM",
    "Subject": "RE: PG&E and Internet",
    "IDs": "<MWHPR0801MB37226503D78CEF8D89C59E08873B0@MWHPR0801MB3722.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Enteprise setup from Loi",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Tue, Sep 22, 2020, 4:56 AM",
    "Subject": "Personify.Presenter.Enterprise.3.0.5.1-Setup.exe",
    "IDs": "<000000000000c123fd05afe3fbf7@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Key form Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wednesday, September 16, 2020 8:16 PM",
    "Subject": "My contact info",
    "IDs": "<BYAPR05MB4471AA18C6BF44AE794CC273A93F0@BYAPR05MB4471.namprd05.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Performance comparison for psyseg",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Fri, Sep 18, 2020 at 4:17 AM",
    "Subject": "Re: Compare about performance for 3.5.18 and latest release",
    "IDs": "<CAO+SG-0CTFBrMP6PG08JmvmwjM215hj-E1aSRR0XSWf-ihnOuw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "s/w signed by Caregility",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Sunday, July 5, 2020 at 11:46 PM",
    "Subject": "S/W evaluation agreement",
    "IDs": "<BL0PR0102MB34425ECC1F8079348D34BDB4AA7E0@BL0PR0102MB3442.prod.exchangelabs.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Evaluation agreement from Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jul 15, 2020, 7:51 PM",
    "Subject": "Re: Software Evaluation Agreement_Personify Inc._Caregility",
    "IDs": "<FCC962D5-D6B2-40CD-B690-5538D7695E09@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Complete agreement from Philip",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jul 15, 2020, 8:30 PM",
    "Subject": "회신: Software Evaluation Agreement_Personify Inc._Caregility",
    "IDs": "<00a501d65b10$a13cd090$e3b671b0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Complete agreement sent to Roger",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jul 15, 2020, 8:30 PM",
    "Subject": "회신: Software Evaluation Agreement_Personify Inc._Caregility",
    "IDs": "<00a501d65b10$a13cd090$e3b671b0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Issues list from Khoa",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Tue, Sep 15, 2020, 12:58 PM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<268B671F-41C3-4C8A-A132-645D336664F3@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Current issues with Cisco",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Sep 16, 2020, 10:56 AM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<22E68023-E9B4-4069-A7E6-9B75EEF817F3@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Current issues with Presenter",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Sep 16, 2020, 10:56 AM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<22E68023-E9B4-4069-A7E6-9B75EEF817F3@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Support evolution slide",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Sep 16, 2020, 10:56 AM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<22E68023-E9B4-4069-A7E6-9B75EEF817F3@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Mac performance comparison",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Sep 16, 2020, 1:14 PM",
    "Subject": "Re: Personify SDK Engineering Quality and Process",
    "IDs": "<46FFFC85-FEB4-41E3-A6BA-00CD423ED22E@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Khoa's number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Wed, Sep 2, 2020, 1:22 PM",
    "Subject": "Re: Enterprise release please share",
    "IDs": "<BD434A92-7288-463B-868F-FDEA5404B8DA@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Summary of tickets from Loron",
    "Entity": "List",
    "Sub-type": "",
    "Date and time": "Tue, Sep 15, 2020, 5:29 PM",
    "Subject": "09/15/2020 Summary of tickets for sales team",
    "IDs": "<019901d68baf$be4f8b30$3aeea190$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify's ECCN from Susan",
    "Entity": "Code",
    "Sub-type": "",
    "Date and time": "Mon, Sep 14, 2020 at 10:45 AM",
    "Subject": "RE: ENNC",
    "IDs": "<DM5PR08MB295662D2363D6B07660FDD838A230@DM5PR08MB2956.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Who's starleaf VP of product",
    "Entity": "Link",
    "Sub-type": "Linkedin",
    "Date and time": "Wed, Jun 17, 2020, 4:55 AM",
    "Subject": "Fwd: StarLeaf / Personify",
    "IDs": "<CAEU0P5aJQSY-Yix6ZRRqnphtf=6irfOm+srNqz55KKDFTAJVKw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Sample eval agreement",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Jun 17, 2020, 3:31 PM",
    "Subject": "Re: StarLeaf / Personify",
    "IDs": "<CAEU0P5bzyMEeJ-4V=bn_2HN=Ke33XWzjff1x8KRGBDcm1O8G_g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Evaluation agreement draft from Personify",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Jun 17, 2020, 3:31 PM",
    "Subject": "Re: StarLeaf / Personify",
    "IDs": "<CAEU0P5bzyMEeJ-4V=bn_2HN=Ke33XWzjff1x8KRGBDcm1O8G_g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Definitive evaluation agreement from Andrew",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jun 18, 2020 at 2:32 PM",
    "Subject": "Re: StarLeaf / Personify",
    "IDs": "<CAEU0P5ZMHtQmTozUicAYUibh=958PGVM111_c8eJENJeF+bM1Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Definitive starleaf eval agreement",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jun 18, 2020 at 2:32 PM",
    "Subject": "Re: StarLeaf / Personify",
    "IDs": "<CAEU0P5ZMHtQmTozUicAYUibh=958PGVM111_c8eJENJeF+bM1Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Update link from Andrew",
    "Entity": "Link",
    "Sub-type": "Dropbox",
    "Date and time": "Wed, Aug 5, 2020, 5:01 AM",
    "Subject": "Re: StarLeaf / Personify",
    "IDs": "<CAEU0P5ZSNaXScPD3SLm94dD3zOXstW0-jGDFBS0DaLq79ckZmQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Video outline from Jeremiah",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Sep 10, 2020, 11:48 AM",
    "Subject": "Jeremiah Barkman shared \"ConXChat Video Outline Draft 1\" with you.",
    "IDs": "<CO2PR0801MB231250B204D0CBCF39D1C87CCD270@CO2PR0801MB2312.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Stability issues from Khoa",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Wed, Sep 9, 2020, 12:49 PM",
    "Subject": "SDK stability issues - Invitation to edit",
    "IDs": "<0000000000003b939605aee5131a@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Mooncake budget by Long",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Wed, Sep 9, 2020, 4:18 AM",
    "Subject": "Fwd: Quotation for preparing Moon cake 2020",
    "IDs": "<CAL43u-VjfZbdotXZ=9coVNuDyeztjU0vrmd9eBZLCjDEfY4_Xw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "QLM Presenter keys",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Tue, Sep 8, 2020, 11:30 PM",
    "Subject": "QLM Activation Keys for Presenter (Win and Mac) - Invitation to edit",
    "IDs": "<000000000000a3bf3305aed9ea8e@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "iPhone suggestion from Viet",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Sep 7, 2020, 2:25 AM",
    "Subject": "[Resource Request] IPhoneX for SDK iOS support",
    "IDs": "<CAMovQvchvo1wvWQ_FK1Ln4-b0vQVikYxB4gyJuJxABc9f3-Ogg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Sales summary sent by Philip",
    "Entity": "Link",
    "Sub-type": "Google Analytics",
    "Date and time": "Sat, Sep 5, 2020, 10:15 PM",
    "Subject": "Web sales summary ANZ - August 2020",
    "IDs": "<003201d683fc$0c501360$24f03a20$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Net summer revenue from Philip",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Sep 3, 2020, 8:51 AM",
    "Subject": "Partner Rev Share data",
    "IDs": "<01ea01d681f9$456e61b0$d04b2510$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Link for Google Analytics Korea",
    "Entity": "Link",
    "Sub-type": "Google Analytics",
    "Date and time": "Sep 3, 2020, 8:51 AM",
    "Subject": "Partner Rev Share data",
    "IDs": "<01ea01d681f9$456e61b0$d04b2510$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Link for Google Analytics Japan",
    "Entity": "Link",
    "Sub-type": "Google Analytics",
    "Date and time": "Sep 3, 2020, 8:51 AM",
    "Subject": "Partner Rev Share data",
    "IDs": "<01ea01d681f9$456e61b0$d04b2510$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Summer revenue corrected by Dustin",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Thu, Sep 3, 2020 at 2:17 PM",
    "Subject": "RE: Partner Rev Share data",
    "IDs": "<3E0F736A-0B5E-4084-9333-4533975FD02F@hxcore.ol>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Nvidia blog shared by Surendra",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, Aug 26, 2020, 9:38 PM",
    "Subject": "Re: Your offer letter to Pexip",
    "IDs": "<2B0F4B2A-339B-4D99-A650-C23F48185CF3@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Eddie from Pexip",
    "Entity": "Link",
    "Sub-type": "Linkedin",
    "Date and time": "Fri, Aug 28, 2020 at 7:00 AM",
    "Subject": "회신: Your offer letter to Pexip",
    "IDs": "<000f01d67d32$c7b78be0$5726a3a0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Timesheet from Uyen Tran",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Tue, Sep 1, 2020 at 9:59 AM",
    "Subject": "Re: VN Personify transfer from Oldco to Newco - Payment Application from Uyen Tran",
    "IDs": "<CAL43u-XkYLpw4GQ3CXo_1wXbaZpQ0=KtGcofe_ryFCUXodXR3Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Jira ticket about unistalling",
    "Entity": "Link",
    "Sub-type": "Jira",
    "Date and time": "Sep 1, 2020, 4:07 AM",
    "Subject": "Re: User feedback",
    "IDs": "<CAL43u-UAKDWb8Lppmw3jEAonYGTuUpreY-SCd3BU9C7c2_f=+Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Terms of service by Frank",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Aug 20, 2020, 7:31 PM",
    "Subject": "Personify, Inc. --- UPDATED TERMS OF SERVICE FROM WEBSITE [ NEW VERSION ATTACHED]",
    "IDs": "<Mimecast.4448.1b41cd342bde1e1a.1740e6d614e@us-sl-62.us.mimecast.lan>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Great video sent by Holly",
    "Entity": "Link",
    "Sub-type": "Video",
    "Date and time": "Wed, Jun 2, 10:48 AM",
    "Subject": "Great video",
    "IDs": "<CAMySe0UHdzyZChCicFwM8cQPo05G2p4iqzYf540xTeC9NXGurA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "When is ena trading track",
    "Entity": "Event",
    "Sub-type": "",
    "Date and time": "Fri, Jan 29, 12:15 PM",
    "Subject": "ENA Trading Track - Interviews October",
    "IDs": "<CAGM-d-Ep044Yd6YBa+30dgA2vDqEV7zFSwLg71d1J4PKUFM_1w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Deadline for chairma's award",
    "Entity": "Date",
    "Sub-type": "",
    "Date and time": "Fri, Jan 29, 12:14 PM",
    "Subject": "2001 Chairman's Award Deadline Extension",
    "IDs": "<CAGM-d-FwA9MeWvtPEYC=i=awJQPPsvXtsM_t_6c8xMLP6LtC9A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Link about urban legends",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Fri, Jan 29, 12:14 PM",
    "Subject": "FW: Urban Legends Reference Pages Rumors of War",
    "IDs": "<CAGM-d-E7TY=Q9QMXfjTVO9d9DF_y8bLhB3C7msfVMeDbikThTw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Feedback form from Shuchen",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Fri, Jan 29, 11:15 AM",
    "Subject": "(no subject)",
    "IDs": "<CAFQg0LpuDz_DF1KjEgOs0dDQ-XLNPEk4D7k+gtRXP79=h5-FtQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "NER blog shared by Shuchen",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "Thu, Jan 28, 3:46 PM",
    "Subject": "(no subject)",
    "IDs": "<CAC1JF-9z51hmyXOe-VkpTGY1UkD=3jtE4fsU4wqiyYR1Wi1_dQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Facebook ai link sent by Shuchen",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Thu, Jan 28, 2:25 PM",
    "Subject": "(no subject)",
    "IDs": "<CAFQg0LrZAT1L_ezrcWnEVc1n9Fd3u=NhRzC43iG1mJYgkFBPag@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Issues list compiled by Khoa",
    "Entity": "Link",
    "Sub-type": "Google Sheet",
    "Date and time": "Aug 22, 2020, 2:57 PM",
    "Subject": "Re: Cisco issues and Solutions",
    "IDs": "<52EEABD7-F0FC-4A38-8C44-A8BEA1B27324@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "SDK customer issues",
    "Entity": "Link",
    "Sub-type": "Google Sheet",
    "Date and time": "Sat, Aug 22, 2020, 2:56 PM",
    "Subject": "SDK Customer Issues - Invitation to edit",
    "IDs": "<00000000000081be8405ad7cc11b@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Video wall tracker shared by Chris",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Tue, Aug 18, 2020, 3:21 PM",
    "Subject": "RE: XLS with tracking info",
    "IDs": "<MWHPR08MB2496F37D1A2E0DCF7F0D2553845C0@MWHPR08MB2496.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Updated video wall tracker from Chris",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Thu, Aug 20, 2020, 8:22 AM",
    "Subject": "RE: XLS with tracking info",
    "IDs": "<MWHPR08MB249602467F13CDA0686EF50E845A0@MWHPR08MB2496.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "SOC2 slides from Khoa",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Fri, Aug 21, 2020, 9:41 AM",
    "Subject": "SOC 2 - Invitation to edit",
    "IDs": "<000000000000390ce205ad643cc4@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Challenge shared by Surendra",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Aug 10, 2020, 10:08 PM",
    "Subject": "Re: Summary",
    "IDs": "<3DCD4996-7B6B-48E7-9164-19F475193647@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Hyperconnect link from Philip",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Aug 10, 2020, 11:10 PM",
    "Subject": "회신: Summary",
    "IDs": "<000801d66f95$4ba5b6d0$e2f12470$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Surendra's linkedin profile",
    "Entity": "Link",
    "Sub-type": "Linkedin",
    "Date and time": "Monday, August 17, 2020 at 3:52 PM",
    "Subject": "회신: Personify Introductions; backgrounds",
    "IDs": "<004f01d67750$3740c910$a5c25b30$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Sanjay's linkedin profile",
    "Entity": "Link",
    "Sub-type": "Linkedin",
    "Date and time": "Monday, August 17, 2020 at 3:52 PM",
    "Subject": "회신: Personify Introductions; backgrounds",
    "IDs": "<004f01d67750$3740c910$a5c25b30$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Linkedin of Personify's CEO",
    "Entity": "Link",
    "Sub-type": "Linkedin",
    "Date and time": "Monday, August 17, 2020 at 3:52 PM",
    "Subject": "회신: Personify Introductions; backgrounds",
    "IDs": "<004f01d67750$3740c910$a5c25b30$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Linkedin of Personify's CTO",
    "Entity": "Link",
    "Sub-type": "Linkedin",
    "Date and time": "Monday, August 17, 2020 at 3:52 PM",
    "Subject": "회신: Personify Introductions; backgrounds",
    "IDs": "<004f01d67750$3740c910$a5c25b30$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Registration link from Bank of America",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Tue, Aug 18, 2020 at 1:12 PM",
    "Subject": "RE: Chromacam for enterprise deployment.",
    "IDs": "<8bab8b0e34bd44e28cae59e6a9e15175@bofa.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Liting patent from Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Aug 26, 2020 at 7:02 PM",
    "Subject": "472_US20190251434.pdf",
    "IDs": "<8AE50045-C518-4CAD-8320-357AACFDAEDE@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Liting patent shared with Sanjay",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Aug 26, 2020 at 7:02 PM",
    "Subject": "472_US20190251434.pdf",
    "IDs": "<8AE50045-C518-4CAD-8320-357AACFDAEDE@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Windows build for cisco with file increase",
    "Entity": "Link",
    "Sub-type": "Google Drive?",
    "Date and time": "Mon, Aug 17, 2020 at 10:15 AM",
    "Subject": "Cisco Windows - Version Incrementation",
    "IDs": "<CAMovQvcP3xDSrjuHjOUeRyuetOctGW6TY8cny1x801=0RXAm7Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Dustin's number",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Mon, Aug 17, 2020 at 10:58 AM",
    "Subject": "Re: Insight Overdue Invoices",
    "IDs": "<CAKVuy5HdLCrtKYiFArnBF+OwTGj8TZ0jTkRfBVezozDEHa0e+w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Windows frames report shared by Long",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Sat, Aug 15, 2020 at 3:09 AM",
    "Subject": "Re: Ground-truth data & DNN in PsySeg",
    "IDs": "<CAL43u-UFB-hxP9+XSCNF1bryNfa1mX-fsRrFdiMxZK3zdp6WoA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify company overview",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Aug 14, 2020 at 1:50 AM",
    "Subject": "회신: 회신: 회신: Personify integration with SGNS.co",
    "IDs": "<01a801d67207$3378ca60$9a6a5f20$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Company overview",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Fri, Aug 14, 2020 at 1:50 AM",
    "Subject": "회신: 회신: 회신: Personify integration with SGNS.co",
    "IDs": "<01a801d67207$3378ca60$9a6a5f20$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Open vino slides from Viet",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Thu, Aug 13, 2020, 9:36 PM",
    "Subject": "OpenVino-Co - Invitation to edit",
    "IDs": "<000000000000f96bc805accd4a61@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Pain-points report from Holly",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, Aug 11, 2020 at 9:44 PM",
    "Subject": "Presenter research for product development",
    "IDs": "<F97E3990-3116-4C06-9278-9A444F1C3AF1@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "3.0 skus and pricing sent to Oracle",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Aug 13, 2020 at 3:28 PM",
    "Subject": "Re: FW: FW: Presenter v2.0 Release Candidates",
    "IDs": "<CALV-+1dPXC0pHv0jQGdbuYUbSz-CN6Exs37QwH3CuwEgdH226A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Presesenter skus and pricing from Simon",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Aug 13, 2020 at 3:28 PM",
    "Subject": "Re: FW: FW: Presenter v2.0 Release Candidates",
    "IDs": "<CALV-+1dPXC0pHv0jQGdbuYUbSz-CN6Exs37QwH3CuwEgdH226A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Chromacam article written by Sean",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, Aug 5, 2020 at 3:10 PM",
    "Subject": "Re: Feature Article Covering Personify's Chromacam on HostingAdvice.com",
    "IDs": "<CAJcYmS8rkKfn+ZTBJOJsFtKa2Xbt1DYUjCLUpnE4m102HSPk1A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Definitive chromacam article by Sean",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Aug 10, 2020 at 11:26 AM",
    "Subject": "Re: Feature Article Covering Personify's Chromacam on HostingAdvice.com",
    "IDs": "<CAJcYmS_wQDr+ohbTnubAqCDX-GK05a_949D3BJVkoAiFGCgVZA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "SDK Marketing ppt from Viet",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Mon, Aug 3, 2020 at 5:33 AM",
    "Subject": "PPT for PsySDK",
    "IDs": "<CAMovQve+0=xOFZb6x5ti+7hGc-rbkOEbx_pysvZO23rcU70gWQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Psyseg table from Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Aug 3, 2020 at 6:52 PM",
    "Subject": "Re: PPT for PsySDK",
    "IDs": "<91E4EB2A-F704-405F-8D8C-4F50204962AC@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Psyseg performance with blur",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Thu, Aug 6, 2020 at 2:27 PM",
    "Subject": "Re: PPT for PsySDK",
    "IDs": "<CAMovQvcpJAxDmtYX54ZXEnBohvKCreD3dPpzc6CtwHheU4JRCw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Psyseg performance without blur",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Thu, Aug 6, 2020 at 2:27 PM",
    "Subject": "Re: PPT for PsySDK",
    "IDs": "<CAMovQvcpJAxDmtYX54ZXEnBohvKCreD3dPpzc6CtwHheU4JRCw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Camera options for QC team",
    "Entity": "G",
    "Sub-type": "Google Sheets",
    "Date and time": "Tue, Aug 11, 2020, 11:48 PM",
    "Subject": "QC Team camera request - Invitation to edit",
    "IDs": "<000000000000e0cc4805aca6e514@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Telecom reseller metrics from Holly",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Mon, Aug 10, 2020 at 6:47 PM",
    "Subject": "Re: Telecom Reseller Ads update",
    "IDs": "<419AE6F0-0855-43BA-9A06-6D11DB5A3743@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Website improvement plan sent by Holly",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Aug 10, 2020 at 6:43 PM",
    "Subject": "Personify Inc Website Improvement",
    "IDs": "<D20BC00C-3081-4BCB-9745-6962454333A7@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Long's address",
    "Entity": "Location",
    "Sub-type": "Address",
    "Date and time": "Wed, Jul 29, 2020, 11:57 AM",
    "Subject": "Re: agency contact in Houston",
    "IDs": "<17144CAA-96D9-4E5F-8A2C-DC1FCEFEF90C@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "P&T address by Jeremy",
    "Entity": "Location",
    "Sub-type": "Address",
    "Date and time": "Mon, Aug 10, 2020 at 11:42 AM",
    "Subject": "Re: agency contact in Houston",
    "IDs": "<12790145-FED0-4A7F-BB6F-F12C5BACEFC0@infocus.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Phone number for shipping by Jeremy",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Mon, Aug 10, 2020 at 12:23 PM",
    "Subject": "Re: agency contact in Houston",
    "IDs": "<C36F8D1A-DB63-4EC5-A4D3-54B5DA8AD552@infocus.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Shipping label draft from Genette",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Aug 10, 2020, 12:50 PM",
    "Subject": "RE: agency contact in Houston",
    "IDs": "<MWHPR08MB25259C930E2DCA3EA3D551D38B440@MWHPR08MB2525.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Carton labels sent by Khoa",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Mon, Aug 10, 2020 at 1:29 PM",
    "Subject": "Re: agency contact in Houston",
    "IDs": "<72E68EEA-F909-43DA-889D-537056DC84F7@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Wikipedia link from Khoa",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Aug 10, 2020 at 2:44 PM",
    "Subject": "Re: agency contact in Houston",
    "IDs": "<AAE153F4-74FA-419D-B141-7BB23EF4DA14@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Developers kit's specifics shared by Genette",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Mon, Aug 10, 2020 at 2:50 PM",
    "Subject": "RE: agency contact in Houston",
    "IDs": "<MWHPR08MB2525BA090ABC8CCA9EFE66C08B440@MWHPR08MB2525.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Definitive shipping label from Genette",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Aug 10, 2020 at 4:56 PM",
    "Subject": "RE: agency contact in Houston",
    "IDs": "<MWHPR08MB25254D84566CAF006A9513C68B440@MWHPR08MB2525.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Test report for OpenVino by Viet",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Mon, Aug 10, 2020 at 12:15 PM",
    "Subject": "OpenVino Experimental Results",
    "IDs": "<CAMovQvevQG+nKY6r8qw_torYRwUb4Y_G-aUk7bYGyPwq50=BEQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Machines requests from Viet Vo",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Aug 5, 2020, 4:07 PM",
    "Subject": "Resource Requests",
    "IDs": "<CAMovQvd4QrUyt2mKCmO-bC-ikX-TjTSREgqe5ydyifdsktPLag@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "BJN release from Viet",
    "Entity": "Link",
    "Sub-type": "Google Drive",
    "Date and time": "Wed, Aug 5, 2020, 11:49 AM",
    "Subject": "[BJN] Release on top 3.6.5 with OpenCL Runtime Exception",
    "IDs": "<CAMovQvf7RVppEuE4+iCvs_Un-h3YWFFT-LGxq=nWFUy4E742oA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "BJN error codes sent by Viet",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, Aug 5, 2020, 11:49 AM",
    "Subject": "[BJN] Release on top 3.6.5 with OpenCL Runtime Exception",
    "IDs": "<CAMovQvf7RVppEuE4+iCvs_Un-h3YWFFT-LGxq=nWFUy4E742oA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Alcatel slides shared by Andrew",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Aug 4, 2020, 11:05 AM",
    "Subject": "Lucent-Alcatel Enterprise opportunity",
    "IDs": "<CAEU0P5YRLqFRUN6iCUY3OF8yF0hj+fjppOFHJExhS7p-c0DP7g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Summary of Google Ads results sent by Philip",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Aug 2, 2020, 9:46 PM",
    "Subject": "Summary of Google Ads",
    "IDs": "<00c301d66940$5c10b2f0$143218d0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Download and upgrade statistics shared by Huyen",
    "Entity": "Link",
    "Sub-type": "Google Analytics",
    "Date and time": "Aug 2, 2020, 11:12 PM",
    "Subject": "Re: Summary of Google Ads",
    "IDs": "<CAOuUqHve81RebLkXd7n1=0A8qbLPNEXD+1iUbGEf2CoKcgiR-g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "BJN test build by Viet",
    "Entity": "File",
    "Sub-type": "Zip",
    "Date and time": "Fri, Jul 31, 2020, 8:49 AM",
    "Subject": "BJN test build",
    "IDs": "<CAMovQvd81srO6nP3F3xnrFQzRb8qJEVUCCRySZKtNCAyNGmELQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Paywn guide shared by Mike",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jul 30, 2020, 11:42 AM",
    "Subject": "Re: PTO notice",
    "IDs": "<5A10BE6A-BD47-4D27-BBEA-5A208551FE0C@redzonehr.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Paywn guide sent to Khoa",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jul 30, 2020, 11:42 AM",
    "Subject": "Re: PTO notice",
    "IDs": "<5A10BE6A-BD47-4D27-BBEA-5A208551FE0C@redzonehr.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Amendment from Steve Weinstock",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jul 29, 2020, 1:46 AM",
    "Subject": "Fwd: Amendment to our Agreement",
    "IDs": "<CALV-+1ercaZ3DOGNB7=LuQBJ9zpH5dTCe3rYh4=w3TS2ooVEig@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Amendment signed by Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Jul 29, 2020 at 10:57 AM",
    "Subject": "Re: Amendment to our Agreement",
    "IDs": "<37D680F9-2392-4E51-B5D2-78313107741B@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Marketing slides shared by Holly",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Tue, Jul 28, 2020 at 3:05 PM",
    "Subject": "Marketing Update - Invitation to edit",
    "IDs": "<0000000000001889ea05ab85f670@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Strategy slides from Philip",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Fri, Jul 24, 2020 at 7:28 AM",
    "Subject": "Request a call conf.",
    "IDs": "<003c01d661b5$f995fea0$ecc1fbe0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Raise recap by Long",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Jul 20, 2020, 11:15 AM",
    "Subject": "Suggest salary raise for some key persons that having contract renew this Q3",
    "IDs": "<CAL43u-WrDaim2VJAzKroNtjku=c7svq-mHgDwh-S2mtjBVwpag@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Raise recap by Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Jul 20, 2020, 11:15 AM",
    "Subject": "Suggest salary raise for some key persons that having contract renew this Q3",
    "IDs": "<CAL43u-WrDaim2VJAzKroNtjku=c7svq-mHgDwh-S2mtjBVwpag@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Q3 salary review sent by Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Jul 20, 2020, 11:15 AM",
    "Subject": "Suggest salary raise for some key persons that having contract renew this Q3",
    "IDs": "<CAL43u-WrDaim2VJAzKroNtjku=c7svq-mHgDwh-S2mtjBVwpag@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "POEditor links sent by Philip",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Jul 20, 2020, 2:53 AM",
    "Subject": "Local language support issue - IMPORTANT",
    "IDs": "<001001d65e6a$d3f12970$7bd37c50$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "POEditor links sent to Long",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Jul 20, 2020, 2:53 AM",
    "Subject": "Local language support issue - IMPORTANT",
    "IDs": "<001001d65e6a$d3f12970$7bd37c50$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Unsplash links",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Jul 20, 2020, 4:23 PM",
    "Subject": "Unsplash API Partnership for Personify",
    "IDs": "<495b186f-5863-486d-8d0d-0c63e47f5b27.comment276510498@groovehq.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Unsplash api link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Jul 20, 2020, 4:23 PM",
    "Subject": "Unsplash API Partnership for Personify",
    "IDs": "<495b186f-5863-486d-8d0d-0c63e47f5b27.comment276510498@groovehq.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Unsplash guidelines",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Jul 20, 2020, 4:23 PM",
    "Subject": "Unsplash API Partnership for Personify",
    "IDs": "<495b186f-5863-486d-8d0d-0c63e47f5b27.comment276510498@groovehq.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Unsplash documentation",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Jul 20, 2020, 4:23 PM",
    "Subject": "Unsplash API Partnership for Personify",
    "IDs": "<495b186f-5863-486d-8d0d-0c63e47f5b27.comment276510498@groovehq.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "New support page by Holly",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Jul 17, 2020, 11:20 AM",
    "Subject": "FAQs consolidation and page update",
    "IDs": "<CE0CDE25-DAC3-4E67-B870-9722CB69944A@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Chromacam FAQs shared by Holly",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Jul 17, 2020, 11:20 AM",
    "Subject": "FAQs consolidation and page update",
    "IDs": "<CE0CDE25-DAC3-4E67-B870-9722CB69944A@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "FAQs edited by Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Fri, Jul 17, 2020 at 12:05 PM",
    "Subject": "Re: FAQs consolidation and page update",
    "IDs": "<980E1672-E814-47CC-BE14-7D6B4C913EE8@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Flickering video from Jim",
    "Entity": "File",
    "Sub-type": "3gp",
    "Date and time": "Wed, Jul 8, 2020 at 9:25 AM",
    "Subject": "RE: ChromaCam",
    "IDs": "<586b2f9f052144fb91456a45680208cf@mayerbrown.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Flickering logs from mayerbrown",
    "Entity": "File",
    "Sub-type": "Zip",
    "Date and time": "Fri, Jul 10, 2020 at 9:40 AM",
    "Subject": "RE: ChromaCam",
    "IDs": "<dc8ada7536174500850c1df82c0ada67@mayerbrown.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Cisco report shared by Khoa",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Wed, Jul 15, 2020 at 6:08 PM",
    "Subject": "Re: [PersonifyInc/PsySeg] Release psy-seg-3.6.6-rc1 - psy-seg-3.6.6-rc1",
    "IDs": "<848D3BAA-6A8F-4CB0-A433-33F54D49CDA2@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Khoa's report",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Wed, Jul 15, 2020 at 6:20 PM",
    "Subject": "Re: [PersonifyInc/PsySeg] Release psy-seg-3.6.6-rc1 - psy-seg-3.6.6-rc1",
    "IDs": "<07A05498-427D-4B0B-9C22-DB4F33CF6476@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Cisco's scan results sent by Khoa",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Jul 16, 2020 at 1:17 AM",
    "Subject": "Re: [PsySeg] Mjaor Issues for SDK",
    "IDs": "<320C3C86-B8A0-44D0-9D05-24D55506241D@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Scan spreadsheet by Cisco",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Jul 16, 2020 at 1:17 AM",
    "Subject": "Re: [PsySeg] Mjaor Issues for SDK",
    "IDs": "<320C3C86-B8A0-44D0-9D05-24D55506241D@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify privacy link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Jul 14, 2020, 5:45 PM",
    "Subject": "Follow up from Personify ChromaCam",
    "IDs": "<4C618634-3982-442E-9DA1-CD5418A94F11@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify's license terms",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Jul 14, 2020, 5:45 PM",
    "Subject": "Follow up from Personify ChromaCam",
    "IDs": "<4C618634-3982-442E-9DA1-CD5418A94F11@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Tax exemption certificate from UWF",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Jul 15, 2020 at 2:11 PM",
    "Subject": "Re: Follow up from Personify ChromaCam",
    "IDs": "<CAM33NQrQ=R1w__CXvgy8h_CJHtHp1HHvf68bJrAcDF2z1bz_3g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Salesforce table from Suzie",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Jun 30, 2020, 11:25 AM",
    "Subject": "RE: salesforce.com Invoice 17146575, Personify",
    "IDs": "<DM5PR08MB2956D94E22152286C7FFD2F48A6F0@DM5PR08MB2956.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Edited salesforce table from Suzie",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Tue, Jun 30, 2020, 11:30 AM",
    "Subject": "RE: salesforce.com Invoice 17146575, Personify",
    "IDs": "<DM5PR08MB295657FDCF0707FD3410D7C98A6F0@DM5PR08MB2956.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Salesforce licenses list by Suzie",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Jul 15, 2020, 10:41 AM",
    "Subject": "RE: salesforce.com Invoice 17146575, Personify",
    "IDs": "<DM5PR08MB29564F771C63BF028338E4F78A7E0@DM5PR08MB2956.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Images folder shared by Holly",
    "Entity": "Link",
    "Sub-type": "Google Folder",
    "Date and time": "Jul 14, 2020, 11:19 PM",
    "Subject": "Re: google smart ads",
    "IDs": "<8FB9679B-FBD4-4DE7-A5EE-C914771086CD@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Codes by Philip",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Mon, Jul 6, 2020 at 5:56 AM",
    "Subject": "Product Code",
    "IDs": "<00f701d65384$11f13fe0$35d3bfa0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Codes by Simon",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Mon, Jul 6, 2020 at 11:27 PM",
    "Subject": "Re: Product Code",
    "IDs": "<CALV-+1e6N6yMCw+oHTyy+z7fZvTesWrpt4BconaWUJHPMGEY2g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Pro overview shared by Long",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Jul 6, 2020, 11:24 AM",
    "Subject": "Fwd: Need some info of legacy Omni product",
    "IDs": "<CAL43u-VEczvC7hsf5OsF1KPZcAV5iGQ6Tjek9k5+s03J_eURew@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Screenshots linked by Long",
    "Entity": "Link",
    "Sub-type": "Google Slides",
    "Date and time": "Jul 6, 2020, 11:24 AM",
    "Subject": "Fwd: Need some info of legacy Omni product",
    "IDs": "<CAL43u-VEczvC7hsf5OsF1KPZcAV5iGQ6Tjek9k5+s03J_eURew@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Marketing posts for July 4th by Holly",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Thu, Jul 2, 2020 at 12:54 PM",
    "Subject": "Social Media ads - 7/4",
    "IDs": "<99E969C3-0F78-4D8F-B584-C506F756E7E6@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "On24 link sent by Jeremiah",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Jul 2, 2020, 1:07 PM",
    "Subject": "Re: Fw: Contact Form [ ref:_00DG0Cbyq._5001M1YG0P8:ref ]",
    "IDs": "<CAC=hQb=oCtKnOpyzR+pgoLT-HEguHTjfxmMFdYYWnrb=7Q3dCA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Video from Jeremiah",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Jul 2, 2020, 1:07 PM",
    "Subject": "Re: Fw: Contact Form [ ref:_00DG0Cbyq._5001M1YG0P8:ref ]",
    "IDs": "<CAC=hQb=oCtKnOpyzR+pgoLT-HEguHTjfxmMFdYYWnrb=7Q3dCA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Video sent to Cognizant",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wednesday, July 1, 2020 2:58 AM",
    "Subject": "Re: Fw: Contact Form [ ref:_00DG0Cbyq._5001M1YG0P8:ref ]",
    "IDs": "<CAC=hQb=oCtKnOpyzR+pgoLT-HEguHTjfxmMFdYYWnrb=7Q3dCA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Features walk-through by Jeremiah",
    "Entity": "File",
    "Sub-type": "Video",
    "Date and time": "Thursday, June 25, 2020 11:37 PM",
    "Subject": "Re: Fw: Contact Form [ ref:_00DG0Cbyq._5001M1YG0P8:ref ]",
    "IDs": "<CAC=hQb=oCtKnOpyzR+pgoLT-HEguHTjfxmMFdYYWnrb=7Q3dCA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Video about admin features",
    "Entity": "File",
    "Sub-type": "Video",
    "Date and time": "Thursday, June 25, 2020 11:37 PM",
    "Subject": "Re: Fw: Contact Form [ ref:_00DG0Cbyq._5001M1YG0P8:ref ]",
    "IDs": "<CAC=hQb=oCtKnOpyzR+pgoLT-HEguHTjfxmMFdYYWnrb=7Q3dCA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Risk management requirements from Charles",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Mon, Jun 29, 2020 at 10:46 AM",
    "Subject": "Re: Follow up from Personify Chromacam",
    "IDs": "<CAJKO6C4LqWtCJ_Aq63a5sqn86abL7iito2hkqMHRxOAcAK2tRg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Reseller agreement shared by Surendra",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Tue, Jun 30, 2020 at 11:21 AM",
    "Subject": "Re: Affiliate code monthly update",
    "IDs": "<21318752-1B35-4139-AEAC-B6BA7DDF9A84@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Reseller agreement sent to Holly",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Tue, Jun 30, 2020 at 11:21 AM",
    "Subject": "Re: Affiliate code monthly update",
    "IDs": "<21318752-1B35-4139-AEAC-B6BA7DDF9A84@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Affiliate agreement by Holly",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, Jun 30, 2020 at 2:09 PM",
    "Subject": "Re: Affiliate code monthly update",
    "IDs": "<1A2FD202-CC54-4445-ACFC-1E2A510C0320@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Affiliate agreement sent to Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, Jun 30, 2020 at 2:09 PM",
    "Subject": "Re: Affiliate code monthly update",
    "IDs": "<1A2FD202-CC54-4445-ACFC-1E2A510C0320@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Andrew's outreach log",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Jun 29, 2020 at 10:13 PM",
    "Subject": "Personify BD Dashboard and Outreach log",
    "IDs": "<CAEU0P5bSb=zu5Pjecwn_K=otpJZehBbikOXGt_Kzf1ubTTCM0w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Outreach log sent to Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, Jun 29, 2020 at 10:13 PM",
    "Subject": "Personify BD Dashboard and Outreach log",
    "IDs": "<CAEU0P5bSb=zu5Pjecwn_K=otpJZehBbikOXGt_Kzf1ubTTCM0w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "BD dashboard sent by Andrew",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Mon, Jun 29, 2020 at 10:13 PM",
    "Subject": "Personify BD Dashboard and Outreach log",
    "IDs": "<CAEU0P5bSb=zu5Pjecwn_K=otpJZehBbikOXGt_Kzf1ubTTCM0w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "BD dashboard sent by Andrew",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Mon, Jun 29, 2020 at 10:13 PM",
    "Subject": "Personify BD Dashboard and Outreach log",
    "IDs": "<CAEU0P5bSb=zu5Pjecwn_K=otpJZehBbikOXGt_Kzf1ubTTCM0w@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Expenses report by Andrew",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Jun 29, 2020, 4:55 PM",
    "Subject": "Personify: Q2 Expense Report",
    "IDs": "<CAEU0P5ZTF7v3Q29DD0AxeFS7ZMCm+t8Xn7=4RH=hACaaX7J0Vg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Expenses report sent to Dustin",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Jun 29, 2020, 4:55 PM",
    "Subject": "Personify: Q2 Expense Report",
    "IDs": "<CAEU0P5ZTF7v3Q29DD0AxeFS7ZMCm+t8Xn7=4RH=hACaaX7J0Vg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Webex subscriber list",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Mon, Jun 29, 2020 at 4:24 PM",
    "Subject": "Re: Invoice 2821 from DataCaptive Inc.",
    "IDs": "<CAEU0P5bxvJWD2t6EPwhGme-xbg3afGTC_NTh=d=-x5fZwFVY2g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Example of receipt sent by Long",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Thu, Jun 18, 2020 at 10:42 AM",
    "Subject": "회신: Schedule to launch KOR & JPN service",
    "IDs": "<01d401d64587$09313690$1b93a3b0$@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "June allocations from Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Fri, Jun 26, 2020, 4:16 PM",
    "Subject": "Team allocation",
    "IDs": "<9DE27BDA-6610-40D7-B38B-BAE3CE50D247@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "June allocations shared with Khoa",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Fri, Jun 26, 2020, 4:16 PM",
    "Subject": "Team allocation",
    "IDs": "<9DE27BDA-6610-40D7-B38B-BAE3CE50D247@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Mac specs for R&D",
    "Entity": "File",
    "Sub-type": "Google",
    "Date and time": "Wed, Jun 24, 2020, 2:18 AM",
    "Subject": "[R&D Resources] Request a new MAC machine for R&D development",
    "IDs": "<CAMovQvfmLvsehUArGOWVkKOpn6dWNcOpwuKRn_jOH1GkpJyEMA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Test results for Webex by Surendra",
    "Entity": "File",
    "Sub-type": "Google Docs",
    "Date and time": "Thu, Jun 25, 2020 at 3:45 PM",
    "Subject": "Re: [PsySeg Release] psy-seg-3.6.5-rc1 (with prelim test results)",
    "IDs": "<C52C9B8D-FE49-4DD7-AACA-D78369E4D93B@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Draft of Linkedin ad by Holly",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Jun 23, 2020, 2:48 PM",
    "Subject": "linkedin ads",
    "IDs": "<529151D3-A04C-4F39-ADBF-911DE5974944@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "QLM link sent by Surendra",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Tue, Jun 23, 2020 at 10:40 AM",
    "Subject": "Re: Vietnam sales opportunity",
    "IDs": "<E3C5EEF6-7C3F-45C4-868E-F12AAC9D44C8@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Pride ad by Holly",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Thu, Jun 18, 2020 at 6:52 PM",
    "Subject": "Facebook ads",
    "IDs": "<44D5F4CB-E99C-49A0-8F66-E2B1E943FA91@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "New support link by Surendra",
    "Entity": "Link",
    "Sub-type": "Support",
    "Date and time": "Wed, Jun 17, 2020 at 10:34 PM",
    "Subject": "Re: Personify account - read a Support article?",
    "IDs": "<CAKVuy5E7u_PDEN9HmX_uKRH1EZvDN0vV6DT3rWbTF+_b-YY4ug@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "New support url sent to Jim",
    "Entity": "Link",
    "Sub-type": "Support",
    "Date and time": "Wed, Jun 17, 2020 at 10:34 PM",
    "Subject": "Re: Personify account - read a Support article?",
    "IDs": "<CAKVuy5E7u_PDEN9HmX_uKRH1EZvDN0vV6DT3rWbTF+_b-YY4ug@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Member upload file sent to Melrose",
    "Entity": "File",
    "Sub-type": "Csv",
    "Date and time": "Fri, Jun 12, 2020 at 12:59 PM",
    "Subject": "Re: Contact Form [ ref:_00DG0Cbyq._5001M1YpRj8:ref ]",
    "IDs": "<CAN6k-eXwegsFurUbjMsZXqwA3xZQLodXmfdTXqEYx=mwHMOGUw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Personify member upload",
    "Entity": "File",
    "Sub-type": "Csv",
    "Date and time": "Fri, Jun 12, 2020 at 12:59 PM",
    "Subject": "Re: Contact Form [ ref:_00DG0Cbyq._5001M1YpRj8:ref ]",
    "IDs": "<CAN6k-eXwegsFurUbjMsZXqwA3xZQLodXmfdTXqEYx=mwHMOGUw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Keith's new password",
    "Entity": "Password",
    "Sub-type": "",
    "Date and time": "Tue, Jun 16, 2020, 10:42 PM",
    "Subject": "Fwd: reset account for me",
    "IDs": "<CAKVuy5E6WOcaaBNSZmYzk1UmVW+O8EStPoeHqbavjgJUwzR+iw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Webex guide by Jeremiah",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jun 11, 2020 at 12:21 AM",
    "Subject": "Re: Mayer Brown & Chromacam",
    "IDs": "<CAC=hQbnMC=1JYnbjzqX6xXDDRmbig+4Ym7=SengGNXHyM1YQSg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Chromacam guide by Jeremiah",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Jun 11, 2020 at 12:21 AM",
    "Subject": "Re: Mayer Brown & Chromacam",
    "IDs": "<CAC=hQbnMC=1JYnbjzqX6xXDDRmbig+4Ym7=SengGNXHyM1YQSg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Promo codes by Holly",
    "Entity": "Code",
    "Sub-type": "",
    "Date and time": "Mon, Jun 15, 2020, 1:34 PM",
    "Subject": "Promo codes for email marketing",
    "IDs": "<0F15EF38-A63E-46A9-8113-A7AE3F8B9DF9@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Marketing channel shared by Andrew",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Mon, Jun 15, 2020 at 4:14 PM",
    "Subject": "Re: Promo codes for email marketing",
    "IDs": "<CAEU0P5YJnf-unDoAuU_bTm1xgjrqJbwXEkT2q0yVOjTY64G5Xw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "David's cell",
    "Entity": "Phone number",
    "Sub-type": "",
    "Date and time": "Mon, Jun 15, 2020 at 2:44 PM",
    "Subject": "Re: Nice connecting",
    "IDs": "<0ACE90BF-1FEA-4390-B506-C3C13FCC43BB@pictureu.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Ads by Holly",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Fri, Jun 12, 2020 at 11:32 AM",
    "Subject": "Emails for WebEx",
    "IDs": "<CALV-+1d++qf+uKH=XCye+Ajk6b-87tROvJO1_27e5G2OSjgmfw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Study about limited offers shared by Andrew",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Fri, Jun 12, 2020 at 4:46 PM",
    "Subject": "Re: Emails for WebEx",
    "IDs": "<CAEU0P5aWEsyseTvbcjGiKFEKHO85+4mGdWU4ybwLPTtt+-Uk_g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Link for compliance report shared by Simon",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Fri, Jun 12, 2020 at 2:42 PM",
    "Subject": "SOC2 Compliance",
    "IDs": "<CALV-+1e-yYj7nP4_dRGm2WVz-QB_7mPAdt5YEiQYgHZhKQApqw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Compliance report link",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Fri, Jun 12, 2020 at 2:42 PM",
    "Subject": "SOC2 Compliance",
    "IDs": "<CALV-+1e-yYj7nP4_dRGm2WVz-QB_7mPAdt5YEiQYgHZhKQApqw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Whiteboard doc by Simon",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Jun 4, 2020 at 11:24 AM",
    "Subject": "Fwd: tech marketing material",
    "IDs": "<80B29A55-83D9-4B4C-BFB9-2C7F7E6B8942@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Revised white paper from Holly",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Wed, Jun 10, 2020 at 1:47 PM",
    "Subject": "Re: tech marketing material",
    "IDs": "<3FA54C97-0F20-42F1-9429-20C7DBBD3315@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "508 compliance link from Surendra",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, Jun 8, 2020 at 4:38 PM",
    "Subject": "508 compliance",
    "IDs": "<AC5F6E44-1574-49D3-B3B0-FC6208AFE5A7@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Marketing expenditures from Holly",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Mon, Jun 8, 2020 at 12:52 PM",
    "Subject": "Instagram & twitter expenditure for ChromaCam",
    "IDs": "<B08C768F-DF5C-4303-AFAD-D7A73236C754@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Expenditures sent to Surendra",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Mon, Jun 8, 2020 at 12:52 PM",
    "Subject": "Instagram & twitter expenditure for ChromaCam",
    "IDs": "<B08C768F-DF5C-4303-AFAD-D7A73236C754@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Zoom camera document by Long",
    "Entity": "Link",
    "Sub-type": "Google Docs",
    "Date and time": "Mon, Jun 8, 2020 at 10:50 AM",
    "Subject": "ChromaCam as Virtual Camera in Zoom Client - Invitation to edit",
    "IDs": "<000000000000c4c67f05a794935a@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Webex users list by Surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Fri, Jun 5, 2020 at 9:55 PM",
    "Subject": "Webex user list",
    "IDs": "<0ECB520D-FA13-4DAD-818B-06A8EC52B2C7@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Domains list by Diem",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Mon, Jun 8, 2020 at 6:21 AM",
    "Subject": "Re: Webex user list",
    "IDs": "<CAEZmYG0HM+jFeCZ8NZO7matwvsnG+t=g9stgsXd_FwKAxSEVdw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Domains table sent to Surendra",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Mon, Jun 8, 2020 at 6:21 AM",
    "Subject": "Re: Webex user list",
    "IDs": "<CAEZmYG0HM+jFeCZ8NZO7matwvsnG+t=g9stgsXd_FwKAxSEVdw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Webex users list sent by Andrew",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Thu, Jun 4, 2020 at 5:41 AM",
    "Subject": "Fwd: List procurement 99148",
    "IDs": "<CAEU0P5Z2MOct+ta+uvWKdNeBE_y_Apw_CHYGcE8RbrczipqBQA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Webex users list sent by Andrew",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Fri, Jun 5, 2020 at 1:19 AM",
    "Subject": "Re: List procurement 99148",
    "IDs": "<CAEU0P5acyf_7jE2Oz=O9oFVE_rQEH1Rrh6TJc-0_x0L4UYKdtg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Facebook posts by Holly",
    "Entity": "File",
    "Sub-type": "Picture",
    "Date and time": "Thu, Jun 4, 2020 at 4:43 PM",
    "Subject": "Social media advertising",
    "IDs": "<B402C6EE-B38A-4E40-B19A-437DD895CBEE@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Marketing plan sent by Holly",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Thu, Jun 4, 2020 at 4:07 PM",
    "Subject": "Marketing ppt",
    "IDs": "<CAP7yWZjZECXdoeO77sJH_RcW6-fNjNR0thEQrVuPfjiDsv8tWQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Marketing plan to Surendra",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Thu, Jun 4, 2020 at 4:07 PM",
    "Subject": "Marketing ppt",
    "IDs": "<CAP7yWZjZECXdoeO77sJH_RcW6-fNjNR0thEQrVuPfjiDsv8tWQ@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Marketing plan from Surendra",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Thu, Jun 4, 2020 at 5:11 PM",
    "Subject": "Fwd: Marketing ppt",
    "IDs": "<B059502F-EBE9-4BD4-86AE-26EBDD01F41A@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Unistall command for Chromacam",
    "Entity": "Command",
    "Sub-type": "",
    "Date and time": "Thu, Jun 4, 2020, 3:04 PM",
    "Subject": "RE: Terminal command for uninstall ChromaCam in Mac [ ref:_00DG0Cbyq._5001M1YpTDe:ref ]",
    "IDs": "<qMVat000000000000000000000000000000000000000000000QBF3S000GnpDCFlTQ3WeyImjELgRtA@sfdc.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Counterpath profile shared by Andrew",
    "Entity": "Link",
    "Sub-type": "Linkedin",
    "Date and time": "Thu, Jun 4, 2020, 2:49 PM",
    "Subject": "Fwd: Call Between CounterPath and Andrew Melnichenko of Personify (Chromacam)",
    "IDs": "<CAEU0P5bYUFy702FuUy0rPvd=_Cs0U9wtB1kiP1s6OfiVEuGcoA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Youtube collab shared by Holly",
    "Entity": "File",
    "Sub-type": "Video",
    "Date and time": "Thu, Jun 4, 2020 at 11:26 AM",
    "Subject": "Fwd: Personify Presentation",
    "IDs": "<48AC7039-CD09-4E24-B405-F448C9B6C005@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "GTM celebration costs by Long",
    "Entity": "Link",
    "Sub-type": "Google Sheets",
    "Date and time": "Wed, Jun 3, 2020 at 11:32 PM",
    "Subject": "Estimate cost for winning contract GTM celebration 2020 - Invitation to edit",
    "IDs": "<00000000000021412505a73aa31f@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "SOW by Long",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Wed, Jun 3, 2020 at 10:22 AM",
    "Subject": "Fwd: DIGI-TEXX | Quote for Labeling Server | Phase 2 | Personify",
    "IDs": "<CAL43u-W=4NJvsF7F7hPDrA92Y_ETCfk1oVzHwL7S1eLdH4pW2g@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Outreach log by Andrew",
    "Entity": "Link",
    "Sub-type": "Dropbox",
    "Date and time": "Mon, Jun 1, 2020 at 7:47 PM",
    "Subject": "Personify Outreach log",
    "IDs": "<CAEU0P5YLcyaiNT0oomtwfBOnWAEQ75mdHRA-d81Joen_0-DH4Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Outreach log sent to Surendra",
    "Entity": "Link",
    "Sub-type": "Dropbox",
    "Date and time": "Mon, Jun 1, 2020 at 7:47 PM",
    "Subject": "Personify Outreach log",
    "IDs": "<CAEU0P5YLcyaiNT0oomtwfBOnWAEQ75mdHRA-d81Joen_0-DH4Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Updated contact form from Simon",
    "Entity": "Link",
    "Sub-type": "Support",
    "Date and time": "Fri, May 29, 2020 at 2:27 PM",
    "Subject": "Contact Support Form Updated",
    "IDs": "<CALV-+1c_jQiNgZ2B_s90XiJVyXcr+MsfuLKMP3Tzz1+jxsvG1A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Inventory shared by Long",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Wed, May 27, 2020 at 7:05 PM",
    "Subject": "Inventory management - Invitation to edit",
    "IDs": "<00000000000071188705a6aa16f7@google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "May budget from Long",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Sat, May 23, 2020 at 10:56 AM",
    "Subject": "Extra budget buying machines and stuffs in May 2020",
    "IDs": "<CAL43u-V4ZsyGozp7-eEbCwSw4wbg01ZWwJip4S4RZ4ShRaJWDA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Extra may expenses sent to surendra",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Sat, May 23, 2020 at 10:56 AM",
    "Subject": "Extra budget buying machines and stuffs in May 2020",
    "IDs": "<CAL43u-V4ZsyGozp7-eEbCwSw4wbg01ZWwJip4S4RZ4ShRaJWDA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Webex user sample sent by Andrew",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Wed, May 20, 2020 at 4:51 PM",
    "Subject": "Fwd: WebEx Primary Commercial Account Owners List",
    "IDs": "<CAEU0P5YnVf65LJovPzyMaZ5H_rPHKN=UrX7eZRTbagKsf=n8Bw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Quote form sent by Dustin",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, May 18, 2020 at 10:59 AM",
    "Subject": "RE: quotation form",
    "IDs": "<5ec2b0f1.1c69fb81.796b8.46b0@mx.google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Quote template sent to Simon",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Mon, May 18, 2020 at 10:59 AM",
    "Subject": "RE: quotation form",
    "IDs": "<5ec2b0f1.1c69fb81.796b8.46b0@mx.google.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Chromacam requirements",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Thu, May 14, 2020 at 11:15 AM",
    "Subject": "Video audio and video lip sync out of phase [ ref:_00DG0Cbyq._5001M1YD3sI:ref ]",
    "IDs": "<zzbmz000000000000000000000000000000000000000000000QABX6200b9hzllZtTau8Vjyt9g9lqQ@sfdc.net>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Social media marketing plan from Holly",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Tue, May 12, 2020 at 3:33 PM",
    "Subject": "Social media marketing plan",
    "IDs": "<7B415E5C-570A-4BD1-96F8-8BA8BD02B145@personifyinc.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "New GPU suggested by Phong",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Tue, May 12, 2020 at 9:51 PM",
    "Subject": "Re: R&D Team Request",
    "IDs": "<CAL43u-WWHxwLSdoBAJcqYRuShdQ68dU2Z35z3x44JZt1x+6yTg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Proposal for Hitachi by Philip",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Mon, May 11, 2020, 8:13 PM",
    "Subject": "",
    "IDs": "<CA+ahe=h6dN19y8qp5SW1Qnz5C5BDiL-UEi0wZiFspGir611xbw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Database logs from Phien",
    "Entity": "Link",
    "Sub-type": "Cloud",
    "Date and time": "Mon, May 11, 2020 at 4:05 AM",
    "Subject": "Re: Jabber issue with Chromacam",
    "IDs": "<CAMBAEt6Cajz0=AZeqwwRzqSHEWfv=4EFDxdLgJ+O8Ub1hXnGUw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Google trends link from Simon",
    "Entity": "Link",
    "Sub-type": "",
    "Date and time": "Mon, May 11, 2020 at 12:41 AM",
    "Subject": "Google trends",
    "IDs": "<CALV-+1e_C5B39i43zH-fQZTy=GvFygo1t4aD2Y2SPwAi+DwMFg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Admin portal improvements by Andrew",
    "Entity": "Link",
    "Sub-type": "Dropbox",
    "Date and time": "Fri, May 8, 2020 at 7:04 AM",
    "Subject": "Admin Portal Proposal",
    "IDs": "<CAEU0P5bo04KG0a0Oau52rnX-h+T7mr91717jiNTAh9sW3VEfrA@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Instructions about Asia from Philip",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Fri, May 8, 2020 at 5:42 PM",
    "Subject": "ppt",
    "IDs": "<CA+ahe=g5aFKN+CxPVD01SzfpumYYT=t0p7=X6+1hNbdzBeswvw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Customer support guide by Long",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, May 7, 2020 at 10:01 AM",
    "Subject": "Re: US team for additional help to scale sales & support",
    "IDs": "<CAL43u-Um7NvZu2cXHDVm2=C+tgvupTSA8eh-nB-BSBggxkDCkw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Westan proposal from Philip",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Tue, May 5, 2020 at 6:57 AM",
    "Subject": "Re: connection",
    "IDs": "<CA+ahe=i=hKF1HEL7k7nkJWY6qWvBW8b8euRe2MmHyby7edSa+Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Updated Westan proposal",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Tue, May 5, 2020 at 7:58 PM",
    "Subject": "Re: connection",
    "IDs": "<CA+ahe=iWF7Q6W0t_pH_HMtxXHeXsnw0Q7ecgP_9eR8Yw_8jC4A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Final westan proposal",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Tue, May 5, 2020 at 7:58 PM",
    "Subject": "Re: connection",
    "IDs": "<CA+ahe=iWF7Q6W0t_pH_HMtxXHeXsnw0Q7ecgP_9eR8Yw_8jC4A@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Reported issues shared by Susan",
    "Entity": "Table",
    "Sub-type": "",
    "Date and time": "Mon, May 4, 2020 at 3:17 PM",
    "Subject": "RE: Support Cases Callback Study",
    "IDs": "<MWHPR0801MB38041C3B54E17DE9BB4575808AA60@MWHPR0801MB3804.namprd08.prod.outlook.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Facebook instructions from Loron",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Mon, May 4, 2020 at 3:39 PM",
    "Subject": "Re: Facebook video app",
    "IDs": "<CAF3aHr7_sRjJxQ6-+05RpjOezX5j+6Gg=qQUHvmqi6K4NTz4=Q@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Company introduction by Simon",
    "Entity": "File",
    "Sub-type": "PPT",
    "Date and time": "Fri, May 1, 2020 at 6:37 PM",
    "Subject": "Re: Company and Tech Info",
    "IDs": "<CALV-+1dT4xehSA=y8ODvYvUO50gnC_BpD7Ai2hFvB92-0bqXhg@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "CSA from Julie",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Apr 30, 2020 at 4:16 PM",
    "Subject": "Synopsys Black Duck Audits: Follow Up to Call & Next Steps",
    "IDs": "<E2316ABD-79BF-4EC7-BE03-632CD76514C7@contoso.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Scoping directions from Julie",
    "Entity": "File",
    "Sub-type": "Word",
    "Date and time": "Thu, Apr 30, 2020 at 4:16 PM",
    "Subject": "Synopsys Black Duck Audits: Follow Up to Call & Next Steps",
    "IDs": "<E2316ABD-79BF-4EC7-BE03-632CD76514C7@contoso.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Security document from Julie",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Apr 30, 2020 at 4:16 PM",
    "Subject": "Synopsys Black Duck Audits: Follow Up to Call & Next Steps",
    "IDs": "<E2316ABD-79BF-4EC7-BE03-632CD76514C7@contoso.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Sample summary by Julie",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Apr 30, 2020 at 4:16 PM",
    "Subject": "Synopsys Black Duck Audits: Follow Up to Call & Next Steps",
    "IDs": "<E2316ABD-79BF-4EC7-BE03-632CD76514C7@contoso.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Sample audit from Julie",
    "Entity": "File",
    "Sub-type": "Excel",
    "Date and time": "Thu, Apr 30, 2020 at 4:16 PM",
    "Subject": "Synopsys Black Duck Audits: Follow Up to Call & Next Steps",
    "IDs": "<E2316ABD-79BF-4EC7-BE03-632CD76514C7@contoso.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Signed CSA by Surendra",
    "Entity": "File",
    "Sub-type": "Pdf",
    "Date and time": "Thu, Apr 30, 2020 at 4:55 PM",
    "Subject": "Re: Synopsys Black Duck Audits: Follow Up to Call & Next Steps",
    "IDs": "<C13EE742-5F24-44EF-8216-F3FEA33AD632@synopsys.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  },
  {
    "Query": "Slack channel by Simon",
    "Entity": "Link",
    "Sub-type": "Slack",
    "Date and time": "Tue, Apr 28, 2020, 1:59 AM",
    "Subject": "Re: Technical Deep Dive Meeting on Authentication topics",
    "IDs": "<CALV-+1fn7oeXAXq+s9KhuH-3Z91ha_fT2Vk9Lw7Bo5oc5VHyVw@mail.gmail.com>",
    "Channel": "",
    "Platform": "Outlook",
    "Accounts": "trovatest@outlook.com",
    "Login-email": "trova.testuser3@gmail.com; trova.testuser6@gmail.com; trova.testuser8@gmail.com; trova.testuser11@gmail.com; trova.testuser12@gmail.com"
  }
];

export default testQueries;